// LawPay dashboard refunds/voids: payment detail shows status_label (Refunded, Partially refunded) and each refund's invoice (invoices or reverses), with date falling back to refund_date. Missing fields keep the previous badge and a dash. Delivered 2026-11-01.
// pkg195 — payment method 'unknown' displays as Unknown (label map only; it is not a choice when recording a payment) — delivered 2026-10-31
// pkg198 — Billing → Plans & Autopay (saved-method status, payment plan setup for an owner or attorney, retainer replenishment) — delivered 2026-11-01
// Owner refund on the payment row and in the payment detail: amount defaults to the refundable remainder, reason required, confirm before POST /api/payments/:id/refund { amount, reason }. Refunds show Pending / Completed / Failed. A manual payment says it is not sent to LawPay. Delivered 2026-11-01.
// pkg193 — Billing → Payments gains an Account column (Operating / Trust badge, dash if deposit_account is missing) and an All / Operating / Trust filter. The filter calls GET /api/payments/client/:id?deposit_account= and still narrows locally; the full ledger stays loaded for trust-pending and counts — delivered 2026-10-31
// pkg185 — Time tab owns billing eligibility (D-185a/b/c): every firm member bills unless excluded; "Who can bill" strip on the Time tab replaces the Billing → Team & Rates sub-tab (Exclude / Restore / ★ Default / Edit Rates; Billing Summary moved along); Billed By pre-selects the effective default biller; the "no team" gate is gone — delivered 2026-10-30
// pkg173a — Request Retainer via LawPay also on the Billing tab header; Trust tab shows pending LawPay deposits not yet settled; Del hidden on LawPay-sourced trust rows (reversals arrive from LawPay, never by hand) — delivered 2026-10-03
// pkg172a — "Request Retainer via LawPay" button in the Billing tab action row (LawPayLinkButton, trust page) — delivered 2026-10-03
// pkg166 — Opposing Counsel (Certificate of Service) is a multi-line textarea; lines render one-per-line in the To: block and the COS (backend already split on newlines) — delivered 2026-08-30
// pkg127 — Client-Submitted Forms panel: Email-to-Me replaced by the shared ModuleSendControl (download + multi-select staff email on EVERY module — budget gains the filled-workbook download, witnesses a plain .docx, asset ledger becomes emailable); sendEmail/sendingEmail retired — delivered 2026-07-27
// pkg125b — Modules tab gains the Open Client Modules button (same launcher as the Overview Form Activity header) — delivered 2026-07-27
// pkg125a — Overview Form Activity rebuilt: one clickable tile per ASSIGNED built-in module (status from the clientData buckets), each opening the Client Modules workspace on that module via ?m= deep link; replaces the hardcoded Divorce-Certificate/Parenting-Plan pair — delivered 2026-07-27
// pkg125 — Client's View tab gains the Client Modules workspace launcher card (opens /admin/clients/:id/modules — the D-124c admin-mode module tabs + pleading generation surface) — delivered 2026-07-27
// pkg97 — ™ added to the MightyAnalyzer launch button (Ryan's screenshot catch): the button is the mark's only — therefore most prominent — use on this surface, so it carries the ™ per the naming rule; plain-English tail unchanged; pkg83a untouched — delivered 2026-07-18
// pkg91a — MightyAnalyzer rename on the launch button (with “analyze a production” tail so the action is self-explanatory) + work-product pointer; MightyDigest card gains ™; supersedes the pkg91 strings — delivered 2026-07-18
// pkg91 — MightyDiscovery / MightyDigest rename (UI chrome ONLY): launch button, work-product pointer line, and the case-summary card header rebranded; descriptive copy, billing labels, and archived work-product label map untouched (pkg83a absolute — no branding reaches served/filed documents) — delivered 2026-07-18
// pkg81 — ✦ Discovery Analysis launch button (D-81a) + the work-product viewer renders archived discovery_analysis reports (overview + item counts) — delivered 2026-07-14
// pkg80 — the work-product viewer renders 'discovery_draft' archives (the pkg77 rider): numbered interrogatories + RFPs exactly as billed — delivered 2026-07-14
// pkg77 — digest card is collapsible and collapsed by default when a digest exists (header shows date + flag count, D-77a); billing receipt on every digest run (billed → archived / firm paid, D-77b); Billing-tab AI expense rows with an archived snapshot get "✦ View work product" opening an inline panel — every charged dollar has its document attached (D-77c/d) — delivered 2026-07-13
// pkg76 — "✦ AI case summary" card under the page header (CaseDigestCard): cross-module digest stored on the client — viewing free, Generate/Re-run 1 credit with the D-75h bill-to-client option; sources line states exactly what was read (D-76a/b/c/d) — delivered 2026-07-13
// pkg75 — header gains "✦ Draft Correspondence" (launches the new per-client AI drafting page, D-75a) — delivered 2026-07-13
// pkg72b — teal CTA button(s) #1a7a5e → NAVY #1E2761; semantic status dots/greens kept — delivered 2026-07-12
// pkg72a — green→navy conversion: decorative dark-green surfaces (#1a3a2a/#2a5a4a — banner gradients, featured borders, buttons, toggles, tabs) become NAVY_DEEP #0F1838 → NAVY #1E2761; SEMANTIC greens kept (status/success badges, category chip triads, ✓ text); selected-module card converts as a pair (navy border + pale-navy #F0F2F8 tint) — delivered 2026-07-12
// pkg72 — LawMighty retheme: brand hex sweep (#1a1a1a→#0F1838 NAVY_DEEP, #0f0f0f→#0A1028, #f8f8f8→#F5F1E8 CREAM, #c0392b→#B85042 TERRA) — delivered 2026-07-12
// pkg69 — profile save reads modules_seeded from the PATCH response (D-69a backend cascade): refreshes the Modules tab data and says how many template modules were added, so a case-type change visibly takes effect without a reload — delivered 2026-07-12
// pkg68a — case-type selection becomes a Practice Area → Case Type cascade on the Profile tab AND the Apply-Template picker: turnkey seeding (pkg67b) made the flat all-types dropdown unusable at scale; the area select lists only areas that actually have case types, the type select shows only that area's types; practice area is derived from the case type, never persisted on the client — delivered 2026-07-12
// pkg67b — profile save sends case_type verbatim so the empty option actually clears it (Bug B: `|| null` + backend COALESCE made clearing impossible); dropdown empty option relabeled "— No case type —" (D-67b7) — delivered 2026-07-12
// pkg67 — Client-Submitted Forms panel driven by the client's actual module assignments (clientModules, server-filtered by jurisdiction + practice area + firm module choice) instead of the hardcoded six-form array; labels from the module catalog; empty panel hides entirely (D-67m) — delivered 2026-07-12
// pkg51 — wheel-scroll can no longer change a number input's value (a scroll notch = one $0.01 step was how $300.00 became $299.98): every type="number" input blurs on wheel — delivered 2026-07-09
// pkg49 — rate precedence flip (D-52a): team cards show override > CLIENT's rate > biller default (matches billing.js rateMap) — delivered 2026-07-09
// pkg23 — Divorce Certificate: rename demographic labels + download button (filled PH-1682 PDF) — delivered 2026-06-12
// pkg29 — Asset & Debt List: firm-side row in Client-Submitted Forms with Word (.docx) download (no email dependency)
// pkg21b — tab restructure: Time promoted to main tab; Billing sub-tabs replace collapsible sections; Discovery permanent tab with generator; Case renamed Client's View — delivered 2026-06-11
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { adminApi } from '../utils/adminApi';
import ModuleSendControl from '../components/ModuleSendControl'; // pkg127
import LawPayLinkButton from '../components/LawPayLinkButton'; // pkg172a
import ClientPaymentPlansPanel from '../components/ClientPaymentPlansPanel'; // pkg198
import RefundPaymentModal, { paymentCanBeRefunded, RefundStatusBadge } from '../components/RefundPaymentModal';
import { listRefunds, paymentStatusLabel, paymentStatusTone, refundAmount, refundInvoiceText, refundWhen } from '../utils/paymentRefundDisplay';
import { firmDateYmd, firmTodayYmd, formatFirmDate } from '../utils/firmDate';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { useFirmSettings } from '../contexts/FirmSettingsContext';
import ConflictChecksPanel from '../components/ConflictChecksPanel';


// ── Constants ────────────────────────────────────────────────────────────────

const EXPENSE_CATEGORIES = [
'Filing Fee', 'Court Costs', 'Process Server', 'Postage', 'Copies',
'Deposition', 'Expert Witness', 'Mediator', 'Travel', 'Other'];


const INV_STATUS_STYLES = {
  draft: { bg: '#fdf6e3', fg: '#b7870a', border: '#f0d68a', label: 'Draft' },
  issued: { bg: '#e8f0fb', fg: '#2f5496', border: '#bcd4ee', label: 'Issued' },
  partial: { bg: '#fdf2e7', fg: '#d68910', border: '#f5c98e', label: 'Partial' },
  paid: { bg: '#e8f7ef', fg: '#1a7a5e', border: '#b8e3cf', label: 'Paid' },
  voided: { bg: '#f0f0f0', fg: '#888', border: '#dcdcdc', label: 'Voided' }
};

// Phase 2: payment status styling
const PAY_STATUS_STYLES = {
  cleared: { bg: '#e8f7ef', fg: '#1a7a5e', border: '#b8e3cf', label: 'Cleared' },
  pending: { bg: '#fdf6e3', fg: '#b7870a', border: '#f0d68a', label: 'Pending' },
  reversed: { bg: '#fdf0ec', fg: '#B85042', border: '#f5c6c3', label: 'Reversed' },
  refunded: { bg: '#f0f0f0', fg: '#888', border: '#dcdcdc', label: 'Refunded' },
  partial: { bg: '#e8f1fb', fg: '#1c4e80', border: '#bcd4ee', label: 'Partially refunded' },
  failed: { bg: '#fdf0ec', fg: '#B85042', border: '#f5c6c3', label: 'Failed' },
  // Wave 2: soft-void state. Same gray treatment as refunded but with a more
  // explicit label so admins know the row was deleted, not just refunded.
  voided:   { bg: '#f3f3f3', fg: '#666', border: '#d6d6d6', label: 'Voided (Deleted)' },
};

// Phase 2: payment methods + labels (must mirror VALID_METHODS in backend payments.js)
const PAYMENT_METHODS = [
{ value: 'check', label: 'Check', refLabel: 'Check #' },
{ value: 'cash', label: 'Cash', refLabel: 'Receipt #' },
{ value: 'ach', label: 'ACH / eCheck', refLabel: 'Trace #' },
{ value: 'wire', label: 'Wire Transfer', refLabel: 'Wire ref' },
{ value: 'credit_card', label: 'Credit Card', refLabel: 'Auth code' },
{ value: 'money_order', label: 'Money Order', refLabel: 'MO #' },
{ value: 'trust_transfer', label: 'Trust Transfer', refLabel: 'Reference' },
{ value: 'other', label: 'Other', refLabel: 'Reference' }];

const METHOD_LABELS = Object.fromEntries(PAYMENT_METHODS.map((m) => [m.value, m.label]));
METHOD_LABELS.unknown = 'Unknown'; // pkg195
const METHOD_REF_LABELS = Object.fromEntries(PAYMENT_METHODS.map((m) => [m.value, m.refLabel]));

const DEPOSIT_ACCOUNTS = [
{ value: 'operating', label: 'Operating Account' },
{ value: 'trust', label: 'Trust (IOLTA)' }];


// pkg21b: every tab is always present (Discovery is no longer conditional;
// Time is promoted out of Billing). Keys are stable for ?tab= URL compat —
// 'case' renders as "Client's View", 'conflicts' as "Conflict Check".
const TABS = [
{ key: 'overview', label: 'Overview' },
{ key: 'time', label: 'Time' },
{ key: 'billing', label: 'Billing' },
{ key: 'trust', label: 'Trust' },
{ key: 'discovery', label: 'Discovery' },
{ key: 'modules', label: 'Modules' },
{ key: 'conflicts', label: 'Conflict Check' },
{ key: 'case', label: "Client's View" },
{ key: 'profile', label: 'Profile' }];


const MOBILE_STYLES = `
.client-detail-tabs {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border-bottom: 2px solid #eee;
  margin-bottom: 20px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 5;
}
.client-detail-tabs::-webkit-scrollbar { display: none; }
.client-detail-tabs button {
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 14px 18px;
  margin-bottom: -2px;
  font-size: 14px;
  font-family: Arial, sans-serif;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.15s, border-color 0.15s;
}
.client-detail-tabs button:hover { color: #0F1838; }
.client-detail-tabs button.active {
  color: #0F1838;
  border-bottom-color: #0F1838;
  font-weight: 600;
}

.client-detail-page .danger-zone {
  border: 1px solid #f5c6c3;
  background: #fdf7f6;
  border-radius: 6px;
  padding: 16px;
  margin-top: 24px;
}

.snapshot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.snapshot-card {
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 14px;
}
.snapshot-card .label {
  font-size: 11px;
  color: #888;
  font-family: Arial, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}
.snapshot-card .value {
  font-size: 22px;
  font-weight: 600;
  font-family: Arial, sans-serif;
  color: #0F1838;
}
.snapshot-card .sub {
  font-size: 12px;
  color: #666;
  font-family: Arial, sans-serif;
  margin-top: 4px;
}

@media (max-width: 600px) {
  .client-detail-page .summary-grid-2 {
    grid-template-columns: 1fr !important;
  }
  .client-detail-page .form-row {
    flex-direction: column;
  }
  .client-detail-page .form-row .form-group {
    flex: 1 1 auto !important;
    width: 100%;
    min-width: 0;
  }
  .client-detail-tabs button {
    padding: 14px 14px;
    font-size: 13px;
  }
}
`;

// ── Helpers ───────────────────────────────────────────────────────────────────

function InvStatusBadge({ status }) {
  const s = INV_STATUS_STYLES[status] || INV_STATUS_STYLES.draft;
  return (
    <span style={{
      fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 3,
      background: s.bg, color: s.fg, border: `1px solid ${s.border}`,
      fontFamily: 'Arial, sans-serif', display: 'inline-block', whiteSpace: 'nowrap'
    }}>{s.label}</span>);

}

// Phase 2: badge for payment status
function PayStatusBadge({ status, label }) {
  const text = (label && String(label).trim()) || '';
  const tone = text ? paymentStatusTone(text, status) : status;
  const s = PAY_STATUS_STYLES[tone] || PAY_STATUS_STYLES.cleared;
  return (
    <span style={{
      fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 3,
      background: s.bg, color: s.fg, border: `1px solid ${s.border}`,
      fontFamily: 'Arial, sans-serif', display: 'inline-block', whiteSpace: 'nowrap'
    }}>{text || s.label}</span>);

}

function methodLabel(m) {
  return METHOD_LABELS[m] || m || 'Unknown';
}

function AccountBadge({ account }) {
  const base = {
    fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 3,
    fontFamily: 'Arial, sans-serif', display: 'inline-block', whiteSpace: 'nowrap'
  };
  if (account === 'operating') {
    return <span style={{ ...base, background: '#e8f0fb', color: '#2f5496', border: '1px solid #bcd4ee' }}>Operating</span>;
  }
  if (account === 'trust') {
    return <span style={{ ...base, background: '#fdf6e3', color: '#b7870a', border: '1px solid #f0d68a' }} title="Deposited to trust account">Trust</span>;
  }
  return <span style={{ color: '#ccc' }}>—</span>;
}

function fmtMoneyShort(n) {
  return '$' + (parseFloat(n) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function fmtIsoDate(s) {
  return formatFirmDate(s);
}

// Format a TIME column value as 12-hour with AM/PM, e.g. "10:00 AM".
// Returns null if t is empty/invalid. Accepts "HH:MM" or "HH:MM:SS".
function fmtTime12(t) {
  if (!t) return null;
  const m = /^(\d{2}):(\d{2})/.exec(String(t));
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = m[2];
  const period = h >= 12 ? 'PM' : 'AM';
  h = h % 12;if (h === 0) h = 12;
  return `${h}:${min} ${period}`;
}

// Format a start/end time pair as a single string. Returns "" if no times.
function fmtTimeRange(start, end) {
  const s = fmtTime12(start);
  const e = fmtTime12(end);
  if (!s) return '';
  if (!e || e === s) return s;
  return `${s} – ${e}`;
}

function daysFromNow(isoDate) {
  if (!isoDate) return null;
  const d = new Date(isoDate);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}

function roleLabel(role) {
  if (!role) return 'Staff';
  return role.charAt(0).toUpperCase() + role.slice(1);
}

// ─── Closed-case banner ─────────────────────────────────────────────────────
// Read-only status indicator rendered above the tabs whenever a client is
// in 'closed' or 'settled'. Mirrors the 6-month portal window logic in
// routes/auth.js so the user knows up front whether the client can still
// log in. Action buttons live on the Profile tab — this banner just shows
// state and a shortcut to get there.
function ClosedCaseBanner({ status, closedAt, settledAt, onGoToProfile }) {
  const SIX_MONTHS_MS = 1000 * 60 * 60 * 24 * 183;
  let accessNote = null;
  if (closedAt) {
    const closed = new Date(closedAt).getTime();
    if (Number.isFinite(closed)) {
      const remainingMs = SIX_MONTHS_MS - (Date.now() - closed);
      if (remainingMs <= 0) {
        accessNote = { expired: true, label: 'Client portal access has expired.' };
      } else {
        const days = Math.ceil(remainingMs / (1000 * 60 * 60 * 24));
        accessNote = { expired: false, label: `Client portal access expires in ${days} day${days !== 1 ? 's' : ''}.` };
      }
    }
  }
  const isSettled = status === 'settled';
  const fmt = (s) => {
    if (!s) return '—';
    const d = new Date(s);
    return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };
  return (
    <div style={{
      border: '1px solid', borderColor: isSettled ? '#dcdcdc' : '#f5c98e',
      background: isSettled ? '#f5f5f5' : '#fdf2e7',
      color: isSettled ? '#555' : '#7a5800',
      borderRadius: 6, padding: '12px 16px', marginBottom: 16,
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap'
    }}>
      <div style={{ fontSize: 20, lineHeight: 1 }}>🗂️</div>
      <div style={{ flex: 1, minWidth: 240, fontFamily: 'Arial, sans-serif', fontSize: 13 }}>
        <strong style={{ fontSize: 14 }}>
          {isSettled ? 'This case is settled.' : 'This case is closed.'}
        </strong>
        <div style={{ fontSize: 12, marginTop: 4 }}>
          Closed on <strong>{fmt(closedAt)}</strong>
          {isSettled && settledAt && <> &middot; Settled on <strong>{fmt(settledAt)}</strong></>}
          {accessNote &&
          <> &middot; <span style={{ color: accessNote.expired ? '#B85042' : 'inherit' }}>{accessNote.label}</span></>
          }
        </div>
        <div style={{ fontSize: 12, marginTop: 4, color: isSettled ? '#777' : '#946100' }}>
          {isSettled ?
          'This case is fully wrapped up. The billing tab is read-only. Reopen the case from the Profile tab to make changes.' :
          'Case work is complete; outstanding invoices can still be sent and paid. Reopen or mark as settled from the Profile tab.'}
        </div>
      </div>
      <button className="btn btn-sm" onClick={onGoToProfile} style={{ flexShrink: 0 }}>
        Manage Status
      </button>
    </div>);

}

// ─────────────────────────────────────────────────────────────────────────────
// Main component
// ─────────────────────────────────────────────────────────────────────────────

// pkg33 — Ethical wall control (owner-only). Self-contained: fetches the
// staff roster + block status for this client and lets the owner toggle each
// person's access. Blocking is immediate and also drops the person from the
// billing team (enforced server-side). The firm owner is never blockable.
// Renders nothing for non-owners (the backend also owner-gates the endpoints).
function AccessRestrictionsPanel({ clientId, clientName }) {
  const [role, setRole] = useState(null);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [reasonDrafts, setReasonDrafts] = useState({});
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const perms = await adminApi.getMyPermissions();
        const r = perms && perms.role ? perms.role : null;
        if (!alive) return;
        setRole(r);
        if (r === 'owner' || (perms && perms.isMasterKey)) {
          const data = await adminApi.getClientBlocks(clientId);
          if (!alive) return;
          setStaff((data && data.staff) || []);
        }
      } catch (e) {
        if (alive) setErr('Could not load access restrictions.');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [clientId]);

  if (loading) {
    return (
      <>
        <div className="section-head">Access Restrictions (Ethical Wall)</div>
        <div className="card">
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#777' }}>Loading…</div>
        </div>
      </>
    );
  }
  if (role !== 'owner') return null; // owner-only control

  async function reload() {
    const data = await adminApi.getClientBlocks(clientId);
    setStaff((data && data.staff) || []);
  }

  async function onToggle(u) {
    setBusyId(u.id);
    setErr('');
    try {
      if (u.blocked) {
        await adminApi.unblockClientUser(clientId, u.id);
      } else {
        await adminApi.blockClientUser(clientId, u.id, (reasonDrafts[u.id] || '').trim());
      }
      await reload();
      setReasonDrafts((d) => ({ ...d, [u.id]: '' }));
    } catch (e) {
      setErr(e && e.message ? e.message : 'Action failed.');
    } finally {
      setBusyId(null);
    }
  }

  const blockedCount = staff.filter((u) => u.blocked).length;

  return (
    <>
      <div className="section-head">Access Restrictions (Ethical Wall)</div>
      <div className="card">
        <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 14 }}>
          Block specific staff from seeing or contacting <strong>{clientName || 'this client'}</strong> — for example,
          someone who previously worked at a firm representing the opposing party. A blocked person can't open this
          client, see them in any list, download their documents, or send them any correspondence (mass email
          included). Blocking also removes them from this client's billing team. Changes take effect immediately.
          The firm owner can't be blocked.
        </p>

        {err &&
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#B85042', marginBottom: 12 }}>{err}</div>}

        {blockedCount > 0 &&
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#b7530a', background: '#fdf2e7', border: '1px solid #f5c98e', borderRadius: 6, padding: '8px 10px', marginBottom: 12 }}>
            {blockedCount} {blockedCount === 1 ? 'person is' : 'people are'} currently walled off from this client.
          </div>}

        <div>
          {staff.map((u) => (
            <div key={u.id} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '10px 0', borderTop: '1px solid #eee', flexWrap: 'wrap' }}>
              <div style={{ minWidth: 160 }}>
                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 14, color: '#222' }}>{u.display_name || u.name}</div>
                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#888', textTransform: 'capitalize' }}>{u.role}</div>
                {u.blocked && u.reason &&
                  <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#a35', marginTop: 3, fontStyle: 'italic' }}>Reason: {u.reason}</div>}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end', flex: 1 }}>
                {!u.blockable ? (
                  <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#1a7a5e', background: '#e8f7ef', border: '1px solid #b8e3cf', borderRadius: 12, padding: '3px 10px' }}>Always allowed</span>
                ) : u.blocked ? (
                  <>
                    <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#B85042', background: '#fdf0ec', border: '1px solid #f5c6c3', borderRadius: 12, padding: '3px 10px' }}>Blocked</span>
                    <button type="button" className="btn btn-sm" disabled={busyId === u.id} onClick={() => onToggle(u)}>
                      {busyId === u.id ? '…' : 'Allow access'}
                    </button>
                  </>
                ) : (
                  <>
                    <input type="text" value={reasonDrafts[u.id] || ''} maxLength={500}
                      onChange={(e) => setReasonDrafts((d) => ({ ...d, [u.id]: e.target.value }))}
                      placeholder="Reason (optional)"
                      style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, padding: '5px 8px', border: '1px solid #ccc', borderRadius: 4, minWidth: 180 }} />
                    <button type="button" className="btn btn-sm" disabled={busyId === u.id} onClick={() => onToggle(u)}
                      style={{ background: '#B85042', borderColor: '#B85042', color: '#fff' }}>
                      {busyId === u.id ? '…' : 'Block'}
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
          {staff.length === 0 &&
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#777', paddingTop: 8 }}>No staff members found.</div>}
        </div>
      </div>
    </>
  );
}

// pkg76 — self-contained so the main component only renders one line.
// pkg77 (D-77a) — collapsible: collapsed by default when a digest exists; the
// header carries the date + flag count so the card earns its screen space
// without spending it. Generating (or re-running) expands the fresh result.
function CaseDigestCard({ clientId, clientName }) {
  const [digest, setDigest]     = useState(null);
  const [digestAt, setDigestAt] = useState(null);
  const [open, setOpen]         = useState(false);   // confirm row
  const [expanded, setExpanded] = useState(false);   // pkg77 — digest body visibility
  const [busy, setBusy]         = useState(false);
  const [err, setErr]           = useState('');
  const [note, setNote]         = useState('');
  const [bill, setBill]         = useState(false);
  const [billAmt, setBillAmt]   = useState('1.00');

  useEffect(() => {
    adminApi.getClientCaseDigest(clientId)
      .then(r => {
        setDigest(r.ai_case_digest || null); setDigestAt(r.ai_case_digest_at || null);
        setExpanded(false); // pkg77 (D-77a) — an existing digest loads collapsed
      })
      .catch(() => {}); // card is additive — a read failure just shows the generate row
  }, [clientId]);

  async function generate() {
    setBusy(true); setErr(''); setNote('');
    try {
      const body = bill
        ? { bill_to_client: { enabled: true, amount_cents: Math.round(parseFloat(billAmt || '1') * 100) } }
        : {};
      const r = await adminApi.generateClientCaseDigest(clientId, body);
      setDigest(r.ai_case_digest); setDigestAt(r.ai_case_digest_at); setOpen(false);
      setExpanded(true); // pkg77 — a fresh run always shows its result
      // pkg77 (D-77b) — every run's result carries a billing receipt.
      if (r.bill_requested && r.billed) setNote(`Billed $${r.billed.amount.toFixed(2)} to ${clientName} as an expense — this digest is archived to their Billing tab.`);
      else if (r.bill_requested && !r.billed) setNote('Digest generated, but the client charge did not record — add the expense manually from the Billing tab.');
      else setNote('Firm paid — 1 credit used, nothing billed to the client.');
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  const flagCount = digest && Array.isArray(digest.flags) ? digest.flags.length : 0;

  const confirmRow = (
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', fontSize: 13, marginTop: 8 }}>
      <span style={{ color: '#555' }}>Uses <strong>1 AI credit</strong> — only if it succeeds.</span>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
        title="Adds a billable expense to this client — it will appear on their next invoice.">
        <input type="checkbox" checked={bill} onChange={e => setBill(e.target.checked)} />
        Bill to {clientName} as an expense · $
        <input type="text" value={billAmt} disabled={!bill}
          onChange={e => setBillAmt(e.target.value.replace(/[^0-9.]/g, ''))}
          style={{ width: 52, padding: '3px 6px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }} />
      </label>
      <button className="btn btn-primary btn-sm" disabled={busy} onClick={generate}>
        {busy ? 'Generating…' : 'Generate'}
      </button>
      <button className="btn btn-sm" disabled={busy} onClick={() => setOpen(false)}>Cancel</button>
    </div>
  );

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <strong style={{ fontSize: 14 }}>✦ MightyDigest™ — AI case summary</strong>
        {digest && !open && (
          <span style={{ fontSize: 11, color: '#888' }}>
            generated {digestAt ? new Date(digestAt).toLocaleString() : '—'}
            {/* pkg77 (D-77a) — the collapsed header carries the flag count */}
            {' · '}{flagCount === 0 ? 'no flags' : `${flagCount} flag${flagCount === 1 ? '' : 's'}`}
            {' · viewing is free'}
            &nbsp;<button className="btn btn-sm" style={{ padding: '2px 10px', fontSize: 11 }}
              onClick={() => setExpanded(x => !x)}>
              {expanded ? 'Collapse' : 'Expand'}
            </button>
            &nbsp;<button className="btn btn-sm" style={{ padding: '2px 10px', fontSize: 11 }} onClick={() => { setOpen(true); setBill(false); setBillAmt('1.00'); }}>Re-run · 1 credit</button>
          </span>
        )}
      </div>
      {err  && <div style={{ fontSize: 12, color: '#a02020', marginTop: 6 }}>{err}</div>}
      {note && <div style={{ fontSize: 12, color: '#1E2761', marginTop: 6 }}>{note}</div>}
      {!digest && !open && (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 8 }}>
          <span style={{ fontSize: 13, color: '#555' }}>
            One AI digest of everything this client has entered — budget, assets & debts, parenting plan, discovery answers, and submitted documents — with cross-module inconsistencies flagged.
          </span>
          <button className="btn btn-sm" style={{ border: '1px solid #1E2761', color: '#1E2761' }}
            onClick={() => { setOpen(true); setBill(false); setBillAmt('1.00'); }}>
            ✦ Generate · 1 credit
          </button>
        </div>
      )}
      {open && confirmRow}
      {digest && expanded && ( /* pkg77 (D-77a) — body renders only when expanded */
        <div style={{ marginTop: 8 }}>
          {Array.isArray(digest.sources) && digest.sources.length > 0 && (
            <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Based on: {digest.sources.join(', ')}</div>
          )}
          <div style={{ fontSize: 13, color: '#333', lineHeight: 1.55 }}>{digest.digest}</div>
          {Array.isArray(digest.flags) && digest.flags.length > 0 && (
            <div style={{ marginTop: 8, borderTop: '1px solid #e4e9f0', paddingTop: 8 }}>
              {digest.flags.map((fl, i) => (
                <div key={i} style={{ fontSize: 12, color: '#444', marginTop: i ? 4 : 0 }}>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 9,
                    background: '#fdf6e6', color: '#7c5200', border: '1px solid #7c520033',
                    marginRight: 8, textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                    {fl.type === 'incomplete' ? 'Incomplete' : 'Inconsistent'}
                  </span>
                  {fl.text}
                </div>
              ))}
            </div>
          )}
          <div style={{ fontSize: 10, color: '#aab', marginTop: 8 }}>
            AI-generated from the client's module entries — verify against the source modules before relying on it.
          </div>
        </div>
      )}
    </div>
  );
}

// pkg77 (D-77d) — renders an archived AI work product by kind. Digest-shaped
// kinds (case digest, submission summary) show digest + flags; correspondence
// shows the letter text. Shared by the Billing tab's inline viewer.
const WP_KIND_LABELS = {
  case_digest:        'AI case digest',
  submission_summary: 'AI submission summary',
  correspondence:     'AI correspondence draft',
  discovery_draft:    'AI discovery draft', // pkg80 — the pkg77 rider
  discovery_analysis: 'AI discovery analysis report', // pkg81
};
function AiWorkProductBody({ wp }) {
  const c = wp.content || {};
  return (
    <div>
      <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>
        {WP_KIND_LABELS[wp.kind] || 'AI work product'}
        {c.module_label ? ` · ${c.module_label}` : ''}
        {c.recipient_type ? ` · to ${String(c.recipient_type).replace(/_/g, ' ')}` : ''}
        {' · archived '}{wp.created_at ? new Date(wp.created_at).toLocaleString() : '—'}
        {' — the exact version billed; later re-runs never change it'}
      </div>
      {wp.kind === 'discovery_analysis' ? (
        /* pkg81 — the billed report's overview + item counts; the full Word
           document lives on the client's Discovery Analysis page. */
        <div>
          <div style={{ fontSize: 13, color: '#333', lineHeight: 1.55 }}>{c.overview || '—'}</div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
            {[
              Array.isArray(c.income_items) && `${c.income_items.length} income item${c.income_items.length === 1 ? '' : 's'}`,
              Array.isArray(c.expense_items) && `${c.expense_items.length} expense item${c.expense_items.length === 1 ? '' : 's'}`,
              Array.isArray(c.assets) && `${c.assets.length} asset${c.assets.length === 1 ? '' : 's'}`,
              Array.isArray(c.liabilities) && `${c.liabilities.length} liabilit${c.liabilities.length === 1 ? 'y' : 'ies'}`,
              Array.isArray(c.events) && `${c.events.length} timeline event${c.events.length === 1 ? '' : 's'}`,
              Array.isArray(c.gaps) && c.gaps.length > 0 && `${c.gaps.length} gap${c.gaps.length === 1 ? '' : 's'} flagged`,
            ].filter(Boolean).join(' · ') || '—'}
            {' — the full report is on the client\u2019s MightyAnalyzer page.'}
          </div>
        </div>
      ) : wp.kind === 'discovery_draft' ? (
        /* pkg80 — the exact billed question set: numbered within each type */
        <div>
          {c.case_ref && <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Case: {c.case_ref}</div>}
          {Array.isArray(c.questions) && c.questions.length > 0 ? (
            ['interrogatory', 'rfp'].map((t) => {
              const qs = c.questions.filter((q) => q.type === t);
              if (!qs.length) return null;
              return (
                <div key={t} style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#1E2761', textTransform: 'uppercase', letterSpacing: '0.03em', marginBottom: 4 }}>
                    {t === 'interrogatory' ? `Interrogatories (${qs.length})` : `Requests for Production (${qs.length})`}
                  </div>
                  {qs.map((q, i) => (
                    <div key={i} style={{ fontSize: 13, color: '#333', lineHeight: 1.5, marginTop: i ? 4 : 0 }}>
                      {i + 1}. {q.text}
                    </div>
                  ))}
                </div>
              );
            })
          ) : (
            <div style={{ fontSize: 13, color: '#888' }}>—</div>
          )}
        </div>
      ) : wp.kind === 'correspondence' ? (
        <div style={{ fontSize: 13, color: '#333', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{c.draft || '—'}</div>
      ) : (
        <>
          {Array.isArray(c.sources) && c.sources.length > 0 && (
            <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Based on: {c.sources.join(', ')}</div>
          )}
          <div style={{ fontSize: 13, color: '#333', lineHeight: 1.55 }}>{c.digest || '—'}</div>
          {Array.isArray(c.flags) && c.flags.length > 0 && (
            <div style={{ marginTop: 8, borderTop: '1px solid #e4e9f0', paddingTop: 8 }}>
              {c.flags.map((fl, i) => (
                <div key={i} style={{ fontSize: 12, color: '#444', marginTop: i ? 4 : 0 }}>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 9,
                    background: '#fdf6e6', color: '#7c5200', border: '1px solid #7c520033',
                    marginRight: 8, textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                    {fl.type === 'incomplete' ? 'Incomplete' : 'Inconsistent'}
                  </span>
                  {fl.text}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default function AdminClientDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const validTabKeys = TABS.map((t) => t.key);
  const activeTab = validTabKeys.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'overview';
  const { firm } = useFirmSettings();
  const { adminUser } = useAdminAuth();
  const isOwner = adminUser?.role === 'owner';


  function setActiveTab(tab) {
    const next = new URLSearchParams(searchParams);
    next.set('tab', tab);
    setSearchParams(next);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [editName, setEditName] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editPhone, setEditPhone] = useState('');
  const [editUsername, setEditUsername] = useState('');
  const [editCaseType, setEditCaseType] = useState('');
  // pkg68a — the Profile tab's practice-area half of the cascade. UI-only:
  // derived from the client's case_type on load, never sent to the backend.
  const [editPracticeArea, setEditPracticeArea] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [welcomePassword, setWelcomePassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [sendingWelcome, setSendingWelcome] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  // ── Case lifecycle (Close / Settle / Reopen) ──────────────────────────
  // `caseStatusBusy` holds the action currently in flight ('close', 'settle',
  // or 'reopen') so we can disable the right button. `confirmCaseAction`
  // holds the action awaiting two-step confirmation (same set of strings,
  // or null when nothing is pending).
  const [caseStatusBusy, setCaseStatusBusy] = useState('');
  const [confirmCaseAction, setConfirmCaseAction] = useState(null);
  const [clientData, setClientData] = useState({});
  const [allStaff, setAllStaff] = useState([]); // pkg127 — staff-send picker roster (sendingEmail state retired with the Email-to-Me button)
  const [discovery, setDiscovery] = useState({
    plaintiff: '', defendant: '', court: 'CIRCUIT COURT FOR HAMILTON COUNTY, TENNESSEE',
    docketNo: '', division: '', hasChildren: false,
    ryanRepresents: 'plaintiff', opposingCounsel: '',
    attorneyIds: [], // selected attorneys to appear in signature block
    signingAttorneyId: '' // attorney whose name appears under "By:"
  });
  const [generatingDiscovery, setGeneratingDiscovery] = useState(false);
  // Auto-select-with-override for the firm's standard discovery sets. The
  // resolver returns the auto-picked set for this case (by case type, then
  // practice area, then firm default) plus all active sets for the dropdown.
  // Generation sends whichever set is selected; if none, the backend re-runs
  // the same chain, so behavior is correct even when this UI is unavailable.
  const [discoverySetOptions, setDiscoverySetOptions] = useState([]);
  const [selectedDiscoverySetId, setSelectedDiscoverySetId] = useState('');
  const [autoDiscoverySetId, setAutoDiscoverySetId] = useState('');
  const [discoverySetReason, setDiscoverySetReason] = useState('');
  // When the selected discovery set is an uploaded Word document, these hold the
  // doc's fill-in fields (everything we don't auto-fill) and their entered values.
  const [docIsUploaded, setDocIsUploaded] = useState(false);
  const [docFields, setDocFields] = useState([]);   // [{ token, label }]
  const [docAuto, setDocAuto] = useState([]);        // auto-filled token names
  const [docVals, setDocVals] = useState({});        // token -> value
  // Roster of all owners + attorneys with bar numbers, used for the
  // signature-block checkboxes on the discovery form.
  const [discoveryAttorneys, setDiscoveryAttorneys] = useState([]);
  const [dates, setDates] = useState([]);
  const [newDate, setNewDate] = useState({ date: '', description: '', location: '', start_time: '', end_time: '' });
  const [addingDate, setAddingDate] = useState(false);

  // Calendar sync status for this client. `null` while loading; thereafter
  // { active: bool, createdAt: ISO string | null }. The admin view never
  // sees the token itself (intentional — see backend route comments).
  const [calSync, setCalSync] = useState(null);
  const [calSyncBusy, setCalSyncBusy] = useState(false);
  const [billing, setBilling] = useState({ entries: [], hourly_rate: null, billers: [], allBillers: [], rateMap: {} });
  // newEntry / editEntry carry an internal `_rate_touched` flag so the
  // auto-fill behavior on biller change doesn't wipe a rate the user has
  // already typed in by hand. See handleBillerChange / handleEditBillerChange.
  const [newEntry, setNewEntry] = useState({ entry_date: new Date().toISOString().slice(0, 10), description: '', units: '', billable: true, billed_by: '', rate_used: '', _rate_touched: false });
  const [addingEntry, setAddingEntry] = useState(false);
  // Inline-edit state for an existing time entry. `editingEntryId` is the row
  // currently in edit mode (only one at a time); `editEntry` holds the form
  // values. Entries locked to an invoice cannot be edited from the UI; the
  // backend also refuses with 409 if someone tries.
  const [editingEntryId, setEditingEntryId] = useState(null);
  const [editEntry, setEditEntry] = useState({ entry_date: '', description: '', units: '', billable: true, billed_by: '', rate_used: '', _rate_touched: false });
  const [savingEditEntry, setSavingEditEntry] = useState(false);
  const [hourlyRateEdit, setHourlyRateEdit] = useState('');
  const [savingRate, setSavingRate] = useState(false);
  // Wave 2 — flat-fee editor state. `feeTypeEdit` mirrors billing.fee_type
  // until the user clicks save; `flatFeeEdit` mirrors flat_fee_amount.
  const [editingFeeType, setEditingFeeType] = useState(false);
  const [feeTypeEdit, setFeeTypeEdit] = useState('hourly');
  const [flatFeeEdit, setFlatFeeEdit] = useState('');
  const [savingFeeType, setSavingFeeType] = useState(false);
  const [editingBillerRates, setEditingBillerRates] = useState(false);
  const [billerRateEdits, setBillerRateEdits] = useState({});

  // pkg185 — billing-eligibility strip state (replaces Phase 1.5 team picker)
  const [teamStripOpen, setTeamStripOpen] = useState(false);
  const [showExcluded, setShowExcluded] = useState(false);
  const [eligBusy, setEligBusy] = useState(false);

  const [links, setLinks] = useState([]);
  const [newLinkLabel, setNewLinkLabel] = useState('');
  const [newLinkUrl, setNewLinkUrl] = useState('');
  const [addingLink, setAddingLink] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [newExpense, setNewExpense] = useState({
    expense_date: new Date().toISOString().slice(0, 10),
    description: '', category: '', quantity: '1', unit_price: '', billable: true,
    paid_from_trust: false,
  });
  const [addingExpense, setAddingExpense] = useState(false);
  const [savingExpense, setSavingExpense] = useState(false);
  const [invoices, setInvoices] = useState([]);

  // ── Phase 2: Payments state ────────────────────────────────────────────────
  const [payments, setPayments] = useState([]);
  const [availableCredit, setAvailableCredit] = useState(0);
  // pkg193 — Account filter for the Billing → Payments table. `payments` stays
  // the full ledger (counts, unapplied credit, pending LawPay trust). The
  // table prefers the filtered list response when one is in hand.
  const [paymentAccount, setPaymentAccount] = useState('');
  const [accountRows, setAccountRows] = useState(null);

  // Discovery responses for this client (drives the conditional Discovery tab).
  const [discoveryResponses, setDiscoveryResponses] = useState([]);

  // ── Modules system state (Phase 2) ──────────────────────────────────────
  // `clientModules` is the full list of active modules paired with this
  // client's enabled flag. Edits to the checkbox grid live in `moduleEdits`
  // (a Set of selected module ids) until the admin clicks Save.
  // `caseTypes` is fetched once and used both for the Profile tab dropdown
  // (replaces the old hardcoded CASE_TYPES import) and for the apply-template
  // dropdown on the Modules tab.
  const [clientModules, setClientModules] = useState([]);
  const [moduleEdits, setModuleEdits] = useState(null); // null = matches server
  const [savingModules, setSavingModules] = useState(false);
  const [applyingTemplate, setApplyingTemplate] = useState(false);
  const [applyTemplateId, setApplyTemplateId] = useState('');
  const [applyTemplatePA, setApplyTemplatePA] = useState(''); // pkg68a — cascade half of the template picker
  const [caseTypes, setCaseTypes] = useState([]);
  // pkg68a — firm practice-area catalog (labels + ordering) for both cascades.
  const [practiceAreas, setPracticeAreas] = useState([]);

  // "Record Payment" form state. When `recordingPayment` is true the form is
  // shown inline at the top of the Payments section. The allocation grid is
  // keyed by invoice id → string amount.
  const [recordingPayment, setRecordingPayment] = useState(false);
  const [savingPayment, setSavingPayment] = useState(false);
  const [paymentForm, setPaymentForm] = useState({
    payment_date: firmTodayYmd(),
    method: 'check',
    amount: '',
    deposit_account: 'operating',
    reference_number: '',
    payor: '',
    memo: '',
    status: 'cleared'
  });
  const [paymentAllocations, setPaymentAllocations] = useState({}); // { invoiceId: '12.50' }
  const [paymentOutstanding, setPaymentOutstanding] = useState([]); // outstanding invoices snapshot

  // Per-row UI: which payment row is expanded for detail
  const [expandedPaymentId, setExpandedPaymentId] = useState(null);

  // pkg77 (D-77d) — inline viewer for archived AI work products on billed
  // expenses. One row expands at a time; fetched results are cached so
  // re-opening is free (viewing never costs anything).
  const [wpOpenFor, setWpOpenFor]   = useState(null); // expense id with the panel open
  const [wpCache, setWpCache]       = useState({});   // { [expenseId]: workProduct }
  const [wpLoading, setWpLoading]   = useState('');   // expense id in flight
  const [wpErrors, setWpErrors]     = useState({});   // { [expenseId]: message }
  async function toggleWorkProduct(expenseId) {
    if (wpOpenFor === expenseId) { setWpOpenFor(null); return; }
    setWpOpenFor(expenseId);
    if (wpCache[expenseId]) return;
    setWpLoading(expenseId);
    setWpErrors(prev => ({ ...prev, [expenseId]: '' }));
    try {
      const wp = await adminApi.getExpenseWorkProduct(expenseId);
      setWpCache(prev => ({ ...prev, [expenseId]: wp }));
    } catch (e) {
      setWpErrors(prev => ({ ...prev, [expenseId]: e.message }));
    } finally {
      setWpLoading('');
    }
  }

  // Reverse / refund / edit / email modals (each holds the target payment)
  const [reverseModal, setReverseModal] = useState(null); // { payment, reason, busy }
  const [refundTarget, setRefundTarget] = useState(null); // payment being refunded (owner only)
  const [editPaymentModal, setEditPaymentModal] = useState(null); // { payment, fields..., busy }
  const [paymentEmailModal, setPaymentEmailModal] = useState(null); // { payment, to, subject, body, sendCopyToFirm, busy }

  // Wave 2 modals — soft-void delete on payments/refunds/reversals + edit on
  // individual refund/reversal rows. Each holds { target, busy, _err, ... }.
  const [deletePaymentModal, setDeletePaymentModal] = useState(null);   // { payment, void_reason, busy }
  const [editRefundModal, setEditRefundModal]       = useState(null);   // { payment, refund, refund_date, method, reference_number, reason, busy }
  const [deleteRefundModal, setDeleteRefundModal]   = useState(null);   // { payment, refund, void_reason, busy }
  const [editReversalModal, setEditReversalModal]   = useState(null);   // { payment, reversal, reversal_date, reason, method, reference_number, busy }
  const [deleteReversalModal, setDeleteReversalModal] = useState(null); // { payment, reversal, void_reason, busy }

  // Apply-credit form (separate from new-payment form): apply existing
  // unapplied credit on a payment to a specific outstanding invoice.
  const [applyCreditModal, setApplyCreditModal] = useState(null); // { payment, invoice_id, amount, busy }

  // ── pkg21b: Billing tab UX — persistent summary strip + SUB-TABS ──────────
  // Replaces the Phase 4.5 collapsible sections. One sub-tab renders at a
  // time, fully expanded (no chevrons). The active sub-tab lives in the URL
  // (?btab=) so refresh and back/forward keep position. Time Entries was
  // promoted to its own MAIN tab (renderTime) in the same change.
  const BILLING_SUBTABS = ['expenses', 'invoices', 'payments', 'plans']; // pkg185: 'team' moved to the Time tab; pkg198: plans
  const activeBillingTab = BILLING_SUBTABS.includes(searchParams.get('btab')) ?
  searchParams.get('btab') : 'invoices';
  function setActiveBillingTab(key) {
    const next = new URLSearchParams(searchParams);
    next.set('btab', key);
    setSearchParams(next);
  }
  // Used by the Overview-tab quick-action buttons: land on the right tab with
  // the relevant form already open. Each sets BOTH URL params in one write —
  // two separate setSearchParams calls from the same render would clobber
  // each other (stale snapshot).
  function openLogTimeForm() {
    setActiveTab('time');
    setAddingEntry(true);
  }
  function openAddExpenseForm() {
    const next = new URLSearchParams(searchParams);
    next.set('tab', 'billing');
    next.set('btab', 'expenses');
    setSearchParams(next);
    setAddingExpense(true);
  }

  // ── Phase 3: Trust ledger state ────────────────────────────────────────────
  const [trustTransactions, setTrustTransactions] = useState([]);
  const [trustBalance, setTrustBalance] = useState(0);
  const [recordingTrust, setRecordingTrust] = useState(false);
  const [savingTrust, setSavingTrust] = useState(false);
  const [trustForm, setTrustForm] = useState({
    txn_date: new Date().toISOString().slice(0, 10),
    type: 'deposit',
    amount: '',
    description: '',
    payer_payee: '',
    reference_number: '',
    payment_method: '',
    bank_account: ''
  });
  const [confirmDeleteTrustId, setConfirmDeleteTrustId] = useState(null);

  useEffect(() => {
    adminApi.getClient(id).then((data) => {
      setClient(data);
      setEditName(data.name);
      setEditEmail(data.email);
      setEditPhone(data.phone || '');
      setEditUsername(data.display_name || '');
      setEditCaseType(data.case_type || '');
      setLoading(false);
    }).catch((err) => {setError(err.message);setLoading(false);});
    adminApi.getLinks(id).then(setLinks).catch(() => {});
    adminApi.getClientDates(id).then(setDates).catch(() => {});
    adminApi.getClientCalendarSync(id).then(setCalSync).catch(() => setCalSync({ active: false }));
    adminApi.getBillingEntries(id).then((data) => {
      setBilling(data);
      setHourlyRateEdit(data.hourly_rate || '');
      setFeeTypeEdit(data.fee_type || 'hourly');
      setFlatFeeEdit(data.flat_fee_amount != null ? String(data.flat_fee_amount) : '');
      const rateEdits = {};
      for (const b of data.billers || []) {
        const override = (data.billerRates || []).find((r) => r.admin_user_id === b.id);
        rateEdits[b.id] = override ? parseFloat(override.hourly_rate) : '';
      }
      setBillerRateEdits(rateEdits);
    }).catch(() => {});
    adminApi.getExpenses(id).then(setExpenses).catch(() => {});
    adminApi.getClientInvoices(id).then(setInvoices).catch(() => {});
    adminApi.getClientPayments(id).then((data) => {
      setPayments(data.payments || []);
      setAvailableCredit(parseFloat(data.availableCredit) || 0);
    }).catch(() => {});
    adminApi.getClientTrust(id).then((data) => {
      setTrustTransactions(data.transactions || []);
      setTrustBalance(parseFloat(data.balance) || 0);
    }).catch(() => {});
    // Modules system: per-client module list + global case-types list
    adminApi.getClientModules(id).then((data) => {
      setClientModules(data.modules || []);
    }).catch(() => {});
    adminApi.listCaseTypes().then((cts) => {
      setCaseTypes((cts || []).filter((ct) => ct.is_active));
    }).catch(() => {});
    // pkg68a — practice-area labels + catalog ordering for the two cascades.
    adminApi.getFirmPracticeAreas().then((data) => {
      setPracticeAreas(data?.practice_areas || []);
    }).catch(() => {});
    // Load owners + attorneys for the discovery signature block.
    // Sort: owners first, then attorneys, alphabetical by last name within each group.
    adminApi.getAdminUsers().then((users) => {
      setAllStaff(users || []); // pkg127 — full roster for the staff-send picker
      const filtered = (users || []).
      filter((u) => u.role === 'owner' || u.role === 'attorney').
      sort((a, b) => {
        const roleOrder = { owner: 0, attorney: 1 };
        const ra = roleOrder[a.role] ?? 9;
        const rb = roleOrder[b.role] ?? 9;
        if (ra !== rb) return ra - rb;
        const lastA = (a.name || '').trim().split(/\s+/).pop().toLowerCase();
        const lastB = (b.name || '').trim().split(/\s+/).pop().toLowerCase();
        return lastA.localeCompare(lastB);
      });
      setDiscoveryAttorneys(filtered);
      // Default selection: pre-check all owners with a bar number on file.
      const defaultIds = filtered.
      filter((u) => u.role === 'owner' && u.bar_number).
      map((u) => u.id);
      setDiscovery((p) => ({
        ...p,
        attorneyIds: defaultIds,
        signingAttorneyId: defaultIds[0] || ''
      }));
    }).catch(() => {});
    Promise.all([
    adminApi.getClientDemographic(id).catch(() => null),
    adminApi.getClientParentingPlan(id).catch(() => null),
    adminApi.getClientWitnesses(id).catch(() => null),
    adminApi.getClientBudget(id).catch(() => null),
    adminApi.getClientJuvenileInfo(id).catch(() => null),
    adminApi.getClientAssetLedger(id).catch(() => null)]
    ).then(([demo, pp, wit, budget, juv, assetLedger]) => {
      setClientData({ demographic: demo, parentingPlan: pp, witnesses: wit, budget, juvenileInfo: juv, assetLedger });
    });
    // Discovery responses for this client — drives the conditional tab.
    adminApi.listDiscoveryResponses(id).then(setDiscoveryResponses).catch(() => {});
    // Auto-selected discovery set + override options for this case. Best-effort:
    // if it fails (e.g. user lacks generate_discovery), the dropdown is hidden
    // and generation falls back to server-side auto-select.
    adminApi.getDiscoverySetForClient(id).then((res) => {
      setDiscoverySetOptions(res.options || []);
      setSelectedDiscoverySetId(res.auto?.id || '');
      setAutoDiscoverySetId(res.auto?.id || '');
      setDiscoverySetReason(res.reason || '');
    }).catch(() => {
      setDiscoverySetOptions([]);
      setSelectedDiscoverySetId('');
      setAutoDiscoverySetId('');
      setDiscoverySetReason('');
    });
  }, [id]);

  // pkg193 — Billing → Payments account filter. Asks the client payment list
  // for ?deposit_account= and falls back to the full ledger (narrowed locally)
  // until that response arrives, or if the server isn't filtering yet.
  useEffect(() => {
    if (!id || !paymentAccount) {
      setAccountRows(null);
      return;
    }
    let cancelled = false;
    setAccountRows(null);
    adminApi.getClientPayments(id, { deposit_account: paymentAccount })
      .then((data) => {
        if (cancelled) return;
        const rows = data.payments || [];
        // If the server ignored the filter, narrow here. If it already
        // narrowed (including rows that still lack the field), keep its list.
        const mixed = rows.some((p) => p.deposit_account && p.deposit_account !== paymentAccount);
        setAccountRows(mixed ? rows.filter((p) => p.deposit_account === paymentAccount) : rows);
      })
      .catch(() => { if (!cancelled) setAccountRows(null); });
    return () => { cancelled = true; };
  }, [id, paymentAccount, payments]);

  // pkg68a — derive the Profile tab's practice-area selection from the client's
  // stored case_type once both the client and the case-type list have loaded
  // (they arrive from independent requests). Only fills the area in when it is
  // still unset, so a user mid-edit is never yanked to a different area.
  useEffect(() => {
    if (!editCaseType || !caseTypes.length) return;
    const ct = caseTypes.find((c) => c.key === editCaseType);
    if (ct && ct.practice_area) {
      setEditPracticeArea((prev) => prev || ct.practice_area);
    }
    // editCaseType intentionally included: a fresh client load resets it, and
    // the derived area must follow.
  }, [editCaseType, caseTypes]);

  // pkg68a — options for the practice-area half of both cascades: only areas
  // that actually have at least one active case type (no dead-end picks),
  // in the firm catalog's order. Case types whose area key no longer resolves
  // (e.g. the area was disengaged after seeding) still get a prettified entry
  // so every case type stays reachable.
  const areaOptions = React.useMemo(() => {
    const areaKeysWithTypes = new Set(
      caseTypes.map((ct) => ct.practice_area).filter(Boolean)
    );
    const known = practiceAreas.filter((pa) => areaKeysWithTypes.has(pa.key));
    const knownKeys = new Set(known.map((pa) => pa.key));
    const orphans = [...areaKeysWithTypes].filter((k) => !knownKeys.has(k)).sort();
    return [
      ...known.map((pa) => ({ key: pa.key, label: pa.label })),
      ...orphans.map((k) => ({
        key: k,
        label: k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      })),
    ];
  }, [practiceAreas, caseTypes]);

  // When the selected discovery set is an uploaded document, load the fields its
  // {{placeholders}} require so the form can render exactly those inputs.
  useEffect(() => {
    if (!selectedDiscoverySetId) {
      setDocIsUploaded(false); setDocFields([]); setDocAuto([]); setDocVals({});
      return;
    }
    let cancelled = false;
    adminApi.getDiscoveryTemplateFields(selectedDiscoverySetId, id).then((d) => {
      if (cancelled) return;
      const uploaded = d.source === 'uploaded';
      setDocIsUploaded(uploaded);
      setDocFields(uploaded ? (d.fields || []) : []);
      setDocAuto(uploaded ? (d.auto_filled || []) : []);
      setDocVals({});
    }).catch(() => {
      if (cancelled) return;
      setDocIsUploaded(false); setDocFields([]); setDocAuto([]); setDocVals({});
    });
    return () => { cancelled = true; };
  }, [selectedDiscoverySetId, id]);

  async function refreshBilling() {
    try {
      const data = await adminApi.getBillingEntries(id);
      setBilling(data);
      setFeeTypeEdit(data.fee_type || 'hourly');
      setFlatFeeEdit(data.flat_fee_amount != null ? String(data.flat_fee_amount) : '');
      const rateEdits = {};
      for (const b of data.billers || []) {
        const override = (data.billerRates || []).find((r) => r.admin_user_id === b.id);
        rateEdits[b.id] = override ? parseFloat(override.hourly_rate) : '';
      }
      setBillerRateEdits(rateEdits);
    } catch (err) {setError(err.message);}
  }

  // ── Phase 2: payment + invoice refreshers ──────────────────────────────────
  // Any payment mutation can change invoice balance/status, so always refresh
  // both lists together.
  async function refreshPayments() {
    try {
      const data = await adminApi.getClientPayments(id);
      setPayments(data.payments || []);
      setAvailableCredit(parseFloat(data.availableCredit) || 0);
    } catch (err) {setError(err.message);}
  }

  async function refreshInvoices() {
    try {
      const data = await adminApi.getClientInvoices(id);
      setInvoices(data || []);
    } catch (err) {/* non-fatal */}
  }

  async function refreshTrust() {
    try {
      const data = await adminApi.getClientTrust(id);
      setTrustTransactions(data.transactions || []);
      setTrustBalance(parseFloat(data.balance) || 0);
    } catch (err) {/* non-fatal */}
  }

  async function refreshAfterPaymentChange() {
    await Promise.all([refreshPayments(), refreshInvoices()]);
  }

  // ── Handlers ────────────────────────────────────────────────────────────────

  async function handleSaveInfo(e) {
    e.preventDefault();
    setSaving(true);setError('');setSuccess('');
    try {
      // pkg67b (D-67b7) — send the dropdown value VERBATIM: '' is the explicit
      // "clear to no case type" signal the backend now honors; `|| null` made
      // clearing silently impossible (COALESCE kept the old value).
      // pkg69 (D-69a) — the response carries modules_seeded: how many built-in
      // modules the backend just added from the case-type template. Keep it
      // out of the client object, refresh the Modules tab, and say so.
      const { modules_seeded, ...updated } = await adminApi.updateClient(id, { name: editName, email: editEmail, phone: editPhone, display_name: editUsername, case_type: editCaseType });
      setClient((c) => ({ ...c, ...updated }));
      if (modules_seeded > 0) {
        adminApi.getClientModules(id).then((data) => {
          setClientModules(data.modules || []);
          setModuleEdits(null);
        }).catch(() => {});
        setSuccess(`Client information updated — ${modules_seeded} module${modules_seeded === 1 ? '' : 's'} added from the case-type template.`);
      } else {
        setSuccess('Client information updated.');
      }
    } catch (err) {setError(err.message);} finally
    {setSaving(false);}
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    if (!newPassword || newPassword.length < 6) return setError('Password must be at least 6 characters.');
    setResetting(true);setError('');setSuccess('');
    try {
      const data = await adminApi.resetPassword(id, newPassword);
      setSuccess(data.message);
      setNewPassword('');
    } catch (err) {setError(err.message);} finally
    {setResetting(false);}
  }

  async function handleSendWelcome(e) {
    e.preventDefault();
    if (!welcomePassword) return setError('Enter the temporary password to include in the welcome email.');
    setSendingWelcome(true);setError('');setSuccess('');
    try {
      await adminApi.sendWelcome(id, welcomePassword);
      setSuccess(`Welcome email sent to ${client.email}.`);
      setWelcomePassword('');
    } catch (err) {setError(err.message);} finally
    {setSendingWelcome(false);}
  }

  async function handleDelete() {
    setDeleting(true);setError('');
    try {
      await adminApi.deleteClient(id);
      navigate('/admin/clients');
    } catch (err) {setError(err.message);setDeleting(false);}
  }

  // ── Case lifecycle handlers ────────────────────────────────────────────
  // Each handler hits its endpoint, merges the returned status fields back
  // into `client` so the banner and Profile section update without a full
  // page reload, and clears the two-step confirmation.
  async function handleCaseAction(action) {
    setCaseStatusBusy(action);setError('');setSuccess('');
    try {
      const fn = action === 'close' ? adminApi.closeClient :
      action === 'settle' ? adminApi.settleClient :
      adminApi.reopenClient;
      const updated = await fn(id);
      setClient((c) => ({ ...c, ...updated }));
      setConfirmCaseAction(null);
      setSuccess(
        action === 'close' ? 'Case closed. The client has been moved to Closed Files.' :
        action === 'settle' ? 'Case marked as settled.' :
        'Case reopened and moved back to active clients.'
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setCaseStatusBusy('');
    }
  }

  // ── Modules tab handlers (Phase 2) ─────────────────────────────────────
  // moduleEdits is a Set of module ids currently checked. When null, the UI
  // renders directly from clientModules (each row's .enabled flag). When set,
  // the UI renders from the Set (admin has unsaved changes).

  function effectiveSelected() {
    if (moduleEdits) return moduleEdits;
    return new Set(clientModules.filter((m) => m.enabled).map((m) => m.id));
  }

  function toggleClientModule(moduleId) {
    setModuleEdits((prev) => {
      const base = prev || new Set(clientModules.filter((m) => m.enabled).map((m) => m.id));
      const next = new Set(base);
      if (next.has(moduleId)) next.delete(moduleId);else
      next.add(moduleId);
      return next;
    });
  }

  async function handleSaveModules() {
    if (!moduleEdits) return; // no changes
    setSavingModules(true);setError('');setSuccess('');
    try {
      await adminApi.setClientModules(id, [...moduleEdits]);
      // Refresh the canonical list and clear local edits
      const data = await adminApi.getClientModules(id);
      setClientModules(data.modules || []);
      setModuleEdits(null);
      setSuccess('Module assignments saved.');
    } catch (err) {setError(err.message);} finally
    {setSavingModules(false);}
  }

  async function handleApplyTemplate() {
    if (!applyTemplateId) return;
    const ct = caseTypes.find((c) => c.id === applyTemplateId);
    if (!ct) return;
    const ok = window.confirm(
      `Replace this client's current module set with the "${ct.label}" template? ` +
      `This will overwrite any per-client customizations and cannot be undone.`
    );
    if (!ok) return;
    setApplyingTemplate(true);setError('');setSuccess('');
    try {
      await adminApi.applyClientModuleTemplate(id, applyTemplateId);
      const data = await adminApi.getClientModules(id);
      setClientModules(data.modules || []);
      setModuleEdits(null);
      setApplyTemplateId('');
      setApplyTemplatePA(''); // pkg68a — reset the cascade with it
      setSuccess(`Applied "${ct.label}" template.`);
    } catch (err) {setError(err.message);} finally
    {setApplyingTemplate(false);}
  }

  async function downloadParentingPlan() {
    try {
      const blob = await adminApi.downloadParentingPlan(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Parenting_Plan_${(client.name || 'Client').replace(/\s+/g, '_')}.docx`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  async function downloadJuvenileInfo() {
    try {
      const blob = await adminApi.downloadJuvenileInfo(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Juvenile_Info_${(client.name || 'Client').replace(/\s+/g, '_')}.pdf`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  async function downloadAssetLedger() {
    try {
      const blob = await adminApi.downloadClientAssetLedger(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Asset_Debt_List_${(client.name || 'Client').replace(/\s+/g, '_')}.docx`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  // pkg127 — the two downloads that complete parity (D-126b)
  async function downloadBudgetXlsx() {
    try {
      const blob = await adminApi.downloadClientBudget(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Budget_Worksheet_${(client.name || 'Client').replace(/\s+/g, '_')}.xlsx`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  async function downloadWitnessDocx() {
    try {
      const blob = await adminApi.downloadClientWitnesses(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Witness_List_${(client.name || 'Client').replace(/\s+/g, '_')}.docx`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  async function downloadDivorceCertificate() {
    try {
      const blob = await adminApi.downloadDivorceCertificate(id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Divorce_Certificate_${(client.name || 'Client').replace(/\s+/g, '_')}.pdf`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  async function handleAddDate(e) {
    e.preventDefault();
    if (!newDate.date || !newDate.description) return;
    try {
      const d = await adminApi.createDate(
        id,
        newDate.date,
        newDate.description,
        newDate.location,
        newDate.start_time || null,
        newDate.end_time || null
      );
      setDates((prev) => [...prev, d].sort((a, b) => {
        const c = a.date.localeCompare(b.date);
        if (c !== 0) return c;
        // Same-date events: order by start_time (nulls first → all-day above timed)
        const at = a.start_time || '';
        const bt = b.start_time || '';
        return at.localeCompare(bt);
      }));
      setNewDate({ date: '', description: '', location: '', start_time: '', end_time: '' });
      setAddingDate(false);
    } catch (err) {setError(err.message);}
  }

  // When the user enters a start time and end_time is still blank, auto-fill
  // end to start + 1 hour. Caps at 23:00 to avoid wrapping past midnight in
  // the UI (server-side does the same clamp/NULL behavior).
  function handleStartTimeChange(value) {
    setNewDate((p) => {
      const next = { ...p, start_time: value };
      if (value && !p.end_time) {
        const [h, m] = value.split(':').map(Number);
        if (!isNaN(h) && !isNaN(m) && h < 23) {
          const eh = (h + 1).toString().padStart(2, '0');
          const em = m.toString().padStart(2, '0');
          next.end_time = `${eh}:${em}`;
        }
      }
      // Clearing start time also clears end time — keeps the two in sync.
      if (!value) next.end_time = '';
      return next;
    });
  }

  async function handleDeleteDate(dateId) {
    try {await adminApi.deleteDate(dateId);setDates((prev) => prev.filter((d) => d.id !== dateId));}
    catch (err) {setError(err.message);}
  }

  async function handleRevokeCalSync() {
    if (!window.confirm(
      "Revoke this client's calendar sync? Any phone or calendar app they've subscribed will stop receiving updates within a few hours, and the subscription link will stop working. The client can re-enable sync themselves from their dashboard."
    )) return;
    setCalSyncBusy(true);
    try {
      const next = await adminApi.revokeClientCalendarSync(id);
      setCalSync(next);
      setSuccess('Calendar sync revoked.');
    } catch (err) {
      setError(err.message);
    } finally {
      setCalSyncBusy(false);
    }
  }

  // pkg185 (D-185b) — pre-select the effective default biller in the new-entry
  // form whenever the form has no biller yet (first load, after a default
  // change, or after the previously selected biller became ineligible).
  useEffect(() => {
    const def = billing.effective_default_biller_id || '';
    const eligible = new Set((billing.billers || []).map((b) => b.id));
    setNewEntry((p) => {
      if (p.billed_by && eligible.has(p.billed_by)) return p;
      if (!def) return p.billed_by ? { ...p, billed_by: '' } : p;
      const rate = billing.rateMap?.[def] || '';
      return { ...p, billed_by: def, rate_used: p._rate_touched ? p.rate_used : (rate ? String(rate) : '') };
    });
  }, [billing.effective_default_biller_id, billing.billers, billing.rateMap]);

  // Switching billers auto-fills the rate field with that biller's effective
  // hourly rate (per-client override > biller default). But ONLY if the user
  // hasn't manually typed in the Rate field yet — otherwise switching billers
  // would silently overwrite a rate they entered on purpose. The
  // `_rate_touched` flag tracks that.
  function handleBillerChange(billerId) {
    const rate = billing.rateMap[billerId] || '';
    setNewEntry((p) => ({
      ...p,
      billed_by: billerId,
      rate_used: p._rate_touched ? p.rate_used : (rate ? String(rate) : ''),
    }));
  }

  async function handleSaveBillerRates() {
    setSavingRate(true);
    try {
      for (const [adminUserId, rate] of Object.entries(billerRateEdits)) {
        await adminApi.setBillerRate(id, adminUserId, rate ? parseFloat(rate) : null);
      }
      await refreshBilling();
      setEditingBillerRates(false);
      setSuccess('Biller rates saved.');
    } catch (err) {setError(err.message);} finally
    {setSavingRate(false);}
  }

  // Wave 2 — save fee_type and (for flat fee) the amount. Setting fee_type
  // back to 'hourly' clears flat_fee_amount on the server side.
  async function handleSaveFeeType() {
    setSavingFeeType(true);setError('');setSuccess('');
    try {
      const payload = { fee_type: feeTypeEdit };
      if (feeTypeEdit === 'flat_fee') {
        if (flatFeeEdit === '' || flatFeeEdit === null) {
          payload.flat_fee_amount = null;
        } else {
          const amt = parseFloat(flatFeeEdit);
          if (!isFinite(amt) || amt < 0) {
            setError('Flat fee amount must be a non-negative number.');
            setSavingFeeType(false);
            return;
          }
          payload.flat_fee_amount = amt;
        }
      }
      await adminApi.setBillingSettings(id, payload);
      await refreshBilling();
      setEditingFeeType(false);
      setSuccess('Fee type updated.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingFeeType(false);
    }
  }

  // pkg185 — billing-eligibility handlers (opt-out model)
  async function handleExcludeBiller(adminUserId, name) {
    if (!window.confirm(`Exclude ${name} from billing on this client?\n\nTheir past time entries stay; they just won't appear in the "Billed By" dropdown. Their rate override (if any) is preserved in case you restore them later.`)) return;
    setError('');setSuccess('');setEligBusy(true);
    try {
      await adminApi.excludeBiller(id, adminUserId);
      await refreshBilling();
      setSuccess(`${name} excluded from billing on this client.`);
    } catch (err) {setError(err.message);} finally {setEligBusy(false);}
  }

  async function handleRestoreBiller(adminUserId, name) {
    setError('');setSuccess('');setEligBusy(true);
    try {
      await adminApi.restoreBiller(id, adminUserId);
      await refreshBilling();
      setSuccess(`${name} can bill on this client again.`);
    } catch (err) {setError(err.message);} finally {setEligBusy(false);}
  }

  async function handleSetDefaultBiller(adminUserId) {
    setError('');setSuccess('');setEligBusy(true);
    try {
      await adminApi.setDefaultBiller(id, adminUserId);
      await refreshBilling();
      setSuccess(adminUserId ? 'Default biller updated.' : 'Default biller cleared.');
    } catch (err) {setError(err.message);} finally {setEligBusy(false);}
  }

  async function handleAddEntry(e) {
    e.preventDefault();
    if (!newEntry.entry_date || !newEntry.description || !newEntry.units) return;
    try {
      const entry = await adminApi.createBillingEntry(id, newEntry);
      setBilling((prev) => ({ ...prev, entries: [entry, ...prev.entries] }));
      setNewEntry({ entry_date: new Date().toISOString().slice(0, 10), description: '', units: '', billable: true, billed_by: newEntry.billed_by, rate_used: '', _rate_touched: false });
      setAddingEntry(false);
    } catch (err) {setError(err.message);}
  }

  async function handleDeleteEntry(entryId) {
    try {await adminApi.deleteBillingEntry(entryId);setBilling((prev) => ({ ...prev, entries: prev.entries.filter((e) => e.id !== entryId) }));}
    catch (err) {setError(err.message);}
  }

  // Inline-edit handlers for an existing time entry. We pre-fill the editor
  // from the row, let the user change any field, and PATCH on save. If the
  // entry is locked to an invoice the Edit button isn't shown — and the
  // backend will refuse with 409 if a request gets through anyway.
  //
  // _rate_touched starts TRUE here because the existing entry already has a
  // saved rate; we want to treat it as user-set (so switching billers in the
  // edit row doesn't erase it). The user can still type a new rate.
  function handleStartEditEntry(entry) {
    setError('');setSuccess('');
    setEditingEntryId(entry.id);
    setEditEntry({
      entry_date:  entry.entry_date ? String(entry.entry_date).slice(0, 10) : '',
      description: entry.description || '',
      units:       entry.units != null ? String(entry.units) : '',
      billable:    entry.billable !== false,
      billed_by:   entry.billed_by || '',
      rate_used:   entry.rate_used != null ? String(entry.rate_used) : '',
      _rate_touched: entry.rate_used != null,
    });
  }

  function handleCancelEditEntry() {
    setEditingEntryId(null);
    setEditEntry({ entry_date: '', description: '', units: '', billable: true, billed_by: '', rate_used: '', _rate_touched: false });
  }

  // When the biller changes inside the edit row, auto-fill the rate from the
  // effective rateMap — same convention as the "+ Add Time Entry" form. The
  // user can still override the rate by typing in the rate field.
  function handleEditBillerChange(billerId) {
    const rate = billing.rateMap?.[billerId] || '';
    setEditEntry((p) => ({
      ...p,
      billed_by: billerId,
      rate_used: p._rate_touched ? p.rate_used : (rate ? String(rate) : ''),
    }));
  }

  async function handleSaveEditEntry(entryId) {
    if (!editEntry.entry_date || !editEntry.description.trim() || !editEntry.units) {
      setError('Date, description, and units are required.');
      return;
    }
    setSavingEditEntry(true);setError('');setSuccess('');
    try {
      const updated = await adminApi.updateBillingEntry(entryId, {
        entry_date:  editEntry.entry_date,
        description: editEntry.description.trim(),
        units:       parseFloat(editEntry.units),
        billable:    editEntry.billable,
        billed_by:   editEntry.billed_by || null,
        rate_used:   editEntry.rate_used === '' ? null : parseFloat(editEntry.rate_used),
      });
      setBilling((prev) => ({
        ...prev,
        entries: prev.entries.map((e) => e.id === entryId ? { ...e, ...updated } : e),
      }));
      handleCancelEditEntry();
      setSuccess('Time entry updated.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingEditEntry(false);
    }
  }

  async function handleAddExpense(e) {
    e.preventDefault();
    if (!newExpense.expense_date || !newExpense.description || !newExpense.unit_price) return;
    setSavingExpense(true);setError('');
    try {
      const created = await adminApi.createExpense(id, {
        expense_date: newExpense.expense_date,
        description: newExpense.description,
        category: newExpense.category || null,
        quantity: parseFloat(newExpense.quantity) || 1,
        unit_price: parseFloat(newExpense.unit_price),
        billable: newExpense.billable,
        paid_from_trust: !!newExpense.paid_from_trust,
      });
      setExpenses((prev) => [created, ...prev]);
      setNewExpense({
        expense_date: new Date().toISOString().slice(0, 10),
        description: '', category: '', quantity: '1', unit_price: '', billable: true,
        paid_from_trust: false,
      });
      setAddingExpense(false);
    } catch (err) {setError(err.message);} finally
    {setSavingExpense(false);}
  }

  // Toggle paid_from_trust on an existing expense from the row. Locked
  // expenses (on an issued invoice) are rejected by the backend; we hide the
  // toggle for those rows.
  async function handleTogglePaidFromTrust(expense) {
    setError('');setSuccess('');
    try {
      const updated = await adminApi.updateExpense(expense.id, {
        paid_from_trust: !expense.paid_from_trust,
      });
      setExpenses((prev) => prev.map((x) => x.id === expense.id ? { ...x, ...updated } : x));
      setSuccess(updated.paid_from_trust ?
        'Marked as paid from trust — excluded from Amount Billed.' :
        'Unmarked paid-from-trust — included in Amount Billed.');
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDeleteExpense(expenseId, hasAiWork) {
    // pkg77 — the archive CASCADEs with its expense: no charge, no "document
    // the client paid for". Say so before it happens.
    const msg = hasAiWork
      ? 'Delete this expense? Its archived AI work product will be deleted with it.'
      : 'Delete this expense?';
    if (!window.confirm(msg)) return;
    try {
      await adminApi.deleteExpense(expenseId);
      setExpenses((prev) => prev.filter((x) => x.id !== expenseId));
    } catch (err) {setError(err.message);}
  }

  async function handleGenerateDiscovery() {
    if (!docIsUploaded && (!discovery.plaintiff || !discovery.defendant)) {
      setError('Plaintiff and defendant names are required.');
      return;
    }
    if (!discovery.attorneyIds || discovery.attorneyIds.length === 0) {
      setError('Select at least one attorney for the signature block.');
      return;
    }
    // Block generation if any selected attorney is missing a bar number.
    const missing = discoveryAttorneys.
    filter((a) => discovery.attorneyIds.includes(a.id) && !a.bar_number).
    map((a) => a.name);
    if (missing.length) {
      setError('Bar number is missing for: ' + missing.join(', ') +
      '. Add it in Staff Management before generating filings.');
      return;
    }
    setGeneratingDiscovery(true);setError('');setSuccess('');
    try {
      const blob = await adminApi.generateDiscovery({
        ...discovery,
        clientId: id,
        templateId: selectedDiscoverySetId || undefined,
      });
      const setLabel = (discoverySetOptions.find((s) => s.id === selectedDiscoverySetId) || {}).variant_label;
      const safeName = docIsUploaded
        ? (setLabel || 'Discovery').replace(/[^a-zA-Z0-9]/g, '_')
        : (discovery.ryanRepresents === 'plaintiff' ? discovery.defendant : discovery.plaintiff).replace(/[^a-zA-Z0-9]/g, '_');
      const suffix = docIsUploaded ? '' : (discovery.hasChildren ? '_WithChildren' : '_NoChildren');
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Discovery_${safeName}${suffix}.docx`;
      a.click();
    } catch (err) {setError(err.message);} finally
    {setGeneratingDiscovery(false);}
  }

  // Toggle a single attorney's checkbox in the discovery signature block.
  function toggleDiscoveryAttorney(attorneyId) {
    setDiscovery((p) => {
      const isSelected = p.attorneyIds.includes(attorneyId);
      const nextIds = isSelected ?
      p.attorneyIds.filter((x) => x !== attorneyId) :
      [...p.attorneyIds, attorneyId];
      // If we just deselected the signing attorney, fall back to the
      // first selected one (or empty if none remain).
      let nextSigning = p.signingAttorneyId;
      if (isSelected && p.signingAttorneyId === attorneyId) {
        nextSigning = nextIds[0] || '';
      } else if (!isSelected && !p.signingAttorneyId) {
        nextSigning = attorneyId;
      }
      return { ...p, attorneyIds: nextIds, signingAttorneyId: nextSigning };
    });
  }

  async function handleAddLink(e) {
    e.preventDefault();
    if (!newLinkLabel || !newLinkUrl) return;
    setAddingLink(true);
    try {
      const link = await adminApi.addLink(id, newLinkLabel, newLinkUrl);
      setLinks((prev) => [...prev, link]);
      setNewLinkLabel('');setNewLinkUrl('');
    } catch (err) {setError(err.message);} finally
    {setAddingLink(false);}
  }

  async function handleDeleteLink(linkId) {
    try {
      await adminApi.deleteLink(linkId);
      setLinks((prev) => prev.filter((l) => l.id !== linkId));
    } catch (err) {setError(err.message);}
  }

  // ─── Phase 2: Payment handlers ─────────────────────────────────────────────

  // Open the "Record Payment" form. Pulls fresh outstanding invoices from
  // /preview so we always allocate against the current balance, not a stale
  // copy from `invoices` state.
  async function handleOpenRecordPayment() {
    setError('');setSuccess('');
    try {
      const preview = await adminApi.previewPayment(id);
      setPaymentOutstanding(preview.outstandingInvoices || []);
      setPaymentForm({
        payment_date: firmTodayYmd(),
        method: 'check',
        amount: '',
        deposit_account: 'operating',
        reference_number: '',
        payor: '',
        memo: '',
        status: 'cleared'
      });
      setPaymentAllocations({});
      // pkg21b: land on Billing → Payments so the form actually renders
      // (the Payments card only renders on its sub-tab). Both URL params set
      // in one write to avoid clobbering.
      const next = new URLSearchParams(searchParams);
      next.set('tab', 'billing');
      next.set('btab', 'payments');
      setSearchParams(next);
      setRecordingPayment(true);
    } catch (err) {
      setError(err.message);
    }
  }

  function handleClosePaymentForm() {
    setRecordingPayment(false);
    setPaymentAllocations({});
    setPaymentOutstanding([]);
  }

  // Apply payment.amount to outstanding invoices in oldest-first order until
  // the amount is exhausted. Updates the allocation grid in place.
  function handleAutoAllocateFIFO() {
    const amt = parseFloat(paymentForm.amount);
    if (!amt || amt <= 0) {
      setError('Enter a payment amount before auto-allocating.');
      return;
    }
    let remaining = amt;
    const next = {};
    for (const inv of paymentOutstanding) {
      if (remaining < 0.01) break;
      const bal = parseFloat(inv.balance_due) || 0;
      if (bal <= 0) continue;
      const take = Math.min(bal, remaining);
      next[inv.id] = take.toFixed(2);
      remaining = +(remaining - take).toFixed(2);
    }
    setPaymentAllocations(next);
    setError('');
  }

  function handleClearAllocations() {
    setPaymentAllocations({});
  }

  function handleAllocationChange(invoiceId, value) {
    // Allow empty string so the user can clear a row
    if (value === '' || value === null || value === undefined) {
      setPaymentAllocations((prev) => {
        const next = { ...prev };
        delete next[invoiceId];
        return next;
      });
      return;
    }
    setPaymentAllocations((prev) => ({ ...prev, [invoiceId]: value }));
  }

  // Sum of all allocation rows that have a positive parseable value.
  function paymentAllocSum() {
    return Object.values(paymentAllocations).
    reduce((s, v) => s + (parseFloat(v) || 0), 0);
  }

  async function handleCreatePayment(e) {
    e.preventDefault();
    setError('');
    const amt = parseFloat(paymentForm.amount);
    if (!paymentForm.payment_date) return setError('Payment date is required.');
    if (!amt || amt <= 0) return setError('Payment amount must be positive.');
    if (!paymentForm.method) return setError('Method is required.');

    // Build allocations array, drop any zeros/blanks
    const allocations = [];
    for (const inv of paymentOutstanding) {
      const raw = paymentAllocations[inv.id];
      const aAmt = parseFloat(raw);
      if (raw && !isNaN(aAmt) && aAmt > 0) {
        const bal = parseFloat(inv.balance_due) || 0;
        if (aAmt > bal + 0.001) {
          return setError(`Allocation to invoice #${inv.invoice_number} ($${aAmt.toFixed(2)}) exceeds its balance ($${bal.toFixed(2)}).`);
        }
        allocations.push({ invoice_id: inv.id, amount: +aAmt.toFixed(2) });
      }
    }
    const allocSum = +allocations.reduce((s, a) => s + a.amount, 0).toFixed(2);
    if (allocSum > amt + 0.001) {
      return setError(`Allocations total $${allocSum.toFixed(2)} exceeds payment amount $${amt.toFixed(2)}.`);
    }

    setSavingPayment(true);
    try {
      await adminApi.createPayment(id, {
        payment_date: paymentForm.payment_date,
        method: paymentForm.method,
        amount: amt,
        deposit_account: paymentForm.deposit_account || 'operating',
        reference_number: paymentForm.reference_number || null,
        payor: paymentForm.payor || null,
        memo: paymentForm.memo || null,
        status: paymentForm.status || 'cleared',
        allocations
      });
      const unapplied = +(amt - allocSum).toFixed(2);
      setSuccess(
        `Recorded ${methodLabel(paymentForm.method)} payment of $${amt.toFixed(2)}` + (
        allocations.length ?
        ` applied to ${allocations.length} invoice${allocations.length > 1 ? 's' : ''}` + (
        unapplied > 0 ? ` ($${unapplied.toFixed(2)} held as credit)` : '') :
        ' (held as client credit).')
      );
      handleClosePaymentForm();
      await refreshAfterPaymentChange();
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingPayment(false);
    }
  }

  // Open & submit reverse modal
  function openReverseModal(payment) {
    setError('');setSuccess('');
    setReverseModal({ payment, reason: '', busy: false });
  }
  async function handleSubmitReverse() {
    if (!reverseModal) return;
    if (!reverseModal.reason.trim()) {
      setReverseModal((p) => ({ ...p, _err: 'Reason is required.' }));
      return;
    }
    setReverseModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.reversePayment(reverseModal.payment.id, reverseModal.reason.trim());
      setSuccess(`Payment reversed. Allocations released back to outstanding invoices.`);
      setReverseModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setReverseModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  function openRefundModal(payment) {
    setError('');setSuccess('');
    setRefundTarget(payment);
  }

  // Cosmetic edit: date / method / ref / payor / memo / deposit_account / status pending↔cleared
  function openEditPaymentModal(payment) {
    setError('');setSuccess('');
    setEditPaymentModal({
      payment,
      payment_date: firmDateYmd(payment.payment_date),
      method: payment.method || 'check',
      reference_number: payment.reference_number || '',
      payor: payment.payor || '',
      memo: payment.memo || '',
      deposit_account: payment.deposit_account || 'operating',
      status: payment.status === 'pending' ? 'pending' : 'cleared',
      busy: false,
      _err: ''
    });
  }
  async function handleSubmitEditPayment() {
    if (!editPaymentModal) return;
    setEditPaymentModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.updatePayment(editPaymentModal.payment.id, {
        payment_date: editPaymentModal.payment_date,
        method: editPaymentModal.method,
        reference_number: editPaymentModal.reference_number || null,
        payor: editPaymentModal.payor || null,
        memo: editPaymentModal.memo || null,
        deposit_account: editPaymentModal.deposit_account,
        status: editPaymentModal.status
      });
      setSuccess('Payment details updated.');
      setEditPaymentModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setEditPaymentModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Wave 2 — Delete payment (soft-void) ───────────────────────────────────
  function openDeletePaymentModal(payment) {
    setError('');setSuccess('');
    setDeletePaymentModal({ payment, void_reason: '', busy: false, _err: '' });
  }
  async function handleSubmitDeletePayment() {
    if (!deletePaymentModal) return;
    setDeletePaymentModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.deletePayment(deletePaymentModal.payment.id, deletePaymentModal.void_reason || null);
      setSuccess(`Payment voided. It stays in the history for the audit trail but no longer counts toward balances.`);
      setDeletePaymentModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setDeletePaymentModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Wave 2 — Edit refund row ──────────────────────────────────────────────
  function openEditRefundModal(payment, refund) {
    setError('');setSuccess('');
    setEditRefundModal({
      payment, refund,
      refund_date:      firmDateYmd(refund.refund_date),
      method:           refund.method || '',
      reference_number: refund.reference_number || '',
      reason:           refund.reason || '',
      busy: false, _err: '',
    });
  }
  async function handleSubmitEditRefund() {
    if (!editRefundModal) return;
    if (!editRefundModal.refund_date) {
      return setEditRefundModal((p) => ({ ...p, _err: 'Refund date is required.' }));
    }
    if (!editRefundModal.method) {
      return setEditRefundModal((p) => ({ ...p, _err: 'Method is required.' }));
    }
    setEditRefundModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.updateRefund(editRefundModal.refund.id, {
        refund_date:      editRefundModal.refund_date,
        method:           editRefundModal.method,
        reference_number: editRefundModal.reference_number || null,
        reason:           editRefundModal.reason || null,
      });
      setSuccess('Refund updated.');
      setEditRefundModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setEditRefundModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Wave 2 — Delete refund (soft-void) ────────────────────────────────────
  function openDeleteRefundModal(payment, refund) {
    setError('');setSuccess('');
    setDeleteRefundModal({ payment, refund, void_reason: '', busy: false, _err: '' });
  }
  async function handleSubmitDeleteRefund() {
    if (!deleteRefundModal) return;
    setDeleteRefundModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.deleteRefund(deleteRefundModal.refund.id, deleteRefundModal.void_reason || null);
      setSuccess('Refund voided. The amount goes back to unapplied credit on the original payment.');
      setDeleteRefundModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setDeleteRefundModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Wave 2 — Edit reversal row ────────────────────────────────────────────
  function openEditReversalModal(payment, reversal) {
    setError('');setSuccess('');
    setEditReversalModal({
      payment, reversal,
      reversal_date:    firmDateYmd(reversal.reversal_date),
      reason:           reversal.reason || '',
      method:           reversal.method || '',
      reference_number: reversal.reference_number || '',
      busy: false, _err: '',
    });
  }
  async function handleSubmitEditReversal() {
    if (!editReversalModal) return;
    if (!editReversalModal.reversal_date) {
      return setEditReversalModal((p) => ({ ...p, _err: 'Reversal date is required.' }));
    }
    if (!editReversalModal.reason.trim()) {
      return setEditReversalModal((p) => ({ ...p, _err: 'Reason is required.' }));
    }
    setEditReversalModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.updateReversal(editReversalModal.reversal.id, {
        reversal_date:    editReversalModal.reversal_date,
        reason:           editReversalModal.reason.trim(),
        method:           editReversalModal.method || null,
        reference_number: editReversalModal.reference_number || null,
      });
      setSuccess('Reversal updated.');
      setEditReversalModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setEditReversalModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Wave 2 — Delete reversal (soft-void) ──────────────────────────────────
  // Voiding the only active reversal on a payment restores it to 'cleared'
  // status and re-applies its allocations to affected invoices.
  function openDeleteReversalModal(payment, reversal) {
    setError('');setSuccess('');
    setDeleteReversalModal({ payment, reversal, void_reason: '', busy: false, _err: '' });
  }
  async function handleSubmitDeleteReversal() {
    if (!deleteReversalModal) return;
    setDeleteReversalModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.deleteReversal(deleteReversalModal.reversal.id, deleteReversalModal.void_reason || null);
      setSuccess('Reversal voided. The payment is active again and its allocations have been restored.');
      setDeleteReversalModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setDeleteReversalModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // Apply existing unapplied credit on a payment to an invoice
  function openApplyCreditModal(payment) {
    setError('');setSuccess('');
    // Use current outstandingInvoices state (live), fall back to invoices filter
    const candidates = (invoices || []).filter((inv) => inv.status === 'issued' || inv.status === 'partial');
    if (!candidates.length) {
      setError('No outstanding invoices to apply credit to.');
      return;
    }
    const firstId = candidates[0].id;
    const firstBal = parseFloat(candidates[0].balance_due) || 0;
    const cap = Math.min(payment.unapplied || 0, firstBal);
    setApplyCreditModal({
      payment,
      candidates,
      invoice_id: firstId,
      amount: cap.toFixed(2),
      busy: false,
      _err: ''
    });
  }
  async function handleSubmitApplyCredit() {
    if (!applyCreditModal) return;
    const amt = parseFloat(applyCreditModal.amount);
    if (!applyCreditModal.invoice_id) return setApplyCreditModal((p) => ({ ...p, _err: 'Choose an invoice.' }));
    if (!amt || amt <= 0) return setApplyCreditModal((p) => ({ ...p, _err: 'Amount must be positive.' }));
    setApplyCreditModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      await adminApi.addPaymentAllocation(applyCreditModal.payment.id, applyCreditModal.invoice_id, +amt.toFixed(2));
      setSuccess(`Applied $${amt.toFixed(2)} of credit to the invoice.`);
      setApplyCreditModal(null);
      await refreshAfterPaymentChange();
    } catch (err) {
      setApplyCreditModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  async function handleRemoveAllocation(paymentId, allocId) {
    if (!window.confirm('Un-apply this allocation?\n\nThe credit becomes unapplied again and the invoice balance will increase.')) return;
    setError('');setSuccess('');
    try {
      await adminApi.removePaymentAllocation(paymentId, allocId);
      setSuccess('Allocation removed.');
      await refreshAfterPaymentChange();
    } catch (err) {setError(err.message);}
  }

  async function handleDownloadReceipt(payment) {
    setError('');
    try {
      const blob = await adminApi.downloadReceipt(payment.id);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      const datePart = firmDateYmd(payment.payment_date).replace(/-/g, '');
      const safeName = (client.name || 'Client').replace(/[^a-zA-Z0-9]/g, '_');
      a.download = `Receipt_${datePart}_${safeName}.docx`;
      a.click();
    } catch (err) {setError(err.message);}
  }

  // Build the default email subject + body for a receipt (mirrors invoice flow)
  function buildReceiptEmailTemplate(payment) {
    const firmName = firm && firm.firm_name || 'our office';
    const amtStr = '$' + (parseFloat(payment.amount) || 0).toFixed(2);
    const dateStr = fmtIsoDate(payment.payment_date);
    const subject = `Payment Receipt — ${amtStr} received ${dateStr}`;
    const greeting = (client.name || '').split(' ')[0] || 'there';
    const body =
    `Hi ${greeting},

Thank you for your payment of ${amtStr} received on ${dateStr}. A formal receipt is attached for your records.

If you have any questions about the receipt or your account, just reply to this email.

Best,
${firmName}`;
    return { subject, body };
  }

  function openPaymentEmailModal(payment) {
    if (payment.status === 'reversed') {
      setError('Cannot email a receipt for a reversed payment.');
      return;
    }
    setError('');setSuccess('');
    const tmpl = buildReceiptEmailTemplate(payment);
    setPaymentEmailModal({
      payment,
      to: client.email || '',
      subject: tmpl.subject,
      body: tmpl.body,
      sendCopyToFirm: true,
      busy: false,
      _err: ''
    });
  }
  async function handleSubmitPaymentEmail() {
    if (!paymentEmailModal) return;
    if (!paymentEmailModal.to.trim()) return setPaymentEmailModal((p) => ({ ...p, _err: 'Recipient email is required.' }));
    if (!paymentEmailModal.subject.trim()) return setPaymentEmailModal((p) => ({ ...p, _err: 'Subject is required.' }));
    if (!paymentEmailModal.body.trim()) return setPaymentEmailModal((p) => ({ ...p, _err: 'Message body is required.' }));
    setPaymentEmailModal((p) => ({ ...p, busy: true, _err: '' }));
    try {
      const result = await adminApi.emailReceipt(paymentEmailModal.payment.id, {
        to: paymentEmailModal.to.trim(),
        subject: paymentEmailModal.subject,
        body: paymentEmailModal.body,
        sendCopyToFirm: paymentEmailModal.sendCopyToFirm
      });
      setPaymentEmailModal(null);
      setSuccess(`Receipt emailed to ${result.sent_to}${result.bcc?.length ? ` (BCC: ${result.bcc.join(', ')})` : ''}.`);
      await refreshPayments();
    } catch (err) {
      setPaymentEmailModal((p) => p ? { ...p, busy: false, _err: err.message } : null);
    }
  }

  // ── Loading / not found ─────────────────────────────────────────────────────

  if (loading) return <div style={{ fontFamily: 'Arial, sans-serif', color: '#888', fontSize: 13 }}>Loading...</div>;
  if (!client) return <div className="alert alert-error">{error || 'Client not found'}</div>;

  // ── Computed values for the Overview tab ────────────────────────────────────
  //
  // Wave 1 billing-clarity rewrite. The old code used "unbilled" to mean two
  // very different things (billable-but-not-yet-invoiced, AND non-billable),
  // which made the UI confusing. New vocabulary:
  //
  //   Billed Time          — every billable time entry (hours + $ value),
  //                          regardless of invoice status. This is what the
  //                          attorney has worked AND intends to bill the
  //                          client for. Amount Billed is built from this.
  //   Non-Billable Time    — time logged but marked not-billable. Tracked
  //                          for the record (and for justifying flat-fee
  //                          work, etc.) but NEVER appears in Amount Billed.
  //   Billed Expenses      — billable expenses that the client owes the firm
  //                          for. Excludes expenses paid from the client's
  //                          trust funds (those already settled and would
  //                          double-count if included).
  //   Paid From Trust      — informational: expenses the firm covered from
  //                          the client's trust funds. Already accounted for
  //                          in the trust ledger.
  //   Not Yet Invoiced     — subset of Billed Time + Billed Expenses that
  //                          hasn't been put on an issued invoice yet. Kept
  //                          so attorneys still know what's ready to bill.
  //   Amount Billed        — Billed Time $ value + Billed Expenses $ value.
  //                          THIS IS THE TOTAL THE CLIENT HAS BEEN BILLED,
  //                          independent of invoicing or payment status.
  //   Outstanding          — sum of balance_due on issued/partial invoices.
  //   Unapplied Credit     — sum of unallocated payment credit on file.

  // Time totals
  const billedTimeEntries     = (billing.entries || []).filter((e) => e.billable);
  const nonBillableTimeEntries = (billing.entries || []).filter((e) => !e.billable);
  const billedTimeHours = billedTimeEntries.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);
  const billedTimeValue = billedTimeEntries.reduce((s, e) => {
    const rate = e.rate_used ? parseFloat(e.rate_used) : 0;
    return s + (parseFloat(e.units) || 0) * rate;
  }, 0);
  const nonBillableTimeHours = nonBillableTimeEntries.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);

  // Expense totals — split into "billed" (client owes firm) vs "paid from trust"
  // (already covered out of trust funds, would double-count if added in).
  const billedExpenseRows = (expenses || []).filter((x) => x.billable && !x.paid_from_trust);
  const paidFromTrustExpenseRows = (expenses || []).filter((x) => x.billable && x.paid_from_trust);
  const billedExpensesValue = billedExpenseRows.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
  const paidFromTrustValue  = paidFromTrustExpenseRows.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);

  // "Not yet invoiced" — what's ready to put on a new invoice. (Used to be
  // the only thing displayed, under the misleading name "Unbilled".)
  const notYetInvoicedTimeEntries    = billedTimeEntries.filter((e) => !e.invoice_id);
  const notYetInvoicedExpenseRows    = billedExpenseRows.filter((x) => !x.invoice_id);
  const notYetInvoicedTimeHours      = notYetInvoicedTimeEntries.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);
  const notYetInvoicedTimeValue      = notYetInvoicedTimeEntries.reduce((s, e) => {
    const rate = e.rate_used ? parseFloat(e.rate_used) : 0;
    return s + (parseFloat(e.units) || 0) * rate;
  }, 0);
  const notYetInvoicedExpensesValue  = notYetInvoicedExpenseRows.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
  const notYetInvoicedTotalValue     = notYetInvoicedTimeValue + notYetInvoicedExpensesValue;
  const notYetInvoicedItemCount      = notYetInvoicedTimeEntries.length + notYetInvoicedExpenseRows.length;

  // THE big number: total billed to the client.
  //
  // Hourly clients (default): time × rate + billable expenses.
  // Flat-fee clients (Wave 2): flat fee + billable expenses. Time entries on
  // flat-fee matters are still logged (for the record) but they don't
  // contribute to Amount Billed — the flat fee replaces them.
  const isFlatFee       = (billing.fee_type === 'flat_fee');
  const flatFeeAmount   = isFlatFee ? (parseFloat(billing.flat_fee_amount) || 0) : 0;
  const amountBilled    = isFlatFee
    ? flatFeeAmount + billedExpensesValue
    : billedTimeValue + billedExpensesValue;

  const outstandingInvoices = (invoices || []).filter((inv) => inv.status === 'issued' || inv.status === 'partial');
  const outstandingTotal = outstandingInvoices.reduce((s, inv) => s + parseFloat(inv.balance_due || 0), 0);

  // Phase 2: net amount the client owes after applying any unapplied credit
  const netDue = Math.max(0, outstandingTotal - (parseFloat(availableCredit) || 0));

  const upcomingDates = (dates || []).filter((d) => {
    const days = daysFromNow(d.date);
    return days !== null && days >= 0 && days <= 30;
  }).slice(0, 5);

  const hasTeam = (billing.billers || []).length > 0;

  // ─────────────────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <div className="client-detail-page">
      <style>{MOBILE_STYLES}</style>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
        <button className="btn btn-sm" onClick={() => navigate('/admin/clients')}>← All Clients</button>
        {/* pkg75 (D-75a) — correspondence drafting launches from the client
            because every letter is about a client; context rides in free. */}
        <button className="btn btn-sm" style={{ marginLeft: 'auto' }}
          onClick={() => navigate(`/admin/clients/${id}/correspondence`)}>
          ✦ Draft Correspondence
        </button>
        {/* pkg81 — Discovery Analysis launches from the client for the same
            reason: reports belong to a case (D-81a). */}
        <button className="btn btn-sm" style={{ marginLeft: 8 }}
          onClick={() => navigate(`/admin/clients/${id}/discovery-analysis`)}>
          ✦ MightyAnalyzer™ — analyze a production
        </button>
      </div>
      <h1 className="page-title">{client.name}</h1>
      <p className="page-subtitle">
        {client.display_name && <>Display Name: <strong>{client.display_name}</strong> &nbsp;·&nbsp;</>}
        Status: <strong>{client.must_change_password ? 'Awaiting First Login' : 'Active'}</strong>
        {client.case_type && <> &nbsp;·&nbsp; Case Type: <strong>{caseTypes.find((ct) => ct.key === client.case_type)?.label || client.case_type}</strong></>}
        &nbsp;·&nbsp; Created: <strong>{new Date(client.created_at).toLocaleDateString()}</strong>
      </p>

      <CaseDigestCard clientId={id} clientName={client.name} /> {/* pkg76 */}

      {/* ── Closed Files banner ────────────────────────────────────────
           Visible at the top of every tab whenever the case is not active.
           Tells the user at a glance that this client is in the archive
           (and, if appropriate, that portal access is about to expire or
           has already expired). The Profile tab has the actual close/
           reopen action buttons; this banner is read-only.
        */}
      {client.case_status && client.case_status !== 'active' &&
      <ClosedCaseBanner
        status={client.case_status}
        closedAt={client.closed_at}
        settledAt={client.settled_at}
        onGoToProfile={() => setActiveTab('profile')} />

      }

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {/* Tabs */}
      <div className="client-detail-tabs">
        {TABS.map((t) =>
        <button key={t.key}
        className={activeTab === t.key ? 'active' : ''}
        onClick={() => setActiveTab(t.key)}>
            {t.label}
          </button>
        )}
      </div>

      {activeTab === 'overview' && renderOverview()}
      {activeTab === 'billing' && renderBilling()}
      {activeTab === 'time' && renderTime()}
      {activeTab === 'trust' && renderTrust()}
      {activeTab === 'case' && renderCase()}
      {activeTab === 'modules' && renderModules()}
      {activeTab === 'conflicts' && renderConflicts()}
      {activeTab === 'profile' && renderProfile()}
      {activeTab === 'discovery' && renderDiscovery()}

      {/* ── Phase 2: Payment modals ────────────────────────────────────── */}
      {reverseModal && renderReverseModal()}
      {refundTarget && (
        <RefundPaymentModal
          payment={refundTarget}
          onClose={() => setRefundTarget(null)}
          onRefunded={async (text) => { setRefundTarget(null); setSuccess(text); await refreshAfterPaymentChange(); }}
        />
      )}
      {editPaymentModal && renderEditPaymentModal()}
      {applyCreditModal && renderApplyCreditModal()}
      {paymentEmailModal && renderPaymentEmailModal()}
      {/* ── Wave 2: payment/refund/reversal soft-void + edit modals ────── */}
      {deletePaymentModal && renderDeletePaymentModal()}
      {editRefundModal && renderEditRefundModal()}
      {deleteRefundModal && renderDeleteRefundModal()}
      {editReversalModal && renderEditReversalModal()}
      {deleteReversalModal && renderDeleteReversalModal()}
    </div>);


  // ═══════════════════════════════════════════════════════════════════════════
  // OVERVIEW TAB
  // ═══════════════════════════════════════════════════════════════════════════

  function renderOverview() {
    return (
      <>
        {/* Form Activity — pkg125a: driven by the client's ACTUAL module
            assignments (clientModules) instead of the old hardcoded two-tile
            block. One tile per assigned built-in module, status from the
            clientData buckets already loaded on mount, and every tile is
            clickable — it opens the Client Modules workspace on that module
            (?m= deep link) so the attorney can edit it right from here. */}
        {(() => {
          const STATUS_TILE = {
            demographic: () => {
              const d = clientData.demographic;
              if (d?.submitted_at) return { color: '#1e7e5e', text: `✓ Submitted ${new Date(d.submitted_at).toLocaleDateString()}` };
              if (d?.data) return { color: '#b7870a', text: 'Saved, not submitted' };
              return { color: '#888', text: 'Not started' };
            },
            parenting_plan: () => {
              const d = clientData.parentingPlan;
              if (d?.last_saved) return { color: '#1e7e5e', text: `✓ Saved ${new Date(d.last_saved).toLocaleDateString()}` };
              if (d?.data) return { color: '#b7870a', text: 'In progress' };
              return { color: '#888', text: 'Not started' };
            },
            budget: () => {
              const d = clientData.budget;
              if (d?.submitted_at) return { color: '#1e7e5e', text: `✓ Submitted ${new Date(d.submitted_at).toLocaleDateString()}` };
              if (d?.data) return { color: '#b7870a', text: 'Saved, not submitted' };
              return { color: '#888', text: 'Not started' };
            },
            witnesses: () => {
              const d = clientData.witnesses;
              const n = (d?.data?.general?.length || 0) + (d?.data?.expert?.length || 0);
              if (d?.submitted_at) return { color: '#1e7e5e', text: `✓ Submitted ${new Date(d.submitted_at).toLocaleDateString()}` };
              if (n) return { color: '#b7870a', text: `In progress (${n} witness${n === 1 ? '' : 'es'})` };
              return { color: '#888', text: 'Not started' };
            },
            juvenile_info: () => {
              const d = clientData.juvenileInfo;
              if (d?.submitted_at) return { color: '#1e7e5e', text: `✓ Submitted ${new Date(d.submitted_at).toLocaleDateString()}` };
              if (d?.data) return { color: '#b7870a', text: 'Saved, not submitted' };
              return { color: '#888', text: 'Not started' };
            },
            asset_ledger: () => {
              const d = clientData.assetLedger;
              const n = (d?.assets?.length || 0) + (d?.liabilities?.length || 0);
              if (d?.ledger?.submitted_at) return { color: '#1e7e5e', text: `✓ Submitted ${new Date(d.ledger.submitted_at).toLocaleDateString()}` };
              if (n) return { color: '#b7870a', text: `In progress (${n} item${n === 1 ? '' : 's'})` };
              return { color: '#888', text: 'Not started' };
            },
            child_support_calc: () => ({ color: '#888', text: 'Calculator — nothing saved' }),
          };
          const tiles = clientModules
            .filter((m) => m.enabled && STATUS_TILE[m.key])
            .map((m) => ({ key: m.key, label: m.label, ...STATUS_TILE[m.key]() }));
          return (
            <>
              <div className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                <span>Form Activity</span>
                <button className="btn btn-sm btn-primary" onClick={() => navigate(`/admin/clients/${id}/modules`)}>
                  Open Client Modules →
                </button>
              </div>
              <div className="card" style={{ display: 'flex', gap: 14, marginBottom: 20, flexWrap: 'wrap' }}>
                {tiles.length === 0 ? (
                  <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
                    No built-in modules assigned yet — assign them on the <strong>Modules</strong> tab.
                  </p>
                ) : tiles.map((t) => (
                  <div key={t.key}
                    onClick={() => navigate(`/admin/clients/${id}/modules?m=${t.key}`)}
                    title={`Open ${t.label} in the Client Modules workspace`}
                    style={{
                      flex: '1 1 170px', textAlign: 'center', cursor: 'pointer',
                      border: '1px solid #e2e2e2', borderRadius: 6, padding: '10px 8px',
                      background: '#fafafa',
                    }}>
                    <div style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#0F1838', fontWeight: 600, marginBottom: 4 }}>{t.label}</div>
                    <div style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: t.color }}>{t.text}</div>
                    <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#2f5496', marginTop: 6 }}>Open &amp; edit →</div>
                  </div>
                ))}
              </div>
            </>
          );
        })()}

        {/* Billing Snapshot */}
        <div className="section-head">Billing Snapshot</div>
        <div className="card">
          {/* Prominent Amount Billed banner. Sits above the smaller cards
              because this is the single most important number on the page:
              it's the total the client has been billed for, period. */}
          <div style={{
            background: 'linear-gradient(135deg, #0F1838 0%, #1E2761 100%)',
            color: '#fff',
            borderRadius: 6,
            padding: '16px 20px',
            marginBottom: 14,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
            fontFamily: 'Arial, sans-serif',
          }}>
            <div>
              <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8, marginBottom: 4 }}>
                Amount Billed {isFlatFee && <span style={{ marginLeft: 6, padding: '1px 6px', borderRadius: 3, background: 'rgba(255,255,255,0.18)', fontSize: 10 }}>FLAT FEE</span>}
              </div>
              <div style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.1 }}>
                {fmtMoneyShort(amountBilled)}
              </div>
              <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>
                {isFlatFee
                  ? <>{fmtMoneyShort(flatFeeAmount)} flat fee · {fmtMoneyShort(billedExpensesValue)} expenses · {billedTimeHours.toFixed(2)} hr logged (informational only)</>
                  : <>{fmtMoneyShort(billedTimeValue)} time · {fmtMoneyShort(billedExpensesValue)} expenses</>
                }
              </div>
            </div>
            <div style={{ textAlign: 'right', fontSize: 12, opacity: 0.85, lineHeight: 1.6 }}>
              <div>Total billed to client to date.</div>
              <div>Independent of invoice / payment status.</div>
            </div>
          </div>

          <div className="snapshot-grid">
            <div className="snapshot-card">
              <div className="label">Billed Time</div>
              <div className="value">{billedTimeHours.toFixed(2)} hrs</div>
              <div className="sub">{fmtMoneyShort(billedTimeValue)} billable</div>
            </div>
            <div className="snapshot-card">
              <div className="label">Non-Billable Time</div>
              <div className="value">{nonBillableTimeHours.toFixed(2)} hrs</div>
              <div className="sub">
                {nonBillableTimeEntries.length} {nonBillableTimeEntries.length === 1 ? 'entry' : 'entries'} · not charged
              </div>
            </div>
            <div className="snapshot-card">
              <div className="label">Billed Expenses</div>
              <div className="value">{fmtMoneyShort(billedExpensesValue)}</div>
              <div className="sub">
                {billedExpenseRows.length} {billedExpenseRows.length === 1 ? 'item' : 'items'}
                {paidFromTrustValue > 0 && <> · {fmtMoneyShort(paidFromTrustValue)} paid from trust</>}
              </div>
            </div>
            <div className="snapshot-card">
              <div className="label">Not Yet Invoiced</div>
              <div className="value" style={{ color: notYetInvoicedTotalValue > 0 ? '#1a7a5e' : '#888' }}>
                {fmtMoneyShort(notYetInvoicedTotalValue)}
              </div>
              <div className="sub">
                {notYetInvoicedTimeHours.toFixed(1)} hrs · {notYetInvoicedItemCount} {notYetInvoicedItemCount === 1 ? 'item' : 'items'} ready to bill
              </div>
            </div>
            <div className="snapshot-card">
              <div className="label">Outstanding</div>
              <div className="value" style={{ color: outstandingTotal > 0 ? '#B85042' : '#0F1838' }}>{fmtMoneyShort(outstandingTotal)}</div>
              <div className="sub">
                {outstandingInvoices.length} {outstandingInvoices.length === 1 ? 'invoice' : 'invoices'}
                {availableCredit > 0 && netDue !== outstandingTotal &&
                <> · net {fmtMoneyShort(netDue)} after credit</>
                }
              </div>
            </div>
            <div className="snapshot-card">
              <div className="label">Unapplied Credit</div>
              <div className="value" style={{ color: availableCredit > 0 ? '#1a7a5e' : '#888' }}>{fmtMoneyShort(availableCredit)}</div>
              <div className="sub">
                {availableCredit > 0 ?
                'Available to apply' :
                'No credit on file'}
              </div>
            </div>
          </div>
          <div className="btn-row" style={{ flexWrap: 'wrap' }}>
            <button className="btn btn-sm btn-primary"
            onClick={() => navigate(`/admin/dashboard/invoices/new?clientId=${id}`)}>
              + Generate Invoice
            </button>
            <button className="btn btn-sm btn-primary"
            onClick={() => handleOpenRecordPayment()}>
              + Record Payment
            </button>
            {/* pkg172a — emailed LawPay link to the TRUST page; lands in IOLTA on settlement */}
            <LawPayLinkButton purpose="retainer" small clientId={id} clientEmail={client && client.email} />
            <button className="btn btn-sm"
            onClick={() => openLogTimeForm()}>
              Log Time
            </button>
            <button className="btn btn-sm"
            onClick={() => openAddExpenseForm()}>
              Add Expense
            </button>
          </div>
        </div>

        {/* Recent Invoices */}
        <div className="section-head">Recent Invoices</div>
        <div className="card" style={{ padding: invoices.length === 0 ? 16 : 0 }}>
          {invoices.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              No invoices yet for this client.
            </p> :

          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 90 }}>Invoice #</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 90 }}>Status</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 110 }}>Issued</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 100 }}>Total</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 100 }}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.slice(0, 5).map((inv, i) =>
                <tr key={inv.id}
                onClick={() => navigate(`/admin/dashboard/invoices/${inv.id}`)}
                style={{ borderBottom: '1px solid #eee', cursor: 'pointer', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={{ padding: '7px 10px', fontWeight: 600 }}>
                        #{inv.invoice_number}
                        {inv.imported_from_clio && inv.clio_bill_id != null &&
                    <span style={{ marginLeft: 6, fontSize: 10, padding: '1px 5px', borderRadius: 3, background: '#f0f4f8', color: '#2f5496', border: '1px solid #d2dceb', fontFamily: 'Arial, sans-serif', fontWeight: 500 }}
                    title="Imported from Clio">
                            Clio #{inv.clio_bill_id}
                          </span>
                    }
                      </td>
                      <td style={{ padding: '7px 10px' }}><InvStatusBadge status={inv.status} /></td>
                      <td style={{ padding: '7px 10px', color: '#555' }}>{fmtIsoDate(inv.issue_date)}</td>
                      <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtMoneyShort(inv.total)}</td>
                      <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: parseFloat(inv.balance_due) > 0 ? 600 : 400, color: parseFloat(inv.balance_due) > 0 ? '#0F1838' : '#888' }}>
                        {parseFloat(inv.balance_due) > 0 ? fmtMoneyShort(inv.balance_due) : '—'}
                      </td>
                    </tr>
                )}
                </tbody>
              </table>
            </div>
          }
          {invoices.length > 5 &&
          <div style={{ padding: '10px 14px', borderTop: '1px solid #eee' }}>
              <button className="btn btn-sm" onClick={() => setActiveTab('billing')}>View all {invoices.length} invoices →</button>
            </div>
          }
        </div>

        {/* Upcoming Dates */}
        <div className="section-head">Upcoming Dates (Next 30 Days)</div>
        <div className="card">
          {upcomingDates.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              Nothing scheduled in the next 30 days.
            </p> :

          <div>
              {upcomingDates.map((d) => {
              const days = daysFromNow(d.date);
              const isUrgent = days !== null && days <= 7;
              return (
                <div key={d.id} style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12, padding: '8px 0',
                  borderBottom: '1px solid #eee'
                }}>
                    <div style={{ minWidth: 110, fontFamily: 'Arial, sans-serif', fontSize: 13, color: isUrgent ? '#B85042' : '#0F1838', fontWeight: 500 }}>
                      {fmtIsoDate(d.date)}
                      <div style={{ fontSize: 11, color: isUrgent ? '#B85042' : '#888', fontWeight: 'normal' }}>
                        {days === 0 ? 'Today' : days === 1 ? 'Tomorrow' : `in ${days} days`}
                      </div>
                    </div>
                    <div style={{ flex: 1, fontFamily: 'Arial, sans-serif', fontSize: 13 }}>
                      <div>{d.description}</div>
                      {d.location &&
                    <div style={{ fontSize: 11, marginTop: 2, color: '#555' }}>
                          {d.location.startsWith('http') ? '🔗 ' : '📍 '}{d.location}
                        </div>
                    }
                    </div>
                  </div>);

            })}
              {dates.length > upcomingDates.length &&
            <div style={{ marginTop: 10 }}>
                  <button className="btn btn-sm" onClick={() => setActiveTab('case')}>Manage all dates →</button>
                </div>
            }
            </div>
          }
        </div>
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // BILLING TAB — team & rates, time entries, expenses, invoices
  // ═══════════════════════════════════════════════════════════════════════════

  function renderBilling() {
    // ── Phase 4.5 + Wave 1: stats for summary strip + collapsed-section labels
    // See the long comment near "Computed values for the Overview tab" for the
    // new vocabulary; we mirror it here so the Billing tab tells the same
    // story as the Overview tab.
    const allEntries = billing.entries || [];
    const allExpenses = expenses || [];

    const billedEntriesB     = allEntries.filter((e) => e.billable);
    const nonBillableEntriesB = allEntries.filter((e) => !e.billable);
    const billedHoursB       = billedEntriesB.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);
    const billedTimeValueB   = billedEntriesB.reduce((s, e) => {
      const rate = e.rate_used ? parseFloat(e.rate_used) : 0;
      return s + (parseFloat(e.units) || 0) * rate;
    }, 0);
    const nonBillableHoursB  = nonBillableEntriesB.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);

    const billedExpenseRowsB     = allExpenses.filter((x) => x.billable && !x.paid_from_trust);
    const paidFromTrustRowsB     = allExpenses.filter((x) => x.billable && x.paid_from_trust);
    const billedExpensesValueB   = billedExpenseRowsB.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
    const paidFromTrustValueB    = paidFromTrustRowsB.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);

    const notYetInvoicedTimeEntriesB = billedEntriesB.filter((e) => !e.invoice_id);
    const notYetInvoicedExpensesB    = billedExpenseRowsB.filter((x) => !x.invoice_id);
    const notYetInvoicedHoursB       = notYetInvoicedTimeEntriesB.reduce((s, e) => s + (parseFloat(e.units) || 0), 0);
    const notYetInvoicedTimeValueB   = notYetInvoicedTimeEntriesB.reduce((s, e) => {
      const rate = e.rate_used ? parseFloat(e.rate_used) : 0;
      return s + (parseFloat(e.units) || 0) * rate;
    }, 0);
    const notYetInvoicedExpValueB    = notYetInvoicedExpensesB.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
    const notYetInvoicedTotalB       = notYetInvoicedTimeValueB + notYetInvoicedExpValueB;

    // Wave 2: flat-fee aware Amount Billed.
    const isFlatFeeB     = (billing.fee_type === 'flat_fee');
    const flatFeeAmountB = isFlatFeeB ? (parseFloat(billing.flat_fee_amount) || 0) : 0;
    const amountBilledB  = isFlatFeeB
      ? flatFeeAmountB + billedExpensesValueB
      : billedTimeValueB + billedExpensesValueB;

    const outstandingInvoicesB = (invoices || []).filter((inv) => inv.status === 'issued' || inv.status === 'partial');
    const outstandingTotalB = outstandingInvoicesB.reduce((s, inv) => s + parseFloat(inv.balance_due || 0), 0);

    // Card style for summary strip
    const summaryCard = (color, onClick, expanded) => ({
      flex: '1 1 180px', minWidth: 180, padding: 14, cursor: 'pointer',
      borderRadius: 6, border: `1px solid ${expanded ? color : '#e5e5e5'}`,
      background: '#fff', boxShadow: expanded ? `inset 0 -3px 0 ${color}` : 'none',
      transition: 'all 0.12s ease'
    });
    const summaryLabel = { fontSize: 10, fontFamily: 'Arial, sans-serif', color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 };
    const summaryValue = { fontSize: 22, fontFamily: 'Arial, sans-serif', fontWeight: 700 };
    const summarySub = { fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888', marginTop: 4 };

    return (
      <>
        {/* ── Prominent Amount Billed banner (mirrors the Overview tab) ──── */}
        <div style={{
          background: 'linear-gradient(135deg, #0F1838 0%, #1E2761 100%)',
          color: '#fff',
          borderRadius: 6,
          padding: '16px 20px',
          marginBottom: 14,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 12,
          fontFamily: 'Arial, sans-serif',
        }}>
          <div>
            <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8, marginBottom: 4 }}>
              Amount Billed {isFlatFeeB && <span style={{ marginLeft: 6, padding: '1px 6px', borderRadius: 3, background: 'rgba(255,255,255,0.18)', fontSize: 10 }}>FLAT FEE</span>}
            </div>
            <div style={{ fontSize: 32, fontWeight: 700, lineHeight: 1.1 }}>
              {fmtMoneyShort(amountBilledB)}
            </div>
            <div style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>
              {isFlatFeeB
                ? <>{fmtMoneyShort(flatFeeAmountB)} flat fee · {fmtMoneyShort(billedExpensesValueB)} expenses · {billedHoursB.toFixed(2)} hr logged (informational only){paidFromTrustValueB > 0 && <> · {fmtMoneyShort(paidFromTrustValueB)} paid from trust (excluded)</>}</>
                : <>{fmtMoneyShort(billedTimeValueB)} time · {fmtMoneyShort(billedExpensesValueB)} expenses{paidFromTrustValueB > 0 && <> · {fmtMoneyShort(paidFromTrustValueB)} paid from trust (excluded)</>}</>
              }
            </div>
          </div>
          <div style={{ textAlign: 'right', fontSize: 12, opacity: 0.85, lineHeight: 1.6 }}>
            <div>Total billed to client to date.</div>
            <div>Independent of invoice / payment status.</div>
          </div>
        </div>

        {/* ── Summary strip ─────────────────────────────────────────────── */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
          <div style={summaryCard('#1a7a5e', null, false)}
          onClick={() => setActiveTab('time')}
          title="Click to open the Time tab">
            <div style={summaryLabel}>Billed Time</div>
            <div style={{ ...summaryValue, color: billedHoursB > 0 ? '#1a7a5e' : '#888' }}>
              {billedHoursB.toFixed(1)} hr
            </div>
            <div style={summarySub}>
              {fmtMoneyShort(billedTimeValueB)} billable
              {nonBillableHoursB > 0 && <> · {nonBillableHoursB.toFixed(1)} hr non-billable</>}
            </div>
          </div>

          <div style={summaryCard('#1E2761', null, false)}
          onClick={() => setActiveTab('time')}
          title="Click to open the Time tab">
            <div style={summaryLabel}>Not Yet Invoiced</div>
            <div style={{ ...summaryValue, color: notYetInvoicedTotalB > 0 ? '#1E2761' : '#888' }}>
              {fmtMoneyShort(notYetInvoicedTotalB)}
            </div>
            <div style={summarySub}>
              {notYetInvoicedHoursB.toFixed(1)} hr · {notYetInvoicedExpensesB.length} {notYetInvoicedExpensesB.length === 1 ? 'expense' : 'expenses'} ready to bill
            </div>
          </div>

          <div style={summaryCard('#B85042', null, activeBillingTab === 'invoices')}
          onClick={() => setActiveBillingTab('invoices')}
          title="Click to open Invoices">
            <div style={summaryLabel}>Outstanding A/R</div>
            <div style={{ ...summaryValue, color: outstandingTotalB > 0 ? '#B85042' : '#888' }}>
              {fmtMoneyShort(outstandingTotalB)}
            </div>
            <div style={summarySub}>
              {outstandingInvoicesB.length} {outstandingInvoicesB.length === 1 ? 'invoice' : 'invoices'} unpaid
            </div>
          </div>

          <div style={summaryCard('#2f5496', null, activeBillingTab === 'payments')}
          onClick={() => setActiveBillingTab('payments')}
          title="Click to open Payments">
            <div style={summaryLabel}>Available Credit</div>
            <div style={{ ...summaryValue, color: availableCredit > 0 ? '#2f5496' : '#888' }}>
              {fmtMoneyShort(availableCredit)}
            </div>
            <div style={summarySub}>
              {payments.length} payment{payments.length === 1 ? '' : 's'} on file
            </div>
          </div>

          <div style={{ ...summaryCard('#b7870a', () => setActiveTab('trust'), false), boxShadow: 'none' }}
          onClick={() => setActiveTab('trust')}
          title="Click to open the Trust tab">
            <div style={summaryLabel}>Trust Balance</div>
            <div style={{ ...summaryValue, color: trustBalance !== 0 ? trustBalance > 0 ? '#1a7a5e' : '#B85042' : '#888' }}>
              {fmtMoneyShort(trustBalance)}
            </div>
            <div style={summarySub}>
              {trustTransactions.length} transaction{trustTransactions.length === 1 ? '' : 's'} · view register →
            </div>
          </div>
        </div>

        <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#888', marginTop: -8, marginBottom: 14 }}>
          Tap a card above to jump to that section. Time entries live on the Time tab.
        </p>

        {/* Fee Type (Wave 2) — small, always-visible card so the billing model
            for this matter is obvious. Edit-in-place; "hourly" is the default. */}
        <div className="card" style={{ marginBottom: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          {!editingFeeType ?
          <>
              <div>
                <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#888', fontFamily: 'Arial, sans-serif', marginBottom: 4 }}>
                  Fee Type
                </div>
                <div style={{ fontSize: 16, fontFamily: 'Arial, sans-serif', fontWeight: 600 }}>
                  {isFlatFeeB ?
                <>Flat Fee — {fmtMoneyShort(flatFeeAmountB)}</> :
                <>Hourly (bill by time)</>
                }
                </div>
                <div style={{ fontSize: 12, color: '#888', fontFamily: 'Arial, sans-serif', marginTop: 2 }}>
                  {isFlatFeeB ?
                'Time entries are tracked but do not add to Amount Billed.' :
                'Amount Billed = time × rate + billable expenses.'
                }
                </div>
              </div>
              <button className="btn btn-sm" onClick={() => {setEditingFeeType(true);}}>
                Change
              </button>
            </> :

          <div style={{ width: '100%' }}>
              <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.04em', color: '#888', fontFamily: 'Arial, sans-serif', marginBottom: 6 }}>
                Fee Type
              </div>
              <div className="form-row" style={{ alignItems: 'flex-end' }}>
                <div className="form-group" style={{ flex: '0 0 220px' }}>
                  <select value={feeTypeEdit} onChange={(e) => setFeeTypeEdit(e.target.value)}
                disabled={savingFeeType}>
                    <option value="hourly">Hourly (bill by time)</option>
                    <option value="flat_fee">Flat Fee (single set amount)</option>
                  </select>
                </div>
                {feeTypeEdit === 'flat_fee' &&
              <div className="form-group" style={{ flex: '0 0 180px' }}>
                  <label style={{ fontSize: 12 }}>Flat Fee Amount ($)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01" value={flatFeeEdit}
                  onChange={(e) => setFlatFeeEdit(e.target.value)}
                  disabled={savingFeeType}
                  placeholder="e.g. 2500.00" />
                </div>
              }
                <div className="form-group" style={{ flex: '0 0 auto' }}>
                  <button className="btn btn-sm btn-primary" onClick={handleSaveFeeType} disabled={savingFeeType}>
                    {savingFeeType ? 'Saving…' : 'Save'}
                  </button>
                  <button className="btn btn-sm" style={{ marginLeft: 6 }}
                onClick={() => {
                  setEditingFeeType(false);
                  setFeeTypeEdit(billing.fee_type || 'hourly');
                  setFlatFeeEdit(billing.flat_fee_amount != null ? String(billing.flat_fee_amount) : '');
                }}
                disabled={savingFeeType}>
                    Cancel
                  </button>
                </div>
              </div>
              {feeTypeEdit === 'flat_fee' &&
            <p style={{ fontSize: 12, color: '#888', fontFamily: 'Arial, sans-serif', marginTop: 4, marginBottom: 0 }}>
                The flat fee counts as billed immediately. Time logged on this matter is still tracked but won't
                add to Amount Billed.
              </p>
            }
            </div>
          }
        </div>

        {/* pkg21b — Billing sub-tab bar (replaces the collapsible sections) */}
        <div style={{ display: 'flex', gap: 2, background: '#fff', border: '1px solid #e5e5e5', borderRadius: 6, padding: 3, marginBottom: 16, flexWrap: 'wrap' }}>
          {[
          { key: 'expenses', label: 'Expenses (' + allExpenses.length + ')' },
          { key: 'invoices', label: 'Invoices (' + (invoices || []).length + ')' },
          { key: 'payments', label: 'Payments (' + payments.length + ')' },
          { key: 'plans', label: 'Plans & Autopay' }].
          map((t) =>
          <button key={t.key}
          onClick={() => setActiveBillingTab(t.key)}
          style={{
            fontSize: 13, fontFamily: 'Arial, sans-serif',
            fontWeight: activeBillingTab === t.key ? 700 : 400,
            padding: '7px 14px', borderRadius: 4, border: 'none', cursor: 'pointer',
            background: activeBillingTab === t.key ? '#0F1838' : 'transparent',
            color: activeBillingTab === t.key ? '#fff' : '#555'
          }}>
              {t.label}
            </button>
          )}
        </div>

        {/* Team & Rates moved to the Time tab (pkg185) — see renderTime() */}

        {/* Time Entries moved to the main Time tab (pkg21b) — see renderTime() */}

        {/* Expenses */}
        {activeBillingTab === 'expenses' && <>
        <div id="billing-section-expenses" className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>
            Expenses{' '}
            <span style={{ fontSize: 12, fontWeight: 400, color: '#888', marginLeft: 6 }}>
              ({allExpenses.length} item{allExpenses.length === 1 ? '' : 's'} · {fmtMoneyShort(notYetInvoicedExpValueB)} not yet invoiced)
            </span>
          </span>
          {!addingExpense && <button className="btn btn-sm btn-primary" onClick={() => setAddingExpense(true)}>+ Add Expense</button>}
        </div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Costs advanced on behalf of the client (filing fees, depositions, postage, etc.). Billable expenses appear in Amount Billed
            unless marked <em>paid from trust</em> — those are already covered by the client's trust funds and excluded to avoid
            double-counting.
          </p>

          {expenses.length > 0 && (() => {
            const billableTotal      = expenses.filter((x) => x.billable).reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
            const billedTotalExp     = billedExpensesValueB;   // excludes paid-from-trust
            const paidFromTrustTotal = paidFromTrustValueB;
            const notYetInvoicedExp  = notYetInvoicedExpValueB;
            const onInvoiceCount     = expenses.filter((x) => x.invoice_id).length;
            return (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 10, marginBottom: 16 }}>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif' }}>{expenses.length}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>Total Expenses</div>
                </div>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif' }}>{fmtMoneyShort(billableTotal)}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>Total Billable</div>
                </div>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif', color: '#0F1838' }}>{fmtMoneyShort(billedTotalExp)}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>In Amount Billed</div>
                </div>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif', color: '#b7870a' }}>{fmtMoneyShort(paidFromTrustTotal)}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>Paid From Trust</div>
                </div>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif', color: '#1a7a5e' }}>{fmtMoneyShort(notYetInvoicedExp)}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>Not Yet Invoiced</div>
                </div>
                <div style={{ background: '#fafafa', border: '1px solid #ddd', borderRadius: 4, padding: 10, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Arial, sans-serif', color: '#2f5496' }}>{onInvoiceCount}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>On Invoices</div>
                </div>
              </div>);

          })()}

          {addingExpense &&
          <form onSubmit={handleAddExpense} style={{ background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6, padding: 16, marginBottom: 16 }}>
              <div className="form-row">
                <div className="form-group" style={{ flex: '0 0 160px' }}>
                  <label>Date</label>
                  <input type="date" value={newExpense.expense_date}
                onChange={(e) => setNewExpense((p) => ({ ...p, expense_date: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label>Category</label>
                  <select value={newExpense.category}
                onChange={(e) => setNewExpense((p) => ({ ...p, category: e.target.value }))}>
                    <option value="">— Select category —</option>
                    {EXPENSE_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Billable?</label>
                  <select value={newExpense.billable ? 'yes' : 'no'}
                onChange={(e) => setNewExpense((p) => ({ ...p, billable: e.target.value === 'yes' }))}>
                    <option value="yes">Billable</option>
                    <option value="no">Non-Billable</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <input type="text" value={newExpense.description}
              onChange={(e) => setNewExpense((p) => ({ ...p, description: e.target.value }))}
              placeholder="e.g. Court filing fee for divorce complaint" required />
              </div>
              <div className="form-row">
                <div className="form-group" style={{ flex: '0 0 100px' }}>
                  <label>Quantity</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0.01" step="0.01" value={newExpense.quantity}
                onChange={(e) => setNewExpense((p) => ({ ...p, quantity: e.target.value }))} />
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Unit Price ($)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01" value={newExpense.unit_price}
                onChange={(e) => setNewExpense((p) => ({ ...p, unit_price: e.target.value }))}
                placeholder="0.00" required />
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Amount</label>
                  <input type="text" disabled
                value={newExpense.unit_price ? fmtMoneyShort((parseFloat(newExpense.quantity) || 1) * parseFloat(newExpense.unit_price)) : '$0.00'} />
                </div>
              </div>
              {newExpense.billable &&
              <div style={{ background: '#fbf7ee', border: '1px solid #ead9ad', borderRadius: 4, padding: '10px 12px', marginBottom: 12 }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer', fontFamily: 'Arial, sans-serif', fontSize: 13 }}>
                  <input type="checkbox" checked={!!newExpense.paid_from_trust}
                    onChange={(e) => setNewExpense((p) => ({ ...p, paid_from_trust: e.target.checked }))}
                    style={{ marginTop: 3 }} />
                  <span>
                    <strong>Paid from trust funds</strong>
                    <div style={{ color: '#555', fontSize: 12, marginTop: 2 }}>
                      Check this when the expense was paid directly out of the client's trust funds
                      (you'll record the matching trust disbursement separately in the Trust tab).
                      Trust-paid expenses are <em>excluded</em> from "Amount Billed" so the client isn't
                      double-charged.
                    </div>
                  </span>
                </label>
              </div>
              }
              <div className="btn-row">
                <button type="button" className="btn" onClick={() => setAddingExpense(false)} disabled={savingExpense}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={savingExpense}>{savingExpense ? 'Adding...' : 'Add Expense'}</button>
              </div>
            </form>
          }

          {expenses.length > 0 ?
          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 100 }}>Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left' }}>Description</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 130 }}>Category</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 60 }}>Qty</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 80 }}>Unit</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 90 }}>Amount</th>
                    <th style={{ padding: '7px 10px', textAlign: 'center', width: 95 }}>Status</th>
                    <th style={{ padding: '7px 10px', width: 120 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.map((x, i) => {
                  const onInvoice = !!x.invoice_id;
                  const lockedByIssued = onInvoice && x.invoice_status && x.invoice_status !== 'draft';
                  const paidFromTrust = !!x.paid_from_trust;
                  const wpOpen = wpOpenFor === x.id; // pkg77 (D-77d)
                  return (
                    <React.Fragment key={x.id}>
                    <tr style={{ borderBottom: wpOpen ? 'none' : '1px solid #eee', background: x.billable ? paidFromTrust ? '#fbf7ee' : i % 2 === 0 ? '#fff' : '#fafafa' : '#fdf8f0' }}>
                        <td style={{ padding: '7px 10px', whiteSpace: 'nowrap' }}>{fmtIsoDate(x.expense_date)}</td>
                        <td style={{ padding: '7px 10px' }}>
                          {x.description}
                          {paidFromTrust &&
                          <span style={{ marginLeft: 8, fontSize: 10, padding: '1px 6px', borderRadius: 3, background: '#fbf7ee', border: '1px solid #ead9ad', color: '#b7870a', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}
                            title="Paid out of the client's trust funds — excluded from Amount Billed">
                            Trust
                          </span>
                          }
                          {/* pkg77 (D-77d) — the archived document behind the charge */}
                          {x.has_ai_work &&
                          <button onClick={() => toggleWorkProduct(x.id)}
                            style={{ marginLeft: 8, background: wpOpen ? '#1E2761' : 'none', border: '1px solid #1E2761',
                              color: wpOpen ? '#fff' : '#1E2761', borderRadius: 3, padding: '1px 7px', cursor: 'pointer', fontSize: 11 }}
                            title="View the archived AI work product this charge paid for — viewing is free.">
                            {wpLoading === x.id ? '…' : wpOpen ? '✦ Hide' : '✦ View work product'}
                          </button>
                          }
                        </td>
                        <td style={{ padding: '7px 10px', color: '#555', fontSize: 12 }}>{x.category || <span style={{ color: '#ccc' }}>—</span>}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace' }}>{parseFloat(x.quantity).toString()}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', color: '#555', fontSize: 12 }}>{fmtMoneyShort(x.unit_price)}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>{fmtMoneyShort(x.amount)}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                          {!x.billable ?
                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#f8d7da', color: '#721c24', fontWeight: 600 }}>Non-Bill</span> :
                        onInvoice ?
                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#e8f0fb', color: '#2f5496', fontWeight: 600 }} title={x.invoice_number ? `Invoice #${x.invoice_number}` : ''}>
                              Inv #{x.invoice_number || '?'}
                            </span> :

                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#d4edda', color: '#155724', fontWeight: 600 }}>Pending</span>
                        }
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                          {lockedByIssued ?
                        <span style={{ fontSize: 10, color: '#aaa' }} title="Locked — on an issued invoice">🔒</span> :
                        <>
                          {x.billable &&
                          <button onClick={() => handleTogglePaidFromTrust(x)}
                            style={{
                              background: paidFromTrust ? '#b7870a' : 'none',
                              border: '1px solid #b7870a',
                              color: paidFromTrust ? '#fff' : '#b7870a',
                              borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11, marginRight: 4
                            }}
                            title={paidFromTrust ?
                              'Click to un-mark — expense will be included in Amount Billed again' :
                              'Mark as paid from the client trust funds — excluded from Amount Billed'}>
                            {paidFromTrust ? 'Trust ✓' : 'Trust'}
                          </button>
                          }
                          <button onClick={() => handleDeleteExpense(x.id, !!x.has_ai_work)}
                          style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11 }}>Del</button>
                        </>
                        }
                        </td>
                      </tr>
                    {/* pkg77 (D-77d) — the archived work product, inline under its charge */}
                    {wpOpen &&
                      <tr style={{ borderBottom: '1px solid #eee' }}>
                        <td colSpan={8} style={{ padding: '0 10px 12px' }}>
                          <div style={{ background: '#f8fafb', borderRadius: 4, padding: '10px 14px', fontFamily: 'Arial, sans-serif' }}>
                            {wpLoading === x.id && <span style={{ fontSize: 12, color: '#888' }}>Loading…</span>}
                            {wpErrors[x.id] && <span style={{ fontSize: 12, color: '#a02020' }}>{wpErrors[x.id]}</span>}
                            {wpCache[x.id] && <AiWorkProductBody wp={wpCache[x.id]} />}
                          </div>
                        </td>
                      </tr>
                    }
                    </React.Fragment>);

                })}
                </tbody>
              </table>
            </div> :

          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>No expenses recorded yet.</p>
          }
        </div>
        </>}

        {/* Invoices */}
        {activeBillingTab === 'invoices' && <>
        <div id="billing-section-invoices" className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>
            Invoices{' '}
            <span style={{ fontSize: 12, fontWeight: 400, color: '#888', marginLeft: 6 }}>
              ({invoices.length} total · {outstandingInvoicesB.length} outstanding · {fmtMoneyShort(outstandingTotalB)} due)
            </span>
          </span>
          <span style={{ display: 'inline-flex', gap: 8, flexWrap: 'wrap' }}>
            {/* pkg173a — retainer request belongs next to the invoices it funds */}
            <LawPayLinkButton purpose="retainer" small clientId={id} clientEmail={client && client.email} />
            <button className="btn btn-sm btn-primary"
            onClick={() => navigate(`/admin/dashboard/invoices/new?clientId=${id}`)}>
              + Generate Invoice
            </button>
          </span>
        </div>
        <div className="card">
          {invoices.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              No invoices yet for this client. Click "Generate Invoice" to create one from time entries and expenses that haven't been invoiced yet.
            </p> :

          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 90 }}>Invoice #</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 100 }}>Status</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 120 }}>Issue Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 120 }}>Due Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Total</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((inv, i) =>
                <tr key={inv.id}
                onClick={() => navigate(`/admin/dashboard/invoices/${inv.id}`)}
                style={{ borderBottom: '1px solid #eee', cursor: 'pointer', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={{ padding: '7px 10px', fontWeight: 600 }}>
                        #{inv.invoice_number}
                        {inv.imported_from_clio && inv.clio_bill_id != null &&
                    <span style={{ marginLeft: 6, fontSize: 10, padding: '1px 5px', borderRadius: 3, background: '#f0f4f8', color: '#2f5496', border: '1px solid #d2dceb', fontFamily: 'Arial, sans-serif', fontWeight: 500 }}
                    title="Imported from Clio">
                            Clio #{inv.clio_bill_id}
                          </span>
                    }
                      </td>
                      <td style={{ padding: '7px 10px' }}><InvStatusBadge status={inv.status} /></td>
                      <td style={{ padding: '7px 10px', color: '#555' }}>{fmtIsoDate(inv.issue_date)}</td>
                      <td style={{ padding: '7px 10px', color: '#555' }}>{fmtIsoDate(inv.due_date)}</td>
                      <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtMoneyShort(inv.total)}</td>
                      <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: parseFloat(inv.balance_due) > 0 ? 600 : 400, color: parseFloat(inv.balance_due) > 0 ? '#0F1838' : '#888' }}>
                        {parseFloat(inv.balance_due) > 0 ? fmtMoneyShort(inv.balance_due) : '—'}
                      </td>
                    </tr>
                )}
                </tbody>
              </table>
            </div>
          }
        </div>
        </>}

        {/* ── Phase 2: Payments ───────────────────────────────────────────── */}
        {activeBillingTab === 'payments' && renderPaymentsSection()}
        {activeBillingTab === 'plans' && <ClientPaymentPlansPanel clientId={id} />}
      </>);

  }


  // ═══════════════════════════════════════════════════════════════════════════
  // TIME TAB — pkg21b: promoted out of Billing (was a collapsible section).
  //            The Billing summary strip's time cards land here, as does the
  //            Overview "Log Time" quick action (with the form pre-opened).
  // ═══════════════════════════════════════════════════════════════════════════

  // ═══════════════════════════════════════════════════════════════════════════
  // pkg185 — WHO CAN BILL (replaces Billing → Team & Rates)
  // ═══════════════════════════════════════════════════════════════════════════
  // Opt-out model: every firm member is eligible unless excluded here or
  // walled off on the Profile tab (blocked users are not listed at all).
  function renderEligibilityStrip() {
    const eligible = billing.billers || [];
    const excluded = billing.excludedBillers || [];
    const storedDefault = billing.default_biller_id || null;
    const effDefault = billing.effective_default_biller_id || null;
    const contractRate = billing.hourly_rate != null && billing.hourly_rate !== '' ? parseFloat(billing.hourly_rate) : null;
    return (
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#555' }}>
            Everyone at the firm can bill on this client unless excluded. The <strong>★ default</strong> is pre-selected
            when you log time (when none is set, it's you if eligible, otherwise the owner). Rates follow this client's
            rate (or the person's own default when the client has none) unless you set a per-person override.
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {!editingBillerRates && eligible.length > 0 &&
            <button className="btn btn-sm" onClick={() => setEditingBillerRates(true)}>Edit Rates</button>}
            {editingBillerRates &&
            <>
              <button className="btn btn-sm" onClick={() => {setEditingBillerRates(false);refreshBilling();}}>Cancel</button>
              <button className="btn btn-sm btn-primary" onClick={handleSaveBillerRates} disabled={savingRate}>
                {savingRate ? 'Saving...' : 'Save Rates'}
              </button>
            </>}
          </div>
        </div>

        {eligible.length > 0 ?
        <div className="biller-rate-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10 }}>
          {eligible.map((b) => {
            const clientRate = billing.billerRates?.find((r) => r.admin_user_id === b.id);
            // pkg49 (D-52a) — override > the CLIENT's rate > biller default.
            const effectiveRate = clientRate ? parseFloat(clientRate.hourly_rate) : contractRate != null ? contractRate : b.default_hourly_rate ? parseFloat(b.default_hourly_rate) : null;
            const isStoredDefault = storedDefault === b.id;
            const isEffDefault = effDefault === b.id;
            return (
              <div key={b.id} style={{ position: 'relative', border: isEffDefault ? '1px solid #0F1838' : '1px solid #ddd', borderRadius: 4, padding: '10px 12px', paddingRight: 28, background: isEffDefault ? '#F5F1E8' : '#fafafa' }}>
                {!editingBillerRates &&
                <button onClick={() => handleExcludeBiller(b.id, b.name)} disabled={eligBusy}
                title="Exclude from billing on this client"
                style={{ position: 'absolute', top: 4, right: 4, width: 20, height: 20, background: 'none', border: 'none', color: '#B85042', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 0, fontFamily: 'Arial, sans-serif' }}>×</button>}
                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, fontWeight: 600, marginBottom: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                  {!editingBillerRates &&
                  <button onClick={() => handleSetDefaultBiller(isStoredDefault ? null : b.id)} disabled={eligBusy}
                  title={isStoredDefault ? 'Clear default biller' : 'Make default biller'}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 15, lineHeight: 1, color: isStoredDefault ? '#b7870a' : (isEffDefault ? '#999' : '#ccc') }}>★</button>}
                  <span>{b.name}</span>
                </div>
                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 10, color: '#888', marginBottom: 4, textTransform: 'capitalize' }}>
                  {b.role || ''}{isStoredDefault ? ' · default' : (isEffDefault ? ' · default (automatic)' : '')}
                </div>
                {editingBillerRates ?
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 12, color: '#555' }}>$</span>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01"
                  value={billerRateEdits[b.id] !== undefined ? billerRateEdits[b.id] : effectiveRate || ''}
                  onChange={(e) => setBillerRateEdits((p) => ({ ...p, [b.id]: e.target.value }))}
                  placeholder={b.default_hourly_rate ? `Default: $${parseFloat(b.default_hourly_rate).toFixed(2)}` : 'No default rate'}
                  style={{ width: '100%', padding: '4px 6px', border: '1px solid #ddd', borderRadius: 3, fontSize: 12 }} />
                  <span style={{ fontSize: 11, color: '#888' }}>/hr</span>
                </div> :
                <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: effectiveRate ? '#0F1838' : '#aaa' }}>
                  {effectiveRate ? `$${effectiveRate.toFixed(2)}/hr` : 'No rate set'}
                  {clientRate && <span style={{ fontSize: 10, color: '#2f5496', marginLeft: 6 }}>custom</span>}
                </div>}
              </div>);
          })}
        </div> :
        <div style={{ textAlign: 'center', padding: 12, fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888' }}>
          Everyone is excluded. Restore someone below.
        </div>}

        {excluded.length > 0 &&
        <div style={{ marginTop: 12 }}>
          <button className="btn btn-sm" onClick={() => setShowExcluded((v) => !v)}>
            {showExcluded ? 'Hide excluded' : `Show excluded (${excluded.length})`}
          </button>
          {showExcluded &&
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
            {excluded.map((u) =>
            <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, border: '1px dashed #ccc', borderRadius: 4, padding: '6px 10px', fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#777', background: '#fff' }}>
              <span>{u.name}{u.role ? ` (${roleLabel(u.role)})` : ''}</span>
              <button className="btn btn-sm" onClick={() => handleRestoreBiller(u.id, u.name)} disabled={eligBusy}>Restore</button>
            </div>)}
          </div>}
        </div>}
      </div>);
  }

  function renderTime() {
    const allEntries = billing.entries || [];
    const notYetInvoicedHours = allEntries.
    filter((e) => e.billable && !e.invoice_id).
    reduce((s, e) => s + (parseFloat(e.units) || 0), 0);
    return (
      <>
        {/* Time Entries */}
        <div id="billing-section-time" className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>
            Time Entries{' '}
            <span style={{ fontSize: 12, fontWeight: 400, color: '#888', marginLeft: 6 }}>
              ({allEntries.length} entr{allEntries.length === 1 ? 'y' : 'ies'} · {notYetInvoicedHours.toFixed(1)} hr not yet invoiced)
            </span>
          </span>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="btn btn-sm" onClick={() => setTeamStripOpen((o) => !o)}>
              {teamStripOpen ? 'Hide' : 'Who can bill'} ({(billing.billers || []).length})
            </button>
            {!addingEntry &&
            <button className="btn btn-sm btn-primary"
            onClick={() => setAddingEntry(true)}
            disabled={!hasTeam}
            title={!hasTeam ? 'Everyone is excluded from billing on this client — restore someone first' : ''}>
                + Add Time Entry
              </button>
            }
          </div>
        </div>

        {/* pkg185 — Who can bill (opt-out eligibility + default biller + per-person rates) */}
        {teamStripOpen && renderEligibilityStrip()}

        <div className="card">
          {!hasTeam && !addingEntry &&
          <div style={{ background: '#fff8e1', border: '1px solid #f0e0a0', borderRadius: 4, padding: 10, marginBottom: 16, fontFamily: 'Arial, sans-serif', fontSize: 13 }}>
              <strong style={{ color: '#b7870a' }}>Everyone is excluded from billing on this client.</strong>{' '}
              Open <strong>Who can bill</strong> above and restore at least one person before logging time.
            </div>
          }
          {addingEntry &&
          <form onSubmit={handleAddEntry} style={{ background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6, padding: 16, marginBottom: 16 }}>
              <div className="form-row">
                <div className="form-group">
                  <label>Date</label>
                  <input type="date" value={newEntry.entry_date}
                onChange={(e) => setNewEntry((p) => ({ ...p, entry_date: e.target.value }))} required />
                </div>
                <div className="form-group" style={{ flex: '0 0 110px' }}>
                  <label>Units (hrs)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0.01" max="100" step="0.01" value={newEntry.units}
                onChange={(e) => setNewEntry((p) => ({ ...p, units: e.target.value }))}
                placeholder="0.25" required />
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Billable?</label>
                  <select value={newEntry.billable ? 'yes' : 'no'}
                onChange={(e) => setNewEntry((p) => ({ ...p, billable: e.target.value === 'yes' }))}>
                    <option value="yes">Billable</option>
                    <option value="no">Non-Billable</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Billed By</label>
                  <select value={newEntry.billed_by}
                onChange={(e) => handleBillerChange(e.target.value)}>
                    <option value="">— Select biller —</option>
                    {billing.billers?.map((b) =>
                  <option key={b.id} value={b.id}>{b.name}</option>
                  )}
                  </select>
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Rate ($/hr)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01" value={newEntry.rate_used}
                onChange={(e) => setNewEntry((p) => ({ ...p, rate_used: e.target.value, _rate_touched: true }))}
                placeholder="Auto-filled" />
                </div>
              </div>
              <div className="form-group">
                <label>Description of Work</label>
                <input type="text" value={newEntry.description}
              onChange={(e) => setNewEntry((p) => ({ ...p, description: e.target.value }))}
              placeholder="e.g. Reviewed financial disclosure documents, drafted motion to compel" required />
              </div>
              <div className="btn-row">
                <button type="button" className="btn" onClick={() => setAddingEntry(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary">Add Entry</button>
              </div>
            </form>
          }

          {/* Edit form — same shape as the Add form so users get the same
              big inputs and the full Description field width. Triggered from
              the per-row "Edit" button; row in the table below is highlighted
              while this form is open. */}
          {editingEntryId &&
          <form onSubmit={(e) => { e.preventDefault(); handleSaveEditEntry(editingEntryId); }}
                style={{ background: '#eef4fb', border: '1px solid #bcd4ee', borderRadius: 6, padding: 16, marginBottom: 16 }}>
              <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#2f5496', fontWeight: 600, marginBottom: 12 }}>
                Editing time entry
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Date</label>
                  <input type="date" value={editEntry.entry_date}
                onChange={(ev) => setEditEntry((p) => ({ ...p, entry_date: ev.target.value }))}
                disabled={savingEditEntry} required />
                </div>
                <div className="form-group" style={{ flex: '0 0 110px' }}>
                  <label>Units (hrs)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0.01" max="100" step="0.01" value={editEntry.units}
                onChange={(ev) => setEditEntry((p) => ({ ...p, units: ev.target.value }))}
                disabled={savingEditEntry}
                placeholder="0.25" required />
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Billable?</label>
                  <select value={editEntry.billable ? 'yes' : 'no'}
                onChange={(ev) => setEditEntry((p) => ({ ...p, billable: ev.target.value === 'yes' }))}
                disabled={savingEditEntry}>
                    <option value="yes">Billable</option>
                    <option value="no">Non-Billable</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Billed By</label>
                  <select value={editEntry.billed_by}
                onChange={(ev) => handleEditBillerChange(ev.target.value)}
                disabled={savingEditEntry}>
                    <option value="">— Select biller —</option>
                    {billing.billers?.map((b) =>
                  <option key={b.id} value={b.id}>{b.name}</option>
                  )}
                  </select>
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Rate ($/hr)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01" value={editEntry.rate_used}
                onChange={(ev) => setEditEntry((p) => ({ ...p, rate_used: ev.target.value, _rate_touched: true }))}
                disabled={savingEditEntry}
                placeholder="Auto-filled" />
                </div>
              </div>
              <div className="form-group">
                <label>Description of Work</label>
                <input type="text" value={editEntry.description}
              onChange={(ev) => setEditEntry((p) => ({ ...p, description: ev.target.value }))}
              disabled={savingEditEntry} required />
              </div>
              <div className="btn-row">
                <button type="button" className="btn" onClick={handleCancelEditEntry} disabled={savingEditEntry}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={savingEditEntry}>
                  {savingEditEntry ? 'Saving…' : 'Save Changes'}
                </button>
              </div>
            </form>
          }

          {billing.entries?.length > 0 ?
          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 100 }}>Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left' }}>Description</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 110 }}>Billed By</th>
                    <th style={{ padding: '7px 10px', textAlign: 'center', width: 60 }}>Hrs</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 80 }}>Rate</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 90 }}>Amount</th>
                    <th style={{ padding: '7px 10px', textAlign: 'center', width: 95 }}>Status</th>
                    <th style={{ padding: '7px 10px', width: 110 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {billing.entries.map((e, i) => {
                  const hrs = parseFloat(e.units);
                  const rate = e.rate_used ? parseFloat(e.rate_used) : null;
                  const amt = rate && e.billable ? (hrs * rate).toFixed(2) : null;
                  const onInvoice = !!e.invoice_id;
                  const isEditing = editingEntryId === e.id;
                  // Wave: edit-in-place was replaced with an above-table form
                  // (mirroring the Add Time Entry form) so users get the full
                  // Description-field width. The row stays static and just
                  // gets highlighted so users can see which entry is being
                  // edited in the form above.
                  return (
                    <tr key={e.id} style={{
                      borderBottom: '1px solid #eee',
                      background: isEditing
                        ? '#eef4fb'
                        : (e.billable ? (i % 2 === 0 ? '#fff' : '#fafafa') : '#fdf8f0'),
                      outline: isEditing ? '2px solid #2f5496' : 'none',
                      outlineOffset: isEditing ? '-2px' : 0,
                    }}>
                        <td style={{ padding: '7px 10px', whiteSpace: 'nowrap' }}>{fmtIsoDate(e.entry_date)}</td>
                        <td style={{ padding: '7px 10px' }}>{e.description}</td>
                        <td style={{ padding: '7px 10px', color: '#555', fontSize: 12 }}>{e.biller_name || <span style={{ color: '#ccc' }}>—</span>}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'center', fontFamily: 'monospace' }}>{hrs.toFixed(2)}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', color: '#555', fontSize: 12 }}>{rate ? `$${rate.toFixed(2)}` : <span style={{ color: '#ccc' }}>—</span>}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace' }}>{amt ? `$${amt}` : <span style={{ color: '#aaa' }}>—</span>}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                          {!e.billable ?
                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#f8d7da', color: '#721c24', fontWeight: 600 }}>Non-Bill</span> :
                        onInvoice ?
                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#e8f0fb', color: '#2f5496', fontWeight: 600 }}>Invoiced</span> :

                        <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: '#d4edda', color: '#155724', fontWeight: 600 }}>Pending</span>
                        }
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                          {onInvoice ?
                        <span style={{ fontSize: 10, color: '#aaa' }} title="Locked — on an invoice. Void or delete the invoice to edit this entry.">🔒</span> :
                        isEditing ?
                        <span style={{ fontSize: 11, color: '#2f5496', fontWeight: 600, fontStyle: 'italic' }}>editing ↑</span> :
                        <>
                              <button onClick={() => handleStartEditEntry(e)}
                          disabled={editingEntryId !== null || addingEntry}
                          title={editingEntryId !== null ? 'Finish the current edit first' : (addingEntry ? 'Finish adding the new entry first' : 'Edit this entry')}
                          style={{ background: 'none', border: '1px solid #2f5496', color: '#2f5496', borderRadius: 3, padding: '2px 6px', cursor: (editingEntryId !== null || addingEntry) ? 'default' : 'pointer', fontSize: 11, marginRight: 4, opacity: (editingEntryId !== null || addingEntry) ? 0.5 : 1 }}>Edit</button>
                              <button onClick={() => handleDeleteEntry(e.id)}
                          disabled={editingEntryId !== null || addingEntry}
                          style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '2px 6px', cursor: (editingEntryId !== null || addingEntry) ? 'default' : 'pointer', fontSize: 11, opacity: (editingEntryId !== null || addingEntry) ? 0.5 : 1 }}>Del</button>
                            </>}
                        </td>
                      </tr>);

                })}
                </tbody>
              </table>
            </div> :

          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              No time entries yet for this client.
            </p>
          }
        </div>
        {/* Billing Summary by Biller */}
        {billing.entries?.length > 0 && (() => {
            const byBiller = {};
            for (const e of billing.entries) {
              const key = e.biller_name || 'Unknown';
              if (!byBiller[key]) byBiller[key] = { hours: 0, billableHours: 0, amount: 0, rate: e.rate_used ? parseFloat(e.rate_used) : null };
              const hrs = parseFloat(e.units);
              byBiller[key].hours += hrs;
              if (e.billable) {
                byBiller[key].billableHours += hrs;
                if (byBiller[key].rate) byBiller[key].amount += hrs * byBiller[key].rate;
              }
            }
            const totalAmount = Object.values(byBiller).reduce((s, b) => s + b.amount, 0);
            const totalHours = Object.values(byBiller).reduce((s, b) => s + b.hours, 0);
            return (
              <>
              <div className="section-head">Billing Summary</div>
              <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <div className="table-wrap">
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                    <thead>
                      <tr style={{ background: '#0F1838', color: '#fff' }}>
                        <th style={{ padding: '7px 12px', textAlign: 'left' }}>Biller</th>
                        <th style={{ padding: '7px 12px', textAlign: 'right' }}>Total Hrs</th>
                        <th style={{ padding: '7px 12px', textAlign: 'right' }}>Billable Hrs</th>
                        <th style={{ padding: '7px 12px', textAlign: 'right' }}>Rate</th>
                        <th style={{ padding: '7px 12px', textAlign: 'right' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(byBiller).map(([name, data], i) =>
                        <tr key={name} style={{ borderBottom: '1px solid #eee', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                          <td style={{ padding: '7px 12px', fontWeight: 500 }}>{name}</td>
                          <td style={{ padding: '7px 12px', textAlign: 'right', fontFamily: 'monospace' }}>{data.hours.toFixed(2)}</td>
                          <td style={{ padding: '7px 12px', textAlign: 'right', fontFamily: 'monospace' }}>{data.billableHours.toFixed(2)}</td>
                          <td style={{ padding: '7px 12px', textAlign: 'right', color: '#555' }}>{data.rate ? `$${data.rate.toFixed(2)}/hr` : '—'}</td>
                          <td style={{ padding: '7px 12px', textAlign: 'right', fontWeight: 600 }}>{data.amount > 0 ? `$${data.amount.toFixed(2)}` : '—'}</td>
                        </tr>
                        )}
                      <tr style={{ background: '#0F1838', color: '#fff' }}>
                        <td style={{ padding: '8px 12px', fontWeight: 700 }}>TOTAL</td>
                        <td style={{ padding: '8px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{totalHours.toFixed(2)}</td>
                        <td colSpan={2} style={{ padding: '8px 12px' }}></td>
                        <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 700 }}>{totalAmount > 0 ? `$${totalAmount.toFixed(2)}` : '—'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>);

          })()}
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // TRUST TAB — per-client IOLTA register (was inline on Billing in Phase 4;
  //             promoted to its own tab in Phase 4.5 for breathing room)
  // ═══════════════════════════════════════════════════════════════════════════

  function renderTrust() {
    return (
      <>
        <p className="page-subtitle" style={{ marginTop: -4, marginBottom: 16, fontSize: 13 }}>
          Funds held in the firm's IOLTA on behalf of this client. Deposits, withdrawals,
          and transfers all live here — separate from operating-account billing on the Billing tab.
        </p>
        {renderTrustSection()}
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // CLIENT'S VIEW TAB — dates, links, submitted forms
  //   (pkg21b: renders under the "Client's View" label; the discovery
  //    generator moved to the dedicated Discovery tab)
  // ═══════════════════════════════════════════════════════════════════════════

  function renderCase() {
    return (
      <>
        {/* pkg125 — Client Modules workspace launcher (D-124c): open the
            client's actual module pages in admin mode — work them for the
            client, and generate captioned pleadings from budget / witness /
            asset-ledger data. */}
        <div className="card" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div>
            <div style={{ fontWeight: 600, fontFamily: 'Arial, sans-serif', fontSize: 14 }}>Client Modules</div>
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#555', marginTop: 2 }}>
              Open {client.name}'s portal modules exactly as they see them — fill them in on their behalf and generate pleadings with the case caption.
            </div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate(`/admin/clients/${id}/modules`)}>
            Open Client Modules →
          </button>
        </div>

        {/* Important Dates */}
        <div className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>Important Dates</span>
          {!addingDate && <button className="btn btn-sm btn-primary" onClick={() => setAddingDate(true)}>+ Add Date</button>}
        </div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Dates added here appear on the client's dashboard. Upcoming dates within 14 days are highlighted.
          </p>
          {addingDate &&
          <form onSubmit={handleAddDate} style={{ marginBottom: 16, padding: 16, background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6 }}>
              <div className="form-row">
                <div className="form-group" style={{ flex: '0 0 160px' }}>
                  <label>Date</label>
                  <input type="date" value={newDate.date} onChange={(e) => setNewDate((p) => ({ ...p, date: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <input type="text" value={newDate.description} onChange={(e) => setNewDate((p) => ({ ...p, description: e.target.value }))}
                placeholder="e.g. Mediation Session, Court Hearing, Filing Deadline" required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Start time <span style={{ fontWeight: 400, color: '#888' }}>(optional)</span></label>
                  <input
                  type="time"
                  value={newDate.start_time}
                  onChange={(e) => handleStartTimeChange(e.target.value)} />
                
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>End time</label>
                  <input
                  type="time"
                  value={newDate.end_time}
                  onChange={(e) => setNewDate((p) => ({ ...p, end_time: e.target.value }))}
                  disabled={!newDate.start_time} />
                
                </div>
                <div className="form-group" style={{ alignSelf: 'flex-end', paddingBottom: 8 }}>
                  <span style={{ fontSize: 12, color: '#888', fontFamily: 'Arial, sans-serif' }}>
                    Leave both blank for an all-day event. End auto-fills to start + 1 hour.
                  </span>
                </div>
              </div>
              <div className="form-group">
                <label>Location or Link <span style={{ fontWeight: 400, color: '#888' }}>(optional — physical address or URL)</span></label>
                <input type="text" value={newDate.location} onChange={(e) => setNewDate((p) => ({ ...p, location: e.target.value }))}
              placeholder="e.g. Hamilton County Courthouse, 625 Georgia Ave  —or—  https://zoom.us/j/..." />
              </div>
              <div className="btn-row">
                <button type="button" className="btn" onClick={() => setAddingDate(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary">Add Date</button>
              </div>
            </form>
          }
          {dates.length > 0 ?
          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 120 }}>Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left' }}>Description</th>
                    <th style={{ padding: '7px 10px', width: 80 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {dates.map((d, i) => {
                  const timeRange = fmtTimeRange(d.start_time, d.end_time);
                  return (
                    <tr key={d.id} style={{ borderBottom: '1px solid #eee', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={{ padding: '7px 10px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                        {fmtIsoDate(d.date)}
                        {timeRange &&
                        <div style={{ fontSize: 11, fontWeight: 400, color: '#666', marginTop: 2 }}>{timeRange}</div>
                        }
                      </td>
                      <td style={{ padding: '7px 10px' }}>
                        <div>{d.description}</div>
                        {d.location && (() => {
                          const isLink = d.location.startsWith('http://') || d.location.startsWith('https://');
                          return (
                            <div style={{ fontSize: 11, marginTop: 2, color: '#555' }}>
                              {isLink ?
                              <a href={d.location} target="_blank" rel="noopener noreferrer" style={{ color: '#2f5496' }}>🔗 {d.location}</a> :
                              <span>📍 {d.location}</span>}
                            </div>);

                        })()}
                      </td>
                      <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                        <button onClick={() => handleDeleteDate(d.id)}
                        style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '3px 8px', cursor: 'pointer', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>
                          Remove
                        </button>
                      </td>
                    </tr>);

                })}
                </tbody>
              </table>
            </div> :

          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>No important dates set yet.</p>
          }

          {/* Calendar sync status — lives in the dates card because it
               syncs THIS client's personal dates (not firm-wide). The
               client enables sync themselves from their dashboard; the
               admin can only see status and revoke. The token itself is
               never returned to the admin side. */}
          <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'Arial, sans-serif', fontSize: 13 }}>
              <span style={{ fontSize: 14 }}>📅</span>
              <span style={{ color: '#555' }}>Calendar sync:</span>
              {calSync == null ?
              <span style={{ color: '#aaa' }}>checking…</span> :
              calSync.active ?
              <span style={{ color: '#1a7a5e', fontWeight: 600 }}>
                  Active{calSync.createdAt ? ` since ${fmtIsoDate(calSync.createdAt)}` : ''}
                </span> :

              <span style={{ color: '#888' }}>Not enabled by client</span>
              }
            </div>
            {calSync && calSync.active &&
            <button
              type="button"
              onClick={handleRevokeCalSync}
              disabled={calSyncBusy}
              style={{
                background: 'none', border: '1px solid #B85042', color: '#B85042',
                borderRadius: 3, padding: '4px 12px',
                cursor: calSyncBusy ? 'wait' : 'pointer',
                fontSize: 12, fontFamily: 'Arial, sans-serif'
              }}>
              
                {calSyncBusy ? 'Revoking…' : 'Revoke'}
              </button>
            }
          </div>
        </div>

        {/* Client Links & Resources */}
        <div className="section-head">Client Links &amp; Resources</div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Add links that will appear on the client's dashboard — Dropbox upload folders, court portals, payment links, etc.
          </p>
          {links.length > 0 &&
          <div style={{ marginBottom: 16 }}>
              {links.map((link) =>
            <div key={link.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', border: '1px solid #ddd', borderRadius: 4, marginBottom: 8, background: '#fafafa' }}>
                  <span style={{ fontSize: 16 }}>🔗</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, fontFamily: 'Arial, sans-serif' }}>{link.label}</div>
                    <div style={{ fontSize: 11, color: '#888', fontFamily: 'Arial, sans-serif', wordBreak: 'break-all' }}>{link.url}</div>
                  </div>
                  <button onClick={() => handleDeleteLink(link.id)}
              style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '4px 10px', cursor: 'pointer', fontSize: 12, fontFamily: 'Arial, sans-serif', flexShrink: 0 }}>
                    Remove
                  </button>
                </div>
            )}
            </div>
          }
          <form onSubmit={handleAddLink}>
            <div className="form-row">
              <div className="form-group">
                <label>Link Label</label>
                <input type="text" value={newLinkLabel} onChange={(e) => setNewLinkLabel(e.target.value)}
                placeholder="e.g. Upload Documents to Dropbox" required />
              </div>
              <div className="form-group">
                <label>URL</label>
                <input type="url" value={newLinkUrl} onChange={(e) => setNewLinkUrl(e.target.value)}
                placeholder="https://..." required />
              </div>
            </div>
            <button type="submit" className="btn" disabled={addingLink}>
              {addingLink ? 'Adding...' : '+ Add Link'}
            </button>
          </form>
        </div>

        {/* Client Submitted Data */}
        {/* pkg67 (D-67m) — the panel is driven by the client's ACTUAL module
            assignments (clientModules, already jurisdiction/practice-area/
            firm-choice filtered server-side and carrying per-client enabled
            flags) instead of the old hardcoded six-form array that rendered
            TN/divorce panels for every firm. FORM_PANEL maps the six known
            built-in module keys to their clientData buckets and download
            actions; labels come from the module catalog so admin and client
            see the same names. A module not assigned to this client (or
            turned off at the firm level) simply doesn't render. */}
        {(() => {
          // pkg127 (D-126a/b/c) — every module is downloadable AND emailable
          // to any staff selection: budget gains the FILLED workbook download,
          // witnesses a plain .docx, and the asset ledger joins the email set.
          // `send` is the adminApi sender; the shared ModuleSendControl
          // renders the buttons + multi-select staff picker.
          const FORM_PANEL = {
            demographic: {
              dataKey: 'demographic',
              hasData: !!clientData.demographic,
              savedAt: clientData.demographic?.submitted_at,
              download: { label: 'Download .pdf', fn: downloadDivorceCertificate },
              send: (ids) => adminApi.sendClientDemographic(id, ids),
            },
            parenting_plan: {
              dataKey: 'parentingPlan',
              hasData: !!clientData.parentingPlan,
              savedAt: clientData.parentingPlan?.last_saved,
              download: { label: 'Download .docx', fn: downloadParentingPlan },
              send: (ids) => adminApi.sendClientParentingPlan(id, ids),
            },
            witnesses: {
              dataKey: 'witnesses',
              hasData: !!clientData.witnesses,
              savedAt: clientData.witnesses?.submitted_at,
              download: { label: 'Download .docx', fn: downloadWitnessDocx }, // pkg127
              send: (ids) => adminApi.sendClientWitnesses(id, ids),
            },
            budget: {
              dataKey: 'budget',
              hasData: !!clientData.budget,
              savedAt: clientData.budget?.submitted_at,
              download: { label: 'Download .xlsx', fn: downloadBudgetXlsx }, // pkg127 — filled workbook
              send: (ids) => adminApi.sendClientBudget(id, ids),
            },
            juvenile_info: {
              dataKey: 'juvenileInfo',
              hasData: !!clientData.juvenileInfo,
              savedAt: clientData.juvenileInfo?.submitted_at || clientData.juvenileInfo?.updated_at,
              download: { label: 'Download .pdf', fn: downloadJuvenileInfo },
              send: (ids) => adminApi.sendClientJuvenileInfo(id, ids),
            },
            asset_ledger: {
              dataKey: 'assetLedger',
              hasData: !!(clientData.assetLedger && ((clientData.assetLedger.assets || []).length || (clientData.assetLedger.liabilities || []).length)),
              savedAt: clientData.assetLedger?.ledger?.submitted_at,
              download: { label: 'Download .docx', fn: downloadAssetLedger },
              send: (ids) => adminApi.sendClientAssetLedger(id, ids), // pkg127 — was download-only (pkg29)
            },
          };
          const panels = clientModules.
          filter((m) => m.enabled && FORM_PANEL[m.key]).
          map((m) => ({ key: m.key, dataKey: FORM_PANEL[m.key].dataKey, label: m.label, ...FORM_PANEL[m.key] }));
          if (!panels.length) return null;
          return (
            <>
              <div className="section-head">Client-Submitted Forms</div>
              <div className="card">
                <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
                  View what this client has saved, download the documents, or email them to any staff members.
                  Only forms from this client's assigned modules appear here.
                </p>
                <div className="summary-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, minWidth: 0 }}>
                  {panels.map(({ key, label, hasData, savedAt, download, send }) =>
                  <div key={key} style={{ border: '1px solid #ddd', borderRadius: 6, padding: 14, background: '#fafafa' }}>
                      <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>{label}</div>
                      <div style={{ fontSize: 12, color: hasData ? '#1a7a5e' : '#888', fontFamily: 'Arial, sans-serif', marginBottom: 10 }}>
                        {hasData ?
                      savedAt ? `Last saved ${new Date(savedAt).toLocaleDateString()}` : '✓ Data saved' :
                      'Nothing saved yet'}
                      </div>
                      {hasData &&
                    <ModuleSendControl
                      staff={allStaff}
                      downloadLabel={download?.label}
                      onDownload={download?.fn}
                      onSend={send}
                      firmContactEmail={firm.client_contact_email} />
                    }
                    </div>
                  )}
                </div>
              </div>
            </>
          );
        })()}


      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // MODULES TAB — per-client module assignment + apply-template (Phase 2)
  // ═══════════════════════════════════════════════════════════════════════════

  function renderModules() {
    const selected = effectiveSelected();
    const hasChanges = moduleEdits !== null;
    const currentCaseTypeLabel = client.case_type ?
    caseTypes.find((ct) => ct.key === client.case_type)?.label || client.case_type :
    null;

    return (
      <>
        {/* pkg125b — same workspace launcher as the Overview header: assigning
            modules and working them are two halves of the same task. */}
        <div className="section-head" style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>Module Assignments</span>
          <button className="btn btn-sm btn-primary" onClick={() => navigate(`/admin/clients/${id}/modules`)}>
            Open Client Modules →
          </button>
        </div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Modules control what {client.name} sees in their portal sidebar and dashboard.
            Check the modules they should have access to. Deactivated modules don't appear here even if previously assigned.
          </p>

          {clientModules.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888' }}>
              No active modules in the catalog. Add modules under <strong>Admin &rarr; Modules</strong> first.
            </p> :

          <div style={{
            display: 'grid', gap: 8,
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            marginBottom: 16
          }}>
              {clientModules.map((m) => {
              const isSelected = selected.has(m.id);
              return (
                <label key={m.id}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: 10,
                  padding: 12, border: `1px solid ${isSelected ? '#0F1838' : '#ddd'}`,
                  borderRadius: 4, cursor: 'pointer',
                  background: isSelected ? '#F0F2F8' : '#fafafa',
                  fontFamily: 'Arial, sans-serif', fontSize: 13
                }}>
                    <input type="checkbox"
                  checked={isSelected}
                  onChange={() => toggleClientModule(m.id)}
                  style={{ marginTop: 2 }} />
                  
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 500, color: '#0F1838' }}>{m.label}</div>
                      {m.description &&
                    <div style={{ color: '#888', fontSize: 11, marginTop: 2 }}>{m.description}</div>
                    }
                      <div style={{ marginTop: 4, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <span style={{
                        fontSize: 10, padding: '1px 6px', borderRadius: 3,
                        background: m.module_type === 'builtin' ? '#f0faf5' :
                        m.module_type === 'content_pdf' ? '#f0f4ff' : '#f5f0fa',
                        color: m.module_type === 'builtin' ? '#1a3a2a' :
                        m.module_type === 'content_pdf' ? '#2f5496' : '#5b3a8c',
                        fontWeight: 600
                      }}>
                          {m.module_type === 'builtin' ? 'Built-in' :
                        m.module_type === 'content_pdf' ? 'PDF' : 'Rich Text'}
                        </span>
                      </div>
                    </div>
                  </label>);

            })}
            </div>
          }

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <button className="btn btn-primary"
            onClick={handleSaveModules}
            disabled={!hasChanges || savingModules}>
              {savingModules ? 'Saving...' : hasChanges ? `Save (${selected.size} selected)` : 'No changes'}
            </button>
            {hasChanges &&
            <button className="btn" onClick={() => setModuleEdits(null)} disabled={savingModules}>
                Discard
              </button>
            }
            <div style={{ flex: 1 }} />
            <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#888' }}>
              {selected.size} of {clientModules.length} module{clientModules.length === 1 ? '' : 's'} selected
            </span>
          </div>
        </div>

        <div className="section-head">Apply Case-Type Template</div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 12 }}>
            Reset this client's module set to match a case-type template.
            {currentCaseTypeLabel && <> Their current case type is <strong>{currentCaseTypeLabel}</strong>.</>}{' '}
            This <strong>overwrites</strong> the assignments above — any per-client customizations will be lost.
            It does not change the case type itself; update that from the <strong>Profile</strong> tab if needed.
          </p>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            {/* pkg68a — same Practice Area → Case Type cascade as the Profile tab */}
            <select
              value={applyTemplatePA}
              onChange={(e) => {
                setApplyTemplatePA(e.target.value);
                setApplyTemplateId(''); // a new area invalidates the old pick
              }}
              style={{ minWidth: 200, maxWidth: 280 }}
              disabled={applyingTemplate}>
              <option value="">— Select practice area —</option>
              {areaOptions.map((pa) => <option key={pa.key} value={pa.key}>{pa.label}</option>)}
            </select>
            <select
              value={applyTemplateId}
              onChange={(e) => setApplyTemplateId(e.target.value)}
              style={{ minWidth: 280, maxWidth: 400 }}
              disabled={applyingTemplate || !applyTemplatePA}>
              <option value="">
                {applyTemplatePA ? '— Select a case type to apply —' : '— Pick a practice area first —'}
              </option>
              {caseTypes.
              filter((ct) => ct.practice_area === applyTemplatePA).
              map((ct) =>
              <option key={ct.id} value={ct.id}>
                  {ct.label} ({(ct.module_ids || []).length} modules)
                </option>
              )}
            </select>
            <button className="btn"
            onClick={handleApplyTemplate}
            disabled={!applyTemplateId || applyingTemplate}>
              {applyingTemplate ? 'Applying...' : 'Apply Template'}
            </button>
          </div>
        </div>
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // CASE STATUS — close / settle / reopen actions
  // ═══════════════════════════════════════════════════════════════════════════
  //
  // Rendered inside the Profile tab. Buttons available depend on current
  // case_status:
  //   active  → "Close Case" (with two-step confirmation)
  //   closed  → "Mark as Settled" + "Reopen Case"
  //   settled → "Reopen Case"
  //
  // Each destructive-looking action uses the existing two-step pattern
  // (caseStatusBusy + confirmCaseAction) so a misclick never silently
  // changes state. Reopen is included in confirm flow even though it's
  // recoverable, because re-activating a finished case can affect dropdown
  // visibility throughout the app.

  function renderCaseStatusSection() {
    const status = client.case_status || 'active';
    const SIX_MONTHS_MS = 1000 * 60 * 60 * 24 * 183;
    const closed = client.closed_at ? new Date(client.closed_at).getTime() : null;
    const portalExpired = closed && Number.isFinite(closed) && Date.now() - closed > SIX_MONTHS_MS;

    const blurb = status === 'active' ?
    'Active. Appears in All Clients and every dropdown picker. Closing the case moves it to Closed Files and hides it from pickers; outstanding invoices remain available.' :
    status === 'closed' ?
    `Closed${client.closed_at ? ' on ' + new Date(client.closed_at).toLocaleDateString() : ''}. Hidden from All Clients and operational pickers. Billing tab stays fully operational so outstanding invoices can still be sent and paid. Client portal access ${portalExpired ? 'has expired' : 'expires 6 months from the close date'}.` :
    `Settled${client.settled_at ? ' on ' + new Date(client.settled_at).toLocaleDateString() : ''}. Fully wrapped up — case work and billing both complete. Reopen the case to make any further changes.`;

    return (
      <>
        <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
          <strong style={{ textTransform: 'capitalize' }}>{status}</strong> &mdash; {blurb}
        </p>

        {/* Action buttons */}
        {!confirmCaseAction &&
        <div className="btn-row">
            {status === 'active' &&
          <button className="btn" style={{ borderColor: '#d68910', color: '#d68910' }}
          onClick={() => setConfirmCaseAction('close')}>
                Close Case
              </button>
          }
            {status === 'closed' &&
          <>
                <button className="btn" style={{ borderColor: '#1a7a5e', color: '#1a7a5e' }}
            onClick={() => setConfirmCaseAction('settle')}>
                  Mark as Settled
                </button>
                <button className="btn"
            onClick={() => setConfirmCaseAction('reopen')}>
                  Reopen Case
                </button>
              </>
          }
            {status === 'settled' &&
          <button className="btn"
          onClick={() => setConfirmCaseAction('reopen')}>
                Reopen Case
              </button>
          }
          </div>
        }

        {/* Two-step confirmation */}
        {confirmCaseAction === 'close' &&
        <div style={{ padding: 12, border: '1px solid #f5c98e', borderRadius: 4, background: '#fdf2e7' }}>
            <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#7a5800', marginTop: 0, marginBottom: 12 }}>
              Close this case? {client.name} will move to Closed Files,
              disappear from operational dropdowns, and keep client portal access for the next 6 months.
              Outstanding invoices and billing will remain fully operational.
            </p>
            <div className="btn-row">
              <button className="btn" onClick={() => setConfirmCaseAction(null)} disabled={!!caseStatusBusy}>Cancel</button>
              <button className="btn"
            style={{ background: '#d68910', color: '#fff', borderColor: '#d68910' }}
            onClick={() => handleCaseAction('close')}
            disabled={!!caseStatusBusy}>
                {caseStatusBusy === 'close' ? 'Closing...' : 'Yes, Close Case'}
              </button>
            </div>
          </div>
        }

        {confirmCaseAction === 'settle' &&
        <div style={{ padding: 12, border: '1px solid #b8e3cf', borderRadius: 4, background: '#e8f7ef' }}>
            <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#1a7a5e', marginTop: 0, marginBottom: 12 }}>
              Mark this case as <strong>settled</strong>? This is the second-tier close used after the final invoice
              has been paid. The billing tab will become read-only. The 6-month client portal window keeps
              running from the original close date{client.closed_at ? ' (' + new Date(client.closed_at).toLocaleDateString() + ')' : ''}.
            </p>
            <div className="btn-row">
              <button className="btn" onClick={() => setConfirmCaseAction(null)} disabled={!!caseStatusBusy}>Cancel</button>
              <button className="btn"
            style={{ background: '#1E2761', color: '#fff', borderColor: '#1E2761' }}
            onClick={() => handleCaseAction('settle')}
            disabled={!!caseStatusBusy}>
                {caseStatusBusy === 'settle' ? 'Saving...' : 'Yes, Mark as Settled'}
              </button>
            </div>
          </div>
        }

        {confirmCaseAction === 'reopen' &&
        <div style={{ padding: 12, border: '1px solid #bcd4ee', borderRadius: 4, background: '#e8f0fb' }}>
            <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#2f5496', marginTop: 0, marginBottom: 12 }}>
              Reopen this case? {client.name} will return to the active client
              list, appear in operational dropdowns again, and get fresh portal access (the close
              timestamp will be cleared, restarting the 6-month window if the case is ever closed again).
            </p>
            <div className="btn-row">
              <button className="btn" onClick={() => setConfirmCaseAction(null)} disabled={!!caseStatusBusy}>Cancel</button>
              <button className="btn btn-primary"
            onClick={() => handleCaseAction('reopen')}
            disabled={!!caseStatusBusy}>
                {caseStatusBusy === 'reopen' ? 'Reopening...' : 'Yes, Reopen Case'}
              </button>
            </div>
          </div>
        }
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // CONFLICTS TAB — Show prior conflict checks tied to this client. The
  // ConflictChecksPanel component handles its own loading, the disclaimer,
  // and the expand-to-view-details interaction. The "Run new check" button
  // opens the standalone Conflict Check tool with this client pre-selected.
  // ═══════════════════════════════════════════════════════════════════════════

  function renderConflicts() {
    return (
      <ConflictChecksPanel
        clientId={id}
        onRunNew={() => navigate(`/admin/dashboard/conflict-check?clientId=${id}`)}
      />
    );
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // PROFILE TAB — edit client info, send welcome, reset password, delete
  // ═══════════════════════════════════════════════════════════════════════════

  function renderProfile() {
    return (
      <>
        <div className="section-head">Client Information</div>
        <div className="card">
          <form onSubmit={handleSaveInfo}>
            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} required />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" value={editPhone} onChange={(e) => setEditPhone(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Display Name</label>
                <input type="text" value={editUsername}
                onChange={(e) => setEditUsername(e.target.value)}
                placeholder="Optional nickname or display label" />
              </div>
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" value={editEmail} onChange={(e) => setEditEmail(e.target.value)} required />
            </div>
            {/* pkg68a — Practice Area → Case Type cascade. The area select is a
                UI filter only (never persisted); "— No case type —" lives on the
                area select and clears both halves. */}
            <div className="form-group">
              <label>Practice Area</label>
              <select
                value={editPracticeArea}
                onChange={(e) => {
                  const next = e.target.value;
                  setEditPracticeArea(next);
                  // Changing area invalidates any pending case-type pick; '' is
                  // the explicit clear signal the backend honors (pkg67b).
                  setEditCaseType('');
                }}>
                <option value="">— No case type —</option>
                {areaOptions.map((pa) => <option key={pa.key} value={pa.key}>{pa.label}</option>)}
              </select>
            </div>
            {editPracticeArea && (
              <div className="form-group">
                <label>Case Type</label>
                <select value={editCaseType} onChange={(e) => setEditCaseType(e.target.value)}>
                  <option value="">— Select case type —</option>
                  {caseTypes.
                  filter((ct) => ct.practice_area === editPracticeArea).
                  map((ct) => <option key={ct.key} value={ct.key}>{ct.label}</option>)}
                </select>
                {!editCaseType && (
                  <p style={{ fontSize: 12, color: '#8a6d3b', margin: '6px 0 0' }}>
                    No case type selected yet — saving now stores this client with no case type.
                  </p>
                )}
              </div>
            )}
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </form>
        </div>

        <AccessRestrictionsPanel clientId={id} clientName={client && client.name} />

        <div className="section-head">Send Welcome Email</div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Send the client a welcome email with their portal credentials. Enter their current temporary password
            so it can be included in the email. Only use this if email interception is not a concern.
          </p>
          <form onSubmit={handleSendWelcome}>
            <div className="form-group">
              <label>Their Current Temporary Password</label>
              <input type="text" value={welcomePassword} onChange={(e) => setWelcomePassword(e.target.value)}
              placeholder="Enter the temp password to include in the email" />
            </div>
            <button type="submit" className="btn" disabled={sendingWelcome}>
              {sendingWelcome ? 'Sending...' : `Send Welcome Email to ${client.email}`}
            </button>
          </form>
        </div>

        <div className="section-head">Reset Password</div>
        <div className="card">
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Set a new temporary password. The client will be required to change it on next login.
            Deliver the new password directly — in person or by phone.
          </p>
          <form onSubmit={handleResetPassword}>
            <div className="form-group">
              <label>New Temporary Password</label>
              <input type="text" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
              placeholder="e.g. River7742!" required />
            </div>
            <button type="submit" className="btn" disabled={resetting}>
              {resetting ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>

        <div className="section-head">Case Status</div>
        <div className="card">
          {renderCaseStatusSection()}
        </div>

        <div className="danger-zone">
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, fontWeight: 600, color: '#B85042', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>
            Danger Zone
          </div>
          <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginTop: 0, marginBottom: 16 }}>
            Permanently delete this client's account and all their submitted data. This cannot be undone.
          </p>
          {!confirmDelete ?
          <button className="btn" style={{ borderColor: '#B85042', color: '#B85042' }}
          onClick={() => setConfirmDelete(true)}>
              Delete Account
            </button> :

          <div>
              <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#B85042', marginBottom: 12 }}>
                Are you sure? This will permanently delete {client.name}'s account and all their data.
              </p>
              <div className="btn-row">
                <button className="btn" style={{ background: '#B85042', color: '#fff', borderColor: '#B85042' }}
              onClick={handleDelete} disabled={deleting}>
                  {deleting ? 'Deleting...' : 'Yes, Delete Permanently'}
                </button>
                <button className="btn" onClick={() => setConfirmDelete(false)}>Cancel</button>
              </div>
            </div>
          }
        </div>
      </>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // PHASE 2 — Payments section + modal renderers
  // ═══════════════════════════════════════════════════════════════════════════

  function renderPaymentsSection() {
    const allocSum = paymentAllocSum();
    const amt = parseFloat(paymentForm.amount) || 0;
    const remaining = +(amt - allocSum).toFixed(2);
    const shownPayments = (paymentAccount && accountRows)
      ? accountRows
      : payments.filter((p) => !paymentAccount || p.deposit_account === paymentAccount);

    return (
      <>
        <div id="billing-section-payments" className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>
            Payments{' '}
            <span style={{ fontSize: 12, fontWeight: 400, color: '#888', marginLeft: 6 }}>
              ({payments.length} on file{availableCredit > 0 ? ` · ${fmtMoneyShort(availableCredit)} unapplied` : ''})
            </span>
          </span>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#555', display: 'flex', alignItems: 'center', gap: 6 }}>
              Account
              <select value={paymentAccount} onChange={(e) => { setPaymentAccount(e.target.value); setAccountRows(null); }}
                style={{ fontSize: 13, padding: '4px 6px' }}>
                <option value="">All</option>
                <option value="operating">Operating</option>
                <option value="trust">Trust</option>
              </select>
            </label>
            {!recordingPayment &&
            <button className="btn btn-sm btn-primary" onClick={handleOpenRecordPayment}>
                + Record Payment
              </button>
            }
          </div>
        </div>

        <div className="card">
          {availableCredit > 0 &&
          <div style={{
            background: '#e8f7ef', border: '1px solid #b8e3cf', borderRadius: 4,
            padding: '8px 12px', marginBottom: 12, fontFamily: 'Arial, sans-serif', fontSize: 13
          }}>
              <strong style={{ color: '#1a7a5e' }}>Unapplied credit on file: {fmtMoneyShort(availableCredit)}.</strong>
              {' '}Apply it to an outstanding invoice from any payment row below.
            </div>
          }

          {/* Record-payment form */}
          {recordingPayment &&
          <form onSubmit={handleCreatePayment} style={{
            background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6,
            padding: 16, marginBottom: 16
          }}>
              <div className="form-row">
                <div className="form-group" style={{ flex: '0 0 160px' }}>
                  <label>Payment Date</label>
                  <input type="date" value={paymentForm.payment_date}
                onChange={(e) => setPaymentForm((p) => ({ ...p, payment_date: e.target.value }))} required />
                </div>
                <div className="form-group" style={{ flex: '0 0 180px' }}>
                  <label>Method</label>
                  <select value={paymentForm.method}
                onChange={(e) => setPaymentForm((p) => ({ ...p, method: e.target.value }))}>
                    {PAYMENT_METHODS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{ flex: '0 0 140px' }}>
                  <label>Amount ($)</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0.01" step="0.01" value={paymentForm.amount}
                onChange={(e) => setPaymentForm((p) => ({ ...p, amount: e.target.value }))}
                placeholder="0.00" required />
                </div>
                <div className="form-group" style={{ flex: '0 0 180px' }}>
                  <label>Deposit Account</label>
                  <select value={paymentForm.deposit_account}
                onChange={(e) => setPaymentForm((p) => ({ ...p, deposit_account: e.target.value }))}>
                    {DEPOSIT_ACCOUNTS.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>{METHOD_REF_LABELS[paymentForm.method] || 'Reference'} <span style={{ fontWeight: 400, color: '#888' }}>(optional)</span></label>
                  <input type="text" value={paymentForm.reference_number}
                onChange={(e) => setPaymentForm((p) => ({ ...p, reference_number: e.target.value }))}
                placeholder={`e.g. ${paymentForm.method === 'check' ? '4521' : 'TXN-1234567'}`} />
                </div>
                <div className="form-group">
                  <label>Payor <span style={{ fontWeight: 400, color: '#888' }}>(optional — third-party payor)</span></label>
                  <input type="text" value={paymentForm.payor}
                onChange={(e) => setPaymentForm((p) => ({ ...p, payor: e.target.value }))}
                placeholder="Leave blank if paid by client" />
                </div>
                <div className="form-group" style={{ flex: '0 0 160px' }}>
                  <label>Status</label>
                  <select value={paymentForm.status}
                onChange={(e) => setPaymentForm((p) => ({ ...p, status: e.target.value }))}>
                    <option value="cleared">Cleared</option>
                    <option value="pending">Pending (e.g. uncashed check)</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Memo / Notes <span style={{ fontWeight: 400, color: '#888' }}>(optional)</span></label>
                <input type="text" value={paymentForm.memo}
              onChange={(e) => setPaymentForm((p) => ({ ...p, memo: e.target.value }))}
              placeholder="Internal note about this payment" />
              </div>

              {/* Allocation grid */}
              <div style={{ marginTop: 8, marginBottom: 8 }}>
                <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                flexWrap: 'wrap', gap: 8, marginBottom: 6
              }}>
                  <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, fontWeight: 600 }}>
                    Apply to Invoices
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <button type="button" className="btn btn-sm" onClick={handleAutoAllocateFIFO}
                  disabled={!amt || amt <= 0 || paymentOutstanding.length === 0}>
                      Auto-allocate (FIFO)
                    </button>
                    <button type="button" className="btn btn-sm" onClick={handleClearAllocations}
                  disabled={Object.keys(paymentAllocations).length === 0}>
                      Clear
                    </button>
                  </div>
                </div>

                {paymentOutstanding.length === 0 ?
              <div style={{
                padding: 12, border: '1px dashed #ddd', borderRadius: 4,
                fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888'
              }}>
                    No outstanding invoices. The full payment amount will be held as unapplied client credit.
                  </div> :

              <div className="table-wrap">
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                      <thead>
                        <tr style={{ background: '#0F1838', color: '#fff' }}>
                          <th style={{ padding: '6px 10px', textAlign: 'left', width: 90 }}>Invoice</th>
                          <th style={{ padding: '6px 10px', textAlign: 'left', width: 110 }}>Issued</th>
                          <th style={{ padding: '6px 10px', textAlign: 'left', width: 110 }}>Due</th>
                          <th style={{ padding: '6px 10px', textAlign: 'right', width: 100 }}>Total</th>
                          <th style={{ padding: '6px 10px', textAlign: 'right', width: 110 }}>Balance</th>
                          <th style={{ padding: '6px 10px', textAlign: 'right', width: 130 }}>Apply ($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentOutstanding.map((inv, i) => {
                      const bal = parseFloat(inv.balance_due) || 0;
                      const v = paymentAllocations[inv.id] || '';
                      return (
                        <tr key={inv.id} style={{ borderBottom: '1px solid #eee', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                              <td style={{ padding: '6px 10px', fontWeight: 600 }}>#{inv.invoice_number}</td>
                              <td style={{ padding: '6px 10px', color: '#555' }}>{fmtIsoDate(inv.issue_date)}</td>
                              <td style={{ padding: '6px 10px', color: '#555' }}>{fmtIsoDate(inv.due_date)}</td>
                              <td style={{ padding: '6px 10px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtMoneyShort(inv.total)}</td>
                              <td style={{ padding: '6px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>{fmtMoneyShort(bal)}</td>
                              <td style={{ padding: '6px 10px', textAlign: 'right' }}>
                                <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" step="0.01" max={bal}
                            value={v}
                            onChange={(e) => handleAllocationChange(inv.id, e.target.value)}
                            placeholder="0.00"
                            style={{ width: 100, padding: '4px 6px', border: '1px solid #ddd', borderRadius: 3, fontSize: 12, textAlign: 'right', fontFamily: 'monospace' }} />
                              </td>
                            </tr>);

                    })}
                      </tbody>
                      <tfoot>
                        <tr style={{ background: '#f0f0f0', borderTop: '2px solid #ccc' }}>
                          <td colSpan={4} style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 600 }}>Allocated</td>
                          <td style={{ padding: '8px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>{fmtMoneyShort(allocSum)}</td>
                          <td style={{ padding: '8px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600,
                        color: remaining < 0 ? '#B85042' : remaining > 0 ? '#1a7a5e' : '#0F1838' }}>
                            {amt > 0 ? `${remaining < 0 ? 'over by ' : 'unapplied '}${fmtMoneyShort(Math.abs(remaining))}` : ''}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
              }
              </div>

              <div className="btn-row" style={{ marginTop: 12 }}>
                <button type="button" className="btn" onClick={handleClosePaymentForm} disabled={savingPayment}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={savingPayment || !paymentForm.amount}>
                  {savingPayment ? 'Recording...' : `Record ${paymentForm.amount ? fmtMoneyShort(paymentForm.amount) + ' ' : ''}Payment`}
                </button>
              </div>
            </form>
          }

          {/* Payments table */}
          {shownPayments.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              {payments.length === 0 ? 'No payments recorded yet for this client.' : 'No payments in this account.'}
            </p> :

          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 110 }}>Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 130 }}>Method</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 110 }}>Account</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left' }}>Reference / Payor</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Amount</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Applied</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Unapplied</th>
                    <th style={{ padding: '7px 10px', textAlign: 'center', width: 100 }}>Status</th>
                    <th style={{ padding: '7px 10px', width: 30 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {shownPayments.map((p, i) => {
                  const expanded = expandedPaymentId === p.id;
                  const applied = parseFloat(p.applied_total) || 0;
                  const refunded = parseFloat(p.refunded_total) || 0;
                  const unapplied = parseFloat(p.unapplied) || 0;
                  // Wave 2: backend computes is_reversed from active reversal
                  // rows OR legacy status='reversed'. We honor either form.
                  const isReversed = !!p.is_reversed || p.status === 'reversed';
                  const isVoided   = p.status === 'voided';
                  // Disabled means "no edit/refund/reverse buttons" — covers
                  // reversed, voided, and refunded-in-full.
                  const isDisabled = isReversed || isVoided || p.status === 'refunded';
                  // Active reversals/refunds (cleared, not voided)
                  const activeReversals = (p.reversals || []).filter((r) => r.status === 'cleared');
                  const activeRefunds   = (p.refunds   || []).filter((r) => r.status === 'cleared');
                  return (
                    <React.Fragment key={p.id}>
                        <tr
                        onClick={() => setExpandedPaymentId(expanded ? null : p.id)}
                        style={{
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                          background: isVoided ? '#fdf0ec' : i % 2 === 0 ? '#fff' : '#fafafa',
                          opacity: isReversed || isVoided ? 0.65 : 1
                        }}>
                        
                          <td style={{ padding: '7px 10px', whiteSpace: 'nowrap' }}>{fmtIsoDate(p.payment_date)}</td>
                          <td style={{ padding: '7px 10px' }}>
                            {methodLabel(p.method)}
                          </td>
                          <td style={{ padding: '7px 10px' }}>
                            <AccountBadge account={p.deposit_account} />
                          </td>
                          <td style={{ padding: '7px 10px', color: '#555', fontSize: 12 }}>
                            {p.reference_number ? <span style={{ fontFamily: 'monospace' }}>{p.reference_number}</span> : <span style={{ color: '#ccc' }}>—</span>}
                            {p.payor && <div style={{ fontSize: 11, color: '#888', marginTop: 1 }}>from {p.payor}</div>}
                          </td>
                          <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>
                            {fmtMoneyShort(p.amount)}
                          </td>
                          <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', color: applied > 0 ? '#0F1838' : '#aaa' }}>
                            {applied > 0 ? fmtMoneyShort(applied) : '—'}
                          </td>
                          <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', color: unapplied > 0.001 ? '#1a7a5e' : '#aaa', fontWeight: unapplied > 0.001 ? 600 : 400 }}>
                            {unapplied > 0.001 ? fmtMoneyShort(unapplied) : '—'}
                          </td>
                          <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                            <PayStatusBadge status={p.status} label={paymentStatusLabel(p)} />
                          </td>
                          <td style={{ padding: '7px 10px', textAlign: 'center', color: '#888', fontSize: 11, whiteSpace: 'nowrap' }} onClick={(ev) => ev.stopPropagation()}>
                            {isOwner && paymentCanBeRefunded(p) && (
                              <button type="button" className="btn btn-sm" style={{ borderColor: '#b7870a', color: '#b7870a', marginRight: 6 }}
                                onClick={() => openRefundModal(p)}>
                                Refund
                              </button>
                            )}
                            <span style={{ cursor: 'pointer' }} onClick={() => setExpandedPaymentId(expanded ? null : p.id)}>{expanded ? '▾' : '▸'}</span>
                          </td>
                        </tr>

                        {expanded &&
                      <tr style={{ background: '#fafafa', borderBottom: '1px solid #eee' }}>
                            <td colSpan={9} style={{ padding: '12px 14px' }}>
                              {/* Reversed banner */}
                              {isReversed && p.reversed_reason &&
                          <div style={{
                            background: '#fdf0ec', border: '1px solid #f5c6c3',
                            borderRadius: 4, padding: '8px 12px', marginBottom: 10,
                            fontFamily: 'Arial, sans-serif', fontSize: 13
                          }}>
                                  <strong style={{ color: '#B85042' }}>Reversed:</strong> {p.reversed_reason}
                                  {p.reversed_at && <span style={{ color: '#888', marginLeft: 8 }}>· {fmtIsoDate(p.reversed_at)}</span>}
                                </div>
                          }
                              {/* Wave 2: Voided banner. Shown when an admin
                                  soft-void-deleted this payment. The detail
                                  message tells the admin who did it & why so
                                  there's no mystery about its state. */}
                              {isVoided &&
                          <div style={{
                            background: '#f3f3f3', border: '1px solid #d6d6d6',
                            borderRadius: 4, padding: '8px 12px', marginBottom: 10,
                            fontFamily: 'Arial, sans-serif', fontSize: 13
                          }}>
                                  <strong style={{ color: '#666' }}>Voided (deleted):</strong> {p.voided_reason || 'no reason given'}
                                  {p.voided_at && <span style={{ color: '#888', marginLeft: 8 }}>· {fmtIsoDate(p.voided_at)}</span>}
                                  {p.voided_by_name && <span style={{ color: '#888', marginLeft: 8 }}>· by {p.voided_by_name}</span>}
                                  <div style={{ color: '#888', marginTop: 4, fontSize: 12 }}>
                                    This payment is hidden from client-facing invoices and receipts and does not count toward balances.
                                  </div>
                                </div>
                          }

                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, fontFamily: 'Arial, sans-serif', fontSize: 12 }}>
                                <div>
                                  <div style={{ color: '#888', textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.04em', marginBottom: 4 }}>Details</div>
                                  <div>Recorded by <strong>{p.created_by_name || 'Unknown'}</strong> on {fmtIsoDate(p.created_at)}</div>
                                  {p.memo && <div style={{ marginTop: 4 }}><strong>Memo:</strong> {p.memo}</div>}
                                  {(parseInt(p.sent_count) || 0) > 0 &&
                              <div style={{ marginTop: 4, color: '#1a7a5e' }}>
                                      ✓ Receipt emailed {parseInt(p.sent_count) === 1 ? 'once' : `${p.sent_count} times`}
                                      {p.last_sent_at && <> · last on {fmtIsoDate(p.last_sent_at)}</>}
                                    </div>
                              }
                                </div>
                                <div>
                                  <div style={{ color: '#888', textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.04em', marginBottom: 4 }}>Summary</div>
                                  <div style={{ fontFamily: 'monospace' }}>
                                    Amount: {fmtMoneyShort(p.amount)}<br />
                                    Applied to invoices: {fmtMoneyShort(applied)}<br />
                                    Refunded: {fmtMoneyShort(refunded)}<br />
                                    <strong>Unapplied: {fmtMoneyShort(unapplied)}</strong>
                                  </div>
                                </div>
                              </div>

                              {/* Allocations */}
                              {(p.allocations || []).length > 0 &&
                          <div style={{ marginTop: 12 }}>
                                  <div style={{ color: '#888', textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.04em', marginBottom: 4, fontFamily: 'Arial, sans-serif' }}>Applied to</div>
                                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>
                                    <thead>
                                      <tr style={{ background: '#eee', color: '#0F1838' }}>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 90 }}>Invoice</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 110 }}>Issued</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'right', width: 100 }}>Applied</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'right', width: 110 }}>Inv Balance</th>
                                        <th style={{ padding: '5px 8px', width: 80 }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {p.allocations.map((a) =>
                                <tr key={a.id} style={{ borderBottom: '1px solid #eee' }}>
                                          <td style={{ padding: '5px 8px' }}>
                                            <button onClick={(ev) => {ev.stopPropagation();navigate(`/admin/dashboard/invoices/${a.invoice_id}`);}}
                                    style={{ background: 'none', border: 'none', color: '#2f5496', cursor: 'pointer', padding: 0, fontWeight: 600, fontSize: 12 }}>
                                              #{a.invoice_number}
                                            </button>
                                          </td>
                                          <td style={{ padding: '5px 8px', color: '#555' }}>{fmtIsoDate(a.invoice_issue_date)}</td>
                                          <td style={{ padding: '5px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtMoneyShort(a.amount)}</td>
                                          <td style={{ padding: '5px 8px', textAlign: 'right', fontFamily: 'monospace', color: '#555' }}>{fmtMoneyShort(a.invoice_balance_due)}</td>
                                          <td style={{ padding: '5px 8px', textAlign: 'right' }}>
                                            {!isReversed &&
                                    <button onClick={(ev) => {ev.stopPropagation();handleRemoveAllocation(p.id, a.id);}}
                                    style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11 }}>
                                                Un-apply
                                              </button>
                                    }
                                          </td>
                                        </tr>
                                )}
                                    </tbody>
                                  </table>
                                </div>
                          }

                              {/* Refunds (Wave 2: editable + soft-void deletable;
                                  voided refunds shown in muted style for audit) */}
                              {listRefunds(p).length > 0 &&
                          <div style={{ marginTop: 12 }}>
                                  <div style={{ color: '#888', textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.04em', marginBottom: 4, fontFamily: 'Arial, sans-serif' }}>Refunds</div>
                                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>
                                    <thead>
                                      <tr style={{ background: '#eee', color: '#0F1838' }}>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 110 }}>Date</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 130 }}>Method</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left' }}>Reverses</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left' }}>Reason / Reference</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'right', width: 100 }}>Amount</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 100 }}>Status</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'center', width: 110 }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {listRefunds(p).map((r) => {
                                        const rVoided = r.status === 'voided';
                                        return (
                                <tr key={r.id} style={{ borderBottom: '1px solid #eee', opacity: rVoided ? 0.55 : 1, background: rVoided ? '#fafafa' : 'transparent' }}>
                                          <td style={{ padding: '5px 8px' }}>{fmtIsoDate(refundWhen(r))}</td>
                                          <td style={{ padding: '5px 8px' }}>{r.method ? methodLabel(r.method) : '—'}</td>
                                          <td style={{ padding: '5px 8px', color: '#555' }}>{refundInvoiceText(r) || '—'}</td>
                                          <td style={{ padding: '5px 8px', color: '#555' }}>
                                            {rVoided &&
                                              <span style={{ display: 'inline-block', marginRight: 6, padding: '1px 6px', borderRadius: 3, background: '#f3f3f3', color: '#666', border: '1px solid #d6d6d6', fontSize: 10, fontWeight: 600 }}>
                                                VOIDED
                                              </span>
                                            }
                                            {r.reason || ''}{r.reason && r.reference_number ? ' · ' : ''}{r.reference_number ? <span style={{ fontFamily: 'monospace' }}>{r.reference_number}</span> : ''}
                                            {!r.reason && !r.reference_number && !rVoided && <span style={{ color: '#ccc' }}>—</span>}
                                            {rVoided && r.voided_reason && <span style={{ color: '#888', display: 'block', fontSize: 11, marginTop: 2 }}>Void reason: {r.voided_reason}</span>}
                                          </td>
                                          <td style={{ padding: '5px 8px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600, textDecoration: rVoided ? 'line-through' : 'none' }}>{refundAmount(r) == null ? '—' : fmtMoneyShort(refundAmount(r))}</td>
                                          <td style={{ padding: '5px 8px' }}>{rVoided ? <span style={{ color: '#aaa', fontSize: 10 }}>—</span> : <RefundStatusBadge status={r.status} />}</td>
                                          <td style={{ padding: '5px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                            {rVoided ?
                                              <span style={{ color: '#aaa', fontSize: 10 }}>—</span> :
                                              <>
                                                <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openEditRefundModal(p, r);}}
                                                  style={{ padding: '2px 8px', fontSize: 11, marginRight: 4 }}>Edit</button>
                                                <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openDeleteRefundModal(p, r);}}
                                                  style={{ padding: '2px 8px', fontSize: 11, borderColor: '#B85042', color: '#B85042' }}>Del</button>
                                              </>
                                            }
                                          </td>
                                        </tr>);
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                          }

                              {/* Reversals (Wave 2: each reversal is a first-class
                                  row with edit + soft-void delete. The expanded
                                  Reversed banner above shows the latest one;
                                  this table is the full audit trail.) */}
                              {(p.reversals || []).length > 0 &&
                          <div style={{ marginTop: 12 }}>
                                  <div style={{ color: '#888', textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.04em', marginBottom: 4, fontFamily: 'Arial, sans-serif' }}>Reversals</div>
                                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>
                                    <thead>
                                      <tr style={{ background: '#eee', color: '#0F1838' }}>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 110 }}>Date</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left', width: 130 }}>Method / Ref</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'left' }}>Reason</th>
                                        <th style={{ padding: '5px 8px', textAlign: 'center', width: 110 }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {p.reversals.map((r) => {
                                        const rVoided = r.status === 'voided';
                                        return (
                                <tr key={r.id} style={{ borderBottom: '1px solid #eee', opacity: rVoided ? 0.55 : 1, background: rVoided ? '#fafafa' : 'transparent' }}>
                                          <td style={{ padding: '5px 8px' }}>{fmtIsoDate(r.reversal_date)}</td>
                                          <td style={{ padding: '5px 8px', color: '#555' }}>
                                            {r.method ? methodLabel(r.method) : <span style={{ color: '#ccc' }}>—</span>}
                                            {r.reference_number && <span style={{ fontFamily: 'monospace', display: 'block', fontSize: 11 }}>{r.reference_number}</span>}
                                          </td>
                                          <td style={{ padding: '5px 8px', color: '#555' }}>
                                            {rVoided &&
                                              <span style={{ display: 'inline-block', marginRight: 6, padding: '1px 6px', borderRadius: 3, background: '#f3f3f3', color: '#666', border: '1px solid #d6d6d6', fontSize: 10, fontWeight: 600 }}>
                                                VOIDED
                                              </span>
                                            }
                                            {r.reason}
                                            {rVoided && r.voided_reason && <span style={{ color: '#888', display: 'block', fontSize: 11, marginTop: 2 }}>Void reason: {r.voided_reason}</span>}
                                          </td>
                                          <td style={{ padding: '5px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                            {rVoided ?
                                              <span style={{ color: '#aaa', fontSize: 10 }}>—</span> :
                                              <>
                                                <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openEditReversalModal(p, r);}}
                                                  style={{ padding: '2px 8px', fontSize: 11, marginRight: 4 }}>Edit</button>
                                                <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openDeleteReversalModal(p, r);}}
                                                  style={{ padding: '2px 8px', fontSize: 11, borderColor: '#B85042', color: '#B85042' }}>Del</button>
                                              </>
                                            }
                                          </td>
                                        </tr>);
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                          }

                              {/* Action buttons (gated by isDisabled = isReversed || isVoided || refunded) */}
                              <div className="btn-row" style={{ marginTop: 14, flexWrap: 'wrap' }}>
                                {!isDisabled &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openPaymentEmailModal(p);}}>
                                    ✉ Email Receipt
                                  </button>
                            }
                                {!isVoided &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();handleDownloadReceipt(p);}}>
                                  ⬇ Download Receipt
                                </button>
                            }
                                {!isDisabled && unapplied > 0.001 && outstandingInvoices.length > 0 &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openApplyCreditModal(p);}}>
                                    Apply Credit
                                  </button>
                            }
                                {isOwner && paymentCanBeRefunded(p) &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openRefundModal(p);}}
                            style={{ borderColor: '#b7870a', color: '#b7870a' }}>
                                    Refund
                                  </button>
                            }
                                {!isDisabled &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openEditPaymentModal(p);}}>
                                    Edit
                                  </button>
                            }
                                {!isDisabled &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openReverseModal(p);}}
                            style={{ borderColor: '#B85042', color: '#B85042' }}>
                                    Reverse
                                  </button>
                            }
                                {/* Wave 2: soft-void delete. Available on any
                                    payment that isn't already voided (you can
                                    even delete a reversed payment if you need
                                    to scrub it from the books entirely). */}
                                {!isVoided &&
                            <button className="btn btn-sm" onClick={(ev) => {ev.stopPropagation();openDeletePaymentModal(p);}}
                            style={{ borderColor: '#B85042', color: '#B85042', background: '#fdf0ec' }}>
                                    Delete
                                  </button>
                            }
                              </div>
                              <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#888', marginTop: 8, marginBottom: 0 }}>
                                <strong>Edit</strong> changes cosmetic fields only (date, method, reference, memo, status pending↔cleared). To change the amount or allocations, reverse the payment and record a new one. <strong>Delete</strong> soft-voids the payment — it stays in admin history for the audit trail but is hidden from client-facing invoices and receipts.
                              </p>
                            </td>
                          </tr>
                      }
                      </React.Fragment>);

                })}
                </tbody>
              </table>
            </div>
          }
        </div>
      </>);

  }

  // ─── Modal renderers ──────────────────────────────────────────────────────

  function modalShellStyle() {
    return {
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
      padding: '40px 20px', overflow: 'auto'
    };
  }
  function modalCardStyle(maxWidth = 520) {
    return {
      background: '#fff', borderRadius: 6, width: '100%', maxWidth, padding: 24,
      boxShadow: '0 10px 40px rgba(0,0,0,0.3)', fontFamily: 'Arial, sans-serif'
    };
  }

  // ─────────────────────────────────────────────────────────────────────────
  // PHASE 3 — Trust ledger handlers + section renderer
  // ─────────────────────────────────────────────────────────────────────────

  // Open / close inline "Record Trust Transaction" form. Defaults to a deposit
  // dated today; user can switch type before submitting.
  function handleOpenRecordTrust() {
    setTrustForm({
      txn_date: new Date().toISOString().slice(0, 10),
      type: 'deposit',
      amount: '',
      description: '',
      payer_payee: '',
      reference_number: '',
      payment_method: '',
      bank_account: ''
    });
    setRecordingTrust(true);
  }
  function handleCancelRecordTrust() {
    setRecordingTrust(false);
    setSavingTrust(false);
  }

  async function handleSubmitTrust(e) {
    if (e && e.preventDefault) e.preventDefault();
    setError('');setSuccess('');

    const amtAbs = parseFloat(trustForm.amount);
    if (!isFinite(amtAbs) || amtAbs <= 0) {
      setError('Enter a positive amount.');
      return;
    }
    // Sign convention: deposit > 0; withdrawal/transfer < 0; adjustment user-signed.
    let signed;
    if (trustForm.type === 'deposit') {
      signed = amtAbs;
    } else if (trustForm.type === 'withdrawal' || trustForm.type === 'transfer_to_operating') {
      signed = -amtAbs;
    } else {
      // adjustment — accept user's amount sign as entered (negative if prefixed),
      // else keep positive.
      const raw = String(trustForm.amount).trim();
      signed = raw.startsWith('-') ? -amtAbs : amtAbs;
    }

    setSavingTrust(true);
    try {
      await adminApi.createTrustTransaction(id, {
        txn_date: trustForm.txn_date,
        type: trustForm.type,
        amount: signed,
        description: trustForm.description || undefined,
        payer_payee: trustForm.payer_payee || undefined,
        reference_number: trustForm.reference_number || undefined,
        payment_method: trustForm.payment_method || undefined,
        bank_account: trustForm.bank_account || undefined
      });
      setRecordingTrust(false);
      await refreshTrust();
      setSuccess('Trust transaction recorded.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingTrust(false);
    }
  }

  async function handleConfirmDeleteTrust(txnId) {
    setError('');setSuccess('');
    try {
      await adminApi.deleteTrustTransaction(txnId);
      setConfirmDeleteTrustId(null);
      await refreshTrust();
      setSuccess('Trust transaction deleted.');
    } catch (err) {
      setError(err.message);
      setConfirmDeleteTrustId(null);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // DISCOVERY TAB — lists every discovery response for this client.
  // The tab itself only renders if discoveryResponses.length > 0 (see the
  // dynamic TABS computation in the main return).
  // ─────────────────────────────────────────────────────────────────────────

  function renderDiscovery() {
    const STATUS_STYLES = {
      draft: { bg: '#fdf6e3', fg: '#b7870a', border: '#f0d68a', label: 'Draft' },
      visible_to_client: { bg: '#e8f0fb', fg: '#2f5496', border: '#bcd4ee', label: 'Client editing' },
      locked: { bg: '#e8f7ef', fg: '#1a7a5e', border: '#b8e3cf', label: 'Locked' }
    };

    function fmtDate(s) {
      if (!s) return '—';
      const d = new Date(s);
      if (isNaN(d.getTime())) return s;
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }

    const th = { padding: '8px 12px', textAlign: 'left', fontSize: 11, fontFamily: 'Arial, sans-serif', textTransform: 'uppercase', letterSpacing: '0.04em', color: '#fff', fontWeight: 600 };
    const td = { padding: '10px 12px', fontFamily: 'Arial, sans-serif', fontSize: 13 };

    return (
      <div>
        {/* Discovery Generator */}
        <div className="section-head">Generate Discovery</div>
        <div className="card">
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#555', marginTop: 0, marginBottom: 16 }}>
            Generate a First Set of Interrogatories and Requests for Production pre-filled with case information.
            The document downloads immediately as a Word file ready to edit and serve.
          </p>

          {discoverySetOptions.length > 0 && (
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label>Discovery Set</label>
              <select
                value={selectedDiscoverySetId}
                onChange={(e) => setSelectedDiscoverySetId(e.target.value)}
              >
                {!autoDiscoverySetId && (
                  <option value="">Built-in family-law set (no custom set matched)</option>
                )}
                {discoverySetOptions.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.variant_label}
                    {s.case_type_label ? ` — ${s.case_type_label}` : ''}
                    {` (${s.interrogatory_count} interrog. · ${s.rfp_count} RFP)`}
                    {s.is_default ? ' · default' : ''}
                  </option>
                ))}
              </select>
              <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#777', margin: '6px 0 0' }}>
                {selectedDiscoverySetId && selectedDiscoverySetId !== autoDiscoverySetId
                  ? 'Overriding the auto-selected set for this document.'
                  : (discoverySetReason === 'case_type'    ? 'Auto-selected for this case type — change if needed.'
                  :  discoverySetReason === 'practice_area' ? 'Auto-selected for this practice area — change if needed.'
                  :  discoverySetReason === 'firm_default'  ? "Using your firm's default set — change if needed."
                  :  'Auto-selected — change if needed.')}
              </p>
            </div>
          )}

          {docIsUploaded && (
            <div style={{ marginBottom: 4 }}>
              {docAuto.length > 0 && (
                <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#777', margin: '0 0 12px' }}>
                  Filled automatically from your records: {docAuto.join(', ')}.
                </p>
              )}
              {docFields.length === 0 ? (
                <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#555', margin: '0 0 8px' }}>
                  Your interrogatories and requests are kept exactly as written. Fill in the case details
                  below — the caption, title, &ldquo;To:&rdquo; block, signature, and certificate of service
                  are generated automatically.
                </p>
              ) : (
                <div className="form-row" style={{ flexWrap: 'wrap' }}>
                  {docFields.map((f) => (
                    <div className="form-group" key={f.token} style={{ flex: '1 1 220px' }}>
                      <label>{f.label}</label>
                      <input
                        type="text"
                        value={docVals[f.token] || ''}
                        onChange={(e) => setDocVals((v) => ({ ...v, [f.token]: e.target.value }))}
                        placeholder={`{{${f.token}}}`}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Plaintiff Full Name</label>
              <input type="text" value={discovery.plaintiff}
              onChange={(e) => setDiscovery((p) => ({ ...p, plaintiff: e.target.value }))}
              placeholder="e.g. John Robert Smith" />
            </div>
            <div className="form-group">
              <label>Defendant Full Name</label>
              <input type="text" value={discovery.defendant}
              onChange={(e) => setDiscovery((p) => ({ ...p, defendant: e.target.value }))}
              placeholder="e.g. Jane Ann Smith" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Court</label>
              <input type="text" value={discovery.court}
              onChange={(e) => setDiscovery((p) => ({ ...p, court: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Docket Number</label>
              <input type="text" value={discovery.docketNo}
              onChange={(e) => setDiscovery((p) => ({ ...p, docketNo: e.target.value }))}
              placeholder="e.g. 25-D-1234" />
            </div>
            <div className="form-group" style={{ flex: '0 0 100px' }}>
              <label>Division</label>
              <input type="text" value={discovery.division}
              onChange={(e) => setDiscovery((p) => ({ ...p, division: e.target.value }))}
              placeholder="e.g. IV" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Firm Represents</label>
              <select value={discovery.ryanRepresents}
              onChange={(e) => setDiscovery((p) => ({ ...p, ryanRepresents: e.target.value }))}>
                <option value="plaintiff">Plaintiff</option>
                <option value="defendant">Defendant</option>
              </select>
            </div>
            {!docIsUploaded && (
            <div className="form-group">
              <label>Case Involves Minor Children?</label>
              <select value={discovery.hasChildren ? 'yes' : 'no'}
              onChange={(e) => setDiscovery((p) => ({ ...p, hasChildren: e.target.value === 'yes' }))}>
                <option value="no">No — Standard Discovery</option>
                <option value="yes">Yes — Include Child Custody Questions</option>
              </select>
            </div>
            )}
          </div>

          {/* Attorney signature block selection */}
          <div className="form-group">
            <label>Attorneys on Signature Block</label>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#888', margin: '0 0 10px 0' }}>
              Select one or more attorneys to appear under the firm signature line. The signing attorney's name appears beneath the Certificate of Service "By:" line.
            </p>
            {discoveryAttorneys.length === 0 ?
            <div style={{ padding: 12, border: '1px dashed #ddd', borderRadius: 4, fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888' }}>
                No owners or attorneys are set up yet. Add them in Staff Management.
              </div> :

            <div style={{ border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden' }}>
                {discoveryAttorneys.map((a, i) => {
                const checked = discovery.attorneyIds.includes(a.id);
                const missingBar = !a.bar_number;
                const isSigning = discovery.signingAttorneyId === a.id;
                return (
                  <div key={a.id} style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '10px 12px',
                    borderBottom: i < discoveryAttorneys.length - 1 ? '1px solid #eee' : 'none',
                    background: i % 2 === 0 ? '#fff' : '#fafafa'
                  }}>
                      <input type="checkbox" checked={checked}
                    onChange={() => toggleDiscoveryAttorney(a.id)}
                    style={{ width: 16, height: 16, cursor: 'pointer' }} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, fontWeight: 500 }}>
                          {a.name}
                          <span style={{ marginLeft: 8, fontSize: 11, color: '#888', textTransform: 'capitalize', fontWeight: 400 }}>
                            ({a.role})
                          </span>
                        </div>
                        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: missingBar ? '#B85042' : '#888', marginTop: 2 }}>
                          {a.bar_number || '⚠ No bar number on file — cannot sign filings'}
                        </div>
                      </div>
                      {checked &&
                    <label style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', fontFamily: 'Arial, sans-serif', fontSize: 11, color: isSigning ? '#0F1838' : '#888' }}>
                          <input type="radio" name="signingAttorney"
                      checked={isSigning}
                      onChange={() => setDiscovery((p) => ({ ...p, signingAttorneyId: a.id }))} />
                          Signing
                        </label>
                    }
                    </div>);

              })}
              </div>
            }
          </div>
          <div className="form-group">
            <label>Opposing Counsel (for Certificate of Service)</label>
            {/* pkg166: multi-line — each line becomes its own line in the "To:" block and the Certificate of Service, exactly as typed. */}
            <textarea rows={5} value={discovery.opposingCounsel}
            onChange={(e) => setDiscovery((p) => ({ ...p, opposingCounsel: e.target.value }))}
            placeholder={'One line per line, e.g.\nJane Smith, Esq., BPR # 12345\nSmith Law, PLLC\n123 Main Street, Suite 100\nChattanooga, Tennessee 37402\njsmith@smithlaw.com'}
            style={{ fontFamily: 'inherit', whiteSpace: 'pre-wrap', resize: 'vertical' }} />
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              Press Enter for a new line. Appears line-for-line under &ldquo;To:&rdquo; and in the Certificate of Service.
            </div>
          </div>
          <button className="btn btn-primary" onClick={handleGenerateDiscovery} disabled={generatingDiscovery}>
            {generatingDiscovery ? <><span className="spinner" />Generating...</> : '⬇ Generate Discovery Document'}
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12, marginBottom: 12, marginTop: 8 }}>
          <div>
            <h2 className="section-head" style={{ marginTop: 0 }}>Discovery Responses</h2>
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#666', margin: 0 }}>
              Discovery documents uploaded for {client?.name}. Click a row to open the workspace.
            </p>
          </div>
          <button className="btn btn-primary"
          onClick={() => navigate(`/admin/dashboard/discovery-responses/new?clientId=${id}`)}>
            + New Discovery Response
          </button>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="table-wrap">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#0F1838' }}>
                  <th style={th}>Title</th>
                  <th style={{ ...th, width: 130 }}>Status</th>
                  <th style={{ ...th, width: 110, textAlign: 'right' }}>Questions</th>
                  <th style={{ ...th, width: 110, textAlign: 'right' }}>Approved</th>
                  <th style={{ ...th, width: 130 }}>Uploaded</th>
                </tr>
              </thead>
              <tbody>
                {discoveryResponses.length === 0 &&
                <tr>
                    <td colSpan={5} style={{ padding: '18px 12px', textAlign: 'center', fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888' }}>
                      No discovery uploaded yet for this client. Click "+ New Discovery Response" to parse a served PDF.
                    </td>
                  </tr>
                }
                {discoveryResponses.map((r, i) => {
                  const s = STATUS_STYLES[r.status] || STATUS_STYLES.draft;
                  const total = r.question_count ?? 0;
                  const approved = r.approved_count ?? 0;
                  return (
                    <tr key={r.id}
                    onClick={() => navigate(`/admin/dashboard/discovery-responses/${r.id}`)}
                    style={{ borderBottom: '1px solid #eee', cursor: 'pointer', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={td}>{r.title || <span style={{ color: '#aaa' }}>(untitled)</span>}
                        {r.source_file_name &&
                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{r.source_file_name}</div>
                        }
                      </td>
                      <td style={td}>
                        <span style={{
                          fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 3,
                          background: s.bg, color: s.fg, border: `1px solid ${s.border}`,
                          fontFamily: 'Arial, sans-serif', display: 'inline-block', whiteSpace: 'nowrap'
                        }}>{s.label}</span>
                      </td>
                      <td style={{ ...td, textAlign: 'right' }}>{total}</td>
                      <td style={{ ...td, textAlign: 'right', color: total > 0 && approved === total ? '#1a7a5e' : '#555' }}>
                        {approved} / {total}
                      </td>
                      <td style={{ ...td, color: '#555' }}>{fmtDate(r.created_at)}</td>
                    </tr>);

                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>);

  }

  function renderTrustSection() {
    const TYPE_LABEL_MAP = {
      deposit: 'Deposit',
      withdrawal: 'Withdrawal',
      transfer_to_operating: 'Transfer to Operating',
      adjustment: 'Adjustment'
    };
    const typeColors = {
      deposit: { bg: '#e8f7ef', fg: '#1a7a5e', border: '#b8e3cf' },
      withdrawal: { bg: '#fdf0ec', fg: '#B85042', border: '#f5c6c3' },
      transfer_to_operating: { bg: '#fdf2e7', fg: '#d68910', border: '#f5c98e' },
      adjustment: { bg: '#f0f0f0', fg: '#555', border: '#dcdcdc' }
    };

    const balColor = trustBalance > 0 ? '#1a7a5e' : trustBalance < 0 ? '#B85042' : '#888';

    return (
      <>
        <div className="section-head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>Trust Account (IOLTA)</span>
          {!recordingTrust &&
          <button className="btn btn-sm btn-primary" onClick={handleOpenRecordTrust}>+ Record Trust Transaction</button>
          }
        </div>

        {/* Balance card */}
        <div className="card" style={{ padding: 16, marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>
                Current Trust Balance
              </div>
              <div style={{ fontSize: 26, fontFamily: 'Arial, sans-serif', fontWeight: 700, color: balColor }}>
                {fmtMoneyShort(trustBalance)}
              </div>
            </div>
            <div style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#555' }}>
              {trustTransactions.length} transaction{trustTransactions.length === 1 ? '' : 's'} on file
            </div>
          </div>
          {/* pkg173a — money LawPay has authorized but not yet settled is NOT in IOLTA */}
          {(() => {
            const pend = (payments || []).filter(p => p.source === 'lawpay' && p.deposit_account === 'trust' && p.status === 'pending' && !p.is_reversed);
            if (!pend.length) return null;
            const sum = pend.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
            return (
              <div style={{ marginTop: 10, fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#9a4b00', background: '#fff3e0', borderRadius: 4, padding: '6px 10px' }}>
                {fmtMoneyShort(sum)} pending from LawPay ({pend.length} retainer{pend.length === 1 ? '' : 's'}) — appears here once the card processor completes the deposit.
              </div>
            );
          })()}
          {trustBalance < 0 &&
          <div className="alert alert-error" style={{ marginTop: 12, marginBottom: 0, fontSize: 12 }}>
              Negative trust balance — this is an ethics red flag. Investigate and post an adjustment or deposit before any further activity on this matter.
            </div>
          }
        </div>

        {/* Inline record form */}
        {recordingTrust &&
        <div className="card" style={{ padding: 16, marginBottom: 12, background: '#F5F1E8', border: '1px solid #ddd' }}>
            <div style={{ fontSize: 14, fontWeight: 600, fontFamily: 'Arial, sans-serif', marginBottom: 12 }}>
              Record Trust Transaction
            </div>
            <form onSubmit={handleSubmitTrust}>
              <div className="form-row">
                <div className="form-group">
                  <label>Type</label>
                  <select value={trustForm.type}
                onChange={(e) => setTrustForm((p) => ({ ...p, type: e.target.value }))}
                disabled={savingTrust}>
                    <option value="deposit">Deposit (funds in)</option>
                    <option value="withdrawal">Withdrawal (funds out)</option>
                    <option value="transfer_to_operating">Transfer to Operating</option>
                    <option value="adjustment">Adjustment</option>
                  </select>
                </div>
                <div className="form-group" style={{ flex: '0 0 160px' }}>
                  <label>Date</label>
                  <input type="date" value={trustForm.txn_date}
                onChange={(e) => setTrustForm((p) => ({ ...p, txn_date: e.target.value }))}
                disabled={savingTrust} required />
                </div>
                <div className="form-group" style={{ flex: '0 0 180px' }}>
                  <label>Amount {trustForm.type === 'adjustment' ? '(use - for negative)' : '(positive)'}</label>
                  <input type="number" onWheel={(e) => e.currentTarget.blur()} step="0.01" value={trustForm.amount}
                onChange={(e) => setTrustForm((p) => ({ ...p, amount: e.target.value }))}
                placeholder="0.00" disabled={savingTrust} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>{trustForm.type === 'deposit' ? 'Payer / Source' : 'Payee / Recipient'}</label>
                  <input type="text" value={trustForm.payer_payee}
                onChange={(e) => setTrustForm((p) => ({ ...p, payer_payee: e.target.value }))}
                placeholder={trustForm.type === 'deposit' ? 'Who paid the funds in' : 'Who the funds go to'}
                disabled={savingTrust} />
                </div>
                <div className="form-group">
                  <label>Reference / Check #</label>
                  <input type="text" value={trustForm.reference_number}
                onChange={(e) => setTrustForm((p) => ({ ...p, reference_number: e.target.value }))}
                placeholder="Optional" disabled={savingTrust} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Payment Method</label>
                  <select value={trustForm.payment_method}
                onChange={(e) => setTrustForm((p) => ({ ...p, payment_method: e.target.value }))}
                disabled={savingTrust}>
                    <option value="">— Select —</option>
                    <option value="check">Check</option>
                    <option value="ach">ACH / eCheck</option>
                    <option value="wire">Wire</option>
                    <option value="cash">Cash</option>
                    <option value="transfer">Transfer (internal)</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Bank Account Label</label>
                  <input type="text" value={trustForm.bank_account}
                onChange={(e) => setTrustForm((p) => ({ ...p, bank_account: e.target.value }))}
                placeholder="e.g. IOLTA" disabled={savingTrust} />
                </div>
              </div>
              <div className="form-group">
                <label>Description</label>
                <input type="text" value={trustForm.description}
              onChange={(e) => setTrustForm((p) => ({ ...p, description: e.target.value }))}
              placeholder="What this transaction is for"
              disabled={savingTrust} />
              </div>
              <div className="btn-row" style={{ margin: 0 }}>
                <button type="button" className="btn" onClick={handleCancelRecordTrust} disabled={savingTrust}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={savingTrust}>
                  {savingTrust ? 'Saving...' : 'Record Transaction'}
                </button>
              </div>
            </form>
          </div>
        }

        {/* Register table */}
        <div className="card" style={{ padding: trustTransactions.length === 0 ? 16 : 0 }}>
          {trustTransactions.length === 0 ?
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, color: '#888', margin: 0 }}>
              No trust transactions on file for this client.
            </p> :

          <div className="table-wrap">
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
                <thead>
                  <tr style={{ background: '#0F1838', color: '#fff' }}>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 110 }}>Date</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 130 }}>Type</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left' }}>Description</th>
                    <th style={{ padding: '7px 10px', textAlign: 'left', width: 120 }}>Reference</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Amount</th>
                    <th style={{ padding: '7px 10px', textAlign: 'right', width: 110 }}>Balance</th>
                    <th style={{ padding: '7px 10px', textAlign: 'center', width: 60 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {trustTransactions.map((t, i) => {
                  const tc = typeColors[t.type] || typeColors.adjustment;
                  const amt = parseFloat(t.amount) || 0;
                  const amtColor = amt >= 0 ? '#1a7a5e' : '#B85042';
                  const isImported = t.source === 'imported_clio';
                  return (
                    <tr key={t.id} style={{ borderBottom: '1px solid #eee', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                        <td style={{ padding: '7px 10px', whiteSpace: 'nowrap', color: '#555' }}>{fmtIsoDate(t.txn_date)}</td>
                        <td style={{ padding: '7px 10px' }}>
                          <span style={{ fontSize: 11, padding: '2px 7px', borderRadius: 3, background: tc.bg, color: tc.fg, border: `1px solid ${tc.border}` }}>
                            {TYPE_LABEL_MAP[t.type] || t.type}
                          </span>
                          {isImported &&
                        <span style={{ marginLeft: 6, fontSize: 10, padding: '1px 5px', borderRadius: 3, background: '#f0f4f8', color: '#2f5496', border: '1px solid #d2dceb' }} title="Imported from Clio">
                              Clio
                            </span>
                        }
                        </td>
                        <td style={{ padding: '7px 10px', maxWidth: 320 }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {t.description || <span style={{ color: '#aaa' }}>—</span>}
                            {t.payer_payee &&
                          <span style={{ color: '#888', marginLeft: 6, fontSize: 12 }}>
                                ({t.payer_payee})
                              </span>
                          }
                          </div>
                        </td>
                        <td style={{ padding: '7px 10px', color: '#555' }}>{t.reference_number || '—'}</td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600, color: amtColor }}>
                          {amt >= 0 ? '+' : ''}{fmtMoneyShort(amt)}
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'right', fontFamily: 'monospace', color: '#555' }}>
                          {t.running_balance != null ? fmtMoneyShort(t.running_balance) : '—'}
                        </td>
                        <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                          {t.source === 'lawpay' ? <span style={{ fontSize: 10, color: '#888' }} title="Recorded from LawPay settlement; reversals come from LawPay">LawPay</span> :
                          confirmDeleteTrustId === t.id ?
                        <span style={{ display: 'inline-flex', gap: 4 }}>
                              <button onClick={() => handleConfirmDeleteTrust(t.id)}
                          style={{ background: '#B85042', color: '#fff', border: '1px solid #B85042', borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11 }}>
                                Confirm
                              </button>
                              <button onClick={() => setConfirmDeleteTrustId(null)}
                          style={{ background: 'none', border: '1px solid #888', color: '#555', borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11 }}>
                                Cancel
                              </button>
                            </span> :

                        <button onClick={() => setConfirmDeleteTrustId(t.id)}
                        style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '2px 6px', cursor: 'pointer', fontSize: 11 }}
                        title="Delete this transaction">
                              Del
                            </button>
                        }
                        </td>
                      </tr>);

                })}
                </tbody>
              </table>
            </div>
          }
        </div>

        <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#888', marginTop: 8, marginBottom: 24 }}>
          Trust funds are client property held in the firm's IOLTA account. Deleting a transaction recomputes
          all running balances chronologically. Type and amount are immutable on existing rows — to correct an
          error, delete and re-create.
        </p>
      </>);

  }

  function renderReverseModal() {
    const { payment, reason, busy, _err } = reverseModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !busy) setReverseModal(null);}}>
        <div style={modalCardStyle(520)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Reverse Payment</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Reverses {fmtMoneyShort(payment.amount)} {methodLabel(payment.method)} payment from {fmtIsoDate(payment.payment_date)}.
            All allocations are released back to their invoices, increasing those balances. The payment record is preserved for audit.
          </p>
          {_err && <div className="alert alert-error">{_err}</div>}
          <div className="form-group">
            <label>Reason (required)</label>
            <input type="text" value={reason}
            onChange={(e) => setReverseModal((p) => ({ ...p, reason: e.target.value, _err: '' }))}
            placeholder="e.g. NSF / bounced check, recorded in error"
            disabled={busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setReverseModal(null)} disabled={busy}>Cancel</button>
            <button className="btn" onClick={handleSubmitReverse} disabled={busy}
            style={{ background: '#B85042', color: '#fff', borderColor: '#B85042' }}>
              {busy ? 'Reversing...' : 'Reverse Payment'}
            </button>
          </div>
        </div>
      </div>);

  }

  function renderEditPaymentModal() {
    const m = editPaymentModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !m.busy) setEditPaymentModal(null);}}>
        <div style={modalCardStyle(620)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Edit Payment</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Cosmetic fields only. The amount can't be changed here — to correct an amount, reverse this payment and record a new one.
          </p>
          {m._err && <div className="alert alert-error">{m._err}</div>}
          <div className="form-row">
            <div className="form-group" style={{ flex: '0 0 160px' }}>
              <label>Payment Date</label>
              <input type="date" value={m.payment_date}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, payment_date: e.target.value, _err: '' }))}
              disabled={m.busy} />
            </div>
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Method</label>
              <select value={m.method}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, method: e.target.value, _err: '' }))}
              disabled={m.busy}>
                {PAYMENT_METHODS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Deposit Account</label>
              <select value={m.deposit_account}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, deposit_account: e.target.value, _err: '' }))}
              disabled={m.busy}>
                {DEPOSIT_ACCOUNTS.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>{METHOD_REF_LABELS[m.method] || 'Reference'}</label>
              <input type="text" value={m.reference_number}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, reference_number: e.target.value, _err: '' }))}
              disabled={m.busy} />
            </div>
            <div className="form-group">
              <label>Payor</label>
              <input type="text" value={m.payor}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, payor: e.target.value, _err: '' }))}
              disabled={m.busy} />
            </div>
            <div className="form-group" style={{ flex: '0 0 160px' }}>
              <label>Status</label>
              <select value={m.status}
              onChange={(e) => setEditPaymentModal((p) => ({ ...p, status: e.target.value, _err: '' }))}
              disabled={m.busy}>
                <option value="cleared">Cleared</option>
                <option value="pending">Pending</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Memo</label>
            <input type="text" value={m.memo}
            onChange={(e) => setEditPaymentModal((p) => ({ ...p, memo: e.target.value, _err: '' }))}
            disabled={m.busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setEditPaymentModal(null)} disabled={m.busy}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmitEditPayment} disabled={m.busy}>
              {m.busy ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>);

  }

  // ═══════════════════════════════════════════════════════════════════════════
  // WAVE 2 — Soft-void delete + edit modals for payments, refunds, reversals
  // ═══════════════════════════════════════════════════════════════════════════

  function renderDeletePaymentModal() {
    const { payment, void_reason, busy, _err } = deletePaymentModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !busy) setDeletePaymentModal(null);}}>
        <div style={modalCardStyle(520)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Delete Payment</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Voids {fmtMoneyShort(payment.amount)} {methodLabel(payment.method)} payment from {fmtIsoDate(payment.payment_date)}.
            The payment stays in the admin history for the audit trail but no longer counts toward balances and is hidden
            from client-facing invoices and receipts. Any cleared refunds must be voided first.
          </p>
          {_err && <div className="alert alert-error">{_err}</div>}
          <div className="form-group">
            <label>Reason (optional)</label>
            <input type="text" value={void_reason}
              onChange={(e) => setDeletePaymentModal((p) => ({ ...p, void_reason: e.target.value, _err: '' }))}
              placeholder="e.g. Recorded in error, duplicate entry"
              disabled={busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setDeletePaymentModal(null)} disabled={busy}>Cancel</button>
            <button className="btn" onClick={handleSubmitDeletePayment} disabled={busy}
              style={{ background: '#B85042', color: '#fff', borderColor: '#B85042' }}>
              {busy ? 'Voiding...' : 'Delete (Void) Payment'}
            </button>
          </div>
        </div>
      </div>);
  }

  function renderEditRefundModal() {
    const m = editRefundModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !m.busy) setEditRefundModal(null);}}>
        <div style={modalCardStyle(560)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Edit Refund</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Editing refund of {fmtMoneyShort(m.refund.amount)} against {methodLabel(m.payment.method)} payment from {fmtIsoDate(m.payment.payment_date)}.
            Amount cannot be edited — to change the amount, delete this refund and create a new one.
          </p>
          {m._err && <div className="alert alert-error">{m._err}</div>}
          <div className="form-row">
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Refund Date</label>
              <input type="date" value={m.refund_date}
                onChange={(e) => setEditRefundModal((p) => ({ ...p, refund_date: e.target.value, _err: '' }))}
                disabled={m.busy} />
            </div>
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Method</label>
              <select value={m.method}
                onChange={(e) => setEditRefundModal((p) => ({ ...p, method: e.target.value, _err: '' }))}
                disabled={m.busy}>
                <option value="check">Check</option>
                <option value="cash">Cash</option>
                <option value="ach">ACH / eCheck</option>
                <option value="wire">Wire Transfer</option>
                <option value="credit_card">Credit Card</option>
                <option value="money_order">Money Order</option>
                <option value="trust_transfer">Trust Transfer</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Reference Number</label>
            <input type="text" value={m.reference_number}
              onChange={(e) => setEditRefundModal((p) => ({ ...p, reference_number: e.target.value, _err: '' }))}
              placeholder="Check #, confirmation #, etc."
              disabled={m.busy} />
          </div>
          <div className="form-group">
            <label>Reason / Memo</label>
            <input type="text" value={m.reason}
              onChange={(e) => setEditRefundModal((p) => ({ ...p, reason: e.target.value, _err: '' }))}
              placeholder="e.g. Overpayment refund per client request"
              disabled={m.busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setEditRefundModal(null)} disabled={m.busy}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmitEditRefund} disabled={m.busy}>
              {m.busy ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>);
  }

  function renderDeleteRefundModal() {
    const { payment, refund, void_reason, busy, _err } = deleteRefundModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !busy) setDeleteRefundModal(null);}}>
        <div style={modalCardStyle(520)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Delete Refund</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Voids the {fmtMoneyShort(refund.amount)} refund from {fmtIsoDate(refund.refund_date)}.
            The refund stays in the history but no longer counts toward refunded total — its amount goes back
            to the original payment's unapplied credit, ready to apply or refund again.
          </p>
          {_err && <div className="alert alert-error">{_err}</div>}
          <div className="form-group">
            <label>Reason (optional)</label>
            <input type="text" value={void_reason}
              onChange={(e) => setDeleteRefundModal((p) => ({ ...p, void_reason: e.target.value, _err: '' }))}
              placeholder="e.g. Refund check was never cashed, recorded by mistake"
              disabled={busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setDeleteRefundModal(null)} disabled={busy}>Cancel</button>
            <button className="btn" onClick={handleSubmitDeleteRefund} disabled={busy}
              style={{ background: '#B85042', color: '#fff', borderColor: '#B85042' }}>
              {busy ? 'Voiding...' : 'Delete (Void) Refund'}
            </button>
          </div>
        </div>
      </div>);
  }

  function renderEditReversalModal() {
    const m = editReversalModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !m.busy) setEditReversalModal(null);}}>
        <div style={modalCardStyle(560)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Edit Reversal</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Editing the reversal on {methodLabel(m.payment.method)} payment of {fmtMoneyShort(m.payment.amount)} from {fmtIsoDate(m.payment.payment_date)}.
            This is metadata only — the reversal itself stays in effect.
          </p>
          {m._err && <div className="alert alert-error">{m._err}</div>}
          <div className="form-row">
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Reversal Date</label>
              <input type="date" value={m.reversal_date}
                onChange={(e) => setEditReversalModal((p) => ({ ...p, reversal_date: e.target.value, _err: '' }))}
                disabled={m.busy} />
            </div>
            <div className="form-group" style={{ flex: '0 0 180px' }}>
              <label>Method (optional)</label>
              <input type="text" value={m.method}
                onChange={(e) => setEditReversalModal((p) => ({ ...p, method: e.target.value, _err: '' }))}
                placeholder="e.g. ACH return"
                disabled={m.busy} />
            </div>
          </div>
          <div className="form-group">
            <label>Reference Number (optional)</label>
            <input type="text" value={m.reference_number}
              onChange={(e) => setEditReversalModal((p) => ({ ...p, reference_number: e.target.value, _err: '' }))}
              placeholder="Bank's return reference, etc."
              disabled={m.busy} />
          </div>
          <div className="form-group">
            <label>Reason (required)</label>
            <input type="text" value={m.reason}
              onChange={(e) => setEditReversalModal((p) => ({ ...p, reason: e.target.value, _err: '' }))}
              placeholder="e.g. NSF / bounced check"
              disabled={m.busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setEditReversalModal(null)} disabled={m.busy}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmitEditReversal} disabled={m.busy}>
              {m.busy ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>);
  }

  function renderDeleteReversalModal() {
    const { payment, reversal, void_reason, busy, _err } = deleteReversalModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !busy) setDeleteReversalModal(null);}}>
        <div style={modalCardStyle(560)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Delete Reversal</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Voids the reversal from {fmtIsoDate(reversal.reversal_date)} on {methodLabel(payment.method)} payment of {fmtMoneyShort(payment.amount)}.
            If this is the only active reversal on the payment, the payment becomes active again and its allocations
            return to their invoices (those balances will decrease accordingly).
          </p>
          {_err && <div className="alert alert-error">{_err}</div>}
          <div className="form-group">
            <label>Reason (optional)</label>
            <input type="text" value={void_reason}
              onChange={(e) => setDeleteReversalModal((p) => ({ ...p, void_reason: e.target.value, _err: '' }))}
              placeholder="e.g. Check actually cleared after all, reversal recorded in error"
              disabled={busy} />
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setDeleteReversalModal(null)} disabled={busy}>Cancel</button>
            <button className="btn" onClick={handleSubmitDeleteReversal} disabled={busy}
              style={{ background: '#B85042', color: '#fff', borderColor: '#B85042' }}>
              {busy ? 'Voiding...' : 'Delete (Void) Reversal'}
            </button>
          </div>
        </div>
      </div>);
  }

  function renderApplyCreditModal() {
    const m = applyCreditModal;
    const selected = m.candidates.find((c) => c.id === m.invoice_id);
    const selectedBal = selected ? parseFloat(selected.balance_due) || 0 : 0;
    const cap = Math.min(m.payment.unapplied || 0, selectedBal);
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !m.busy) setApplyCreditModal(null);}}>
        <div style={modalCardStyle(540)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>Apply Credit to Invoice</h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            Apply unapplied credit from this {fmtMoneyShort(m.payment.amount)} payment ({fmtMoneyShort(m.payment.unapplied)} available) to one of the client's outstanding invoices.
          </p>
          {m._err && <div className="alert alert-error">{m._err}</div>}
          <div className="form-group">
            <label>Invoice</label>
            <select value={m.invoice_id}
            onChange={(e) => {
              const newId = e.target.value;
              const inv = m.candidates.find((c) => c.id === newId);
              const newBal = inv ? parseFloat(inv.balance_due) || 0 : 0;
              const newCap = Math.min(m.payment.unapplied || 0, newBal);
              setApplyCreditModal((p) => ({ ...p, invoice_id: newId, amount: newCap.toFixed(2), _err: '' }));
            }}
            disabled={m.busy}>
              {m.candidates.map((c) =>
              <option key={c.id} value={c.id}>
                  #{c.invoice_number} — {fmtIsoDate(c.issue_date)} — Balance {fmtMoneyShort(c.balance_due)}
                </option>
              )}
            </select>
          </div>
          <div className="form-group">
            <label>Amount to Apply ($)</label>
            <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0.01" step="0.01" max={cap} value={m.amount}
            onChange={(e) => setApplyCreditModal((p) => ({ ...p, amount: e.target.value, _err: '' }))}
            disabled={m.busy} />
            <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#888', margin: '4px 0 0' }}>
              Capped at the lesser of unapplied credit ({fmtMoneyShort(m.payment.unapplied)}) and invoice balance ({fmtMoneyShort(selectedBal)}).
            </p>
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setApplyCreditModal(null)} disabled={m.busy}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmitApplyCredit} disabled={m.busy}>
              {m.busy ? 'Applying...' : 'Apply Credit'}
            </button>
          </div>
        </div>
      </div>);

  }

  function renderPaymentEmailModal() {
    const m = paymentEmailModal;
    return (
      <div style={modalShellStyle()} onClick={(e) => {if (e.target === e.currentTarget && !m.busy) setPaymentEmailModal(null);}}>
        <div style={modalCardStyle(640)}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 4px' }}>
            Email Receipt — {fmtMoneyShort(m.payment.amount)} {methodLabel(m.payment.method)}
          </h2>
          <p style={{ fontSize: 12, color: '#888', margin: '0 0 16px' }}>
            The Word .docx receipt will be attached. Edit the message before sending.
          </p>
          {m._err && <div className="alert alert-error">{m._err}</div>}
          <div className="form-group">
            <label>To</label>
            <input type="email" value={m.to}
            onChange={(e) => setPaymentEmailModal((p) => ({ ...p, to: e.target.value, _err: '' }))}
            placeholder="recipient@example.com" disabled={m.busy} />
            {client.email && m.to !== client.email &&
            <button type="button"
            onClick={() => setPaymentEmailModal((p) => ({ ...p, to: client.email, _err: '' }))}
            style={{ background: 'none', border: 'none', color: '#2f5496', fontSize: 11, cursor: 'pointer', padding: '4px 0', textDecoration: 'underline' }}>
                Reset to client email ({client.email})
              </button>
            }
          </div>
          <div className="form-group">
            <label>Subject</label>
            <input type="text" value={m.subject}
            onChange={(e) => setPaymentEmailModal((p) => ({ ...p, subject: e.target.value, _err: '' }))}
            disabled={m.busy} />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea rows={10} value={m.body}
            onChange={(e) => setPaymentEmailModal((p) => ({ ...p, body: e.target.value, _err: '' }))}
            disabled={m.busy}
            style={{ fontFamily: 'Georgia, serif', fontSize: 13 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, fontSize: 13 }}>
            <input type="checkbox" id="rcpt-bcc-firm"
            checked={m.sendCopyToFirm}
            onChange={(e) => setPaymentEmailModal((p) => ({ ...p, sendCopyToFirm: e.target.checked, _err: '' }))}
            disabled={m.busy} />
            <label htmlFor="rcpt-bcc-firm" style={{ margin: 0, cursor: 'pointer', fontWeight: 'normal' }}>
              BCC firm contact email
              {firm.client_contact_email && <span style={{ color: '#888' }}> ({firm.client_contact_email})</span>}
            </label>
          </div>
          <div className="btn-row" style={{ margin: 0 }}>
            <button className="btn" onClick={() => setPaymentEmailModal(null)} disabled={m.busy}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmitPaymentEmail} disabled={m.busy}>
              {m.busy ? 'Sending...' : `Send to ${m.to || 'client'}`}
            </button>
          </div>
        </div>
      </div>);

  }
}